import { __decorate, __param, __awaiter } from 'tslib';
import { Input, ViewChild, Component, ContentChildren, ViewContainerRef, Directive, Injector, ComponentFactoryResolver, NgModule, EventEmitter, ContentChild, TemplateRef, Output, ElementRef, Renderer2, HostListener, Pipe, ApplicationRef, ɵɵdefineInjectable, ɵɵinject, INJECTOR, Injectable, ViewChildren, HostBinding, ChangeDetectorRef, forwardRef, Inject, Optional, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import { ENTER, SPACE, UP_ARROW, DOWN_ARROW, ESCAPE, hasModifierKey, TAB } from '@angular/cdk/keycodes';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RouterModule, NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { SkipNavModule, FileSizeModule } from '@cisco/cui-ng/utils';
import { Subject, ReplaySubject, merge, timer, of, Observable, BehaviorSubject, Subscription, combineLatest, fromEvent } from 'rxjs';
import { takeUntil, startWith, map, tap, takeWhile, finalize, take, switchMap, filter, debounceTime, distinctUntilChanged, delay } from 'rxjs/operators';
import { FocusKeyManager, ActiveDescendantKeyManager, FocusMonitor } from '@angular/cdk/a11y';
import { FormControl, NgControl, ReactiveFormsModule, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { SelectionModel, isDataSource } from '@angular/cdk/collections';
import '@angular/localize/init';
import { trigger, transition, style, animate } from '@angular/animations';
import { DataSource, CdkTable, CDK_TABLE_TEMPLATE, CdkCellDef, CdkHeaderCellDef, CdkFooterCellDef, CdkColumnDef, CdkHeaderCell, CdkFooterCell, CdkCell, CdkTextColumn, CdkHeaderRowDef, CdkFooterRowDef, CdkRowDef, CdkHeaderRow, CDK_ROW_TEMPLATE, CdkFooterRow, CdkRow, CdkTableModule } from '@angular/cdk/table';
import { OverlayConfig, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { CdkStepLabel, CdkStep, STEPPER_GLOBAL_OPTIONS, CdkStepper, CdkStepHeader, CdkStepperNext, CdkStepperPrevious } from '@angular/cdk/stepper';

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/accordion</example-url>
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@cisco/cui-ng/utils';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@angular/cdk/scrolling';
import * as ɵngcc6 from '@angular/cdk/table';
import * as ɵngcc7 from '@angular/cdk/overlay';
import * as ɵngcc8 from '@angular/cdk/a11y';

const _c0 = ["drawerTitle"];
const _c1 = ["drawerContent"];
function CngAccordionDrawerComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function CngAccordionDrawerComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1);
} }
const _c2 = [[["", "drawer-title", ""]], [["", "drawer-content", ""]]];
const _c3 = ["[drawer-title]", "[drawer-content]"];
function CngAccordionComponent_li_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngAccordionComponent_li_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 7);
} }
function CngAccordionComponent_li_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c4 = function (a0) { return { "active": a0 }; };
function CngAccordionComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 2)(1, "a", 3);
    ɵngcc0.ɵɵlistener("click", function CngAccordionComponent_li_1_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const drawer_r1 = restoredCtx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.toggle(drawer_r1)); })("keydown", function CngAccordionComponent_li_1_Template_a_keydown_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const drawer_r1 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.onKeydown($event, drawer_r1)); });
    ɵngcc0.ɵɵtemplate(2, CngAccordionComponent_li_1_ng_container_2_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(3, CngAccordionComponent_li_1_span_3_Template, 1, 0, "span", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵtemplate(5, CngAccordionComponent_li_1_ng_container_5_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const drawer_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c4, drawer_r1.active));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", drawer_r1.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showToggle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", drawer_r1.content);
} }
const _c5 = function (a0) { return { "accordion--bordered": a0 }; };
function CngContentComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerText", ctx_r0.config.content);
} }
function CngContentComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.config.content, ɵngcc0.ɵɵsanitizeHtml);
} }
function CngContentComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngContentComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngContentComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.config.content)("ngTemplateOutletContext", ctx_r2.config.context);
} }
function CngContentComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "cng-dcl", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r3.config.content)("setInputFunction", ctx_r3.config.setComponentInputs)("data", ctx_r3.config.componentData);
} }
function CngDclComponent_ng_template_0_Template(rf, ctx) { }
function CngFooterComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelement(1, "a", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", item_r1.link, ɵngcc0.ɵɵsanitizeUrl)("innerText", item_r1.text);
} }
function CngHeaderComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 11);
    ɵngcc0.ɵɵlistener("click", function CngHeaderComponent_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.sidebarToggle.emit()); });
    ɵngcc0.ɵɵelement(1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function CngHeaderComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 13);
    ɵngcc0.ɵɵelement(1, "span", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r1.config.ciscoLogoHREF, ɵngcc0.ɵɵsanitizeUrl);
} }
function CngHeaderComponent_a_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 15);
    ɵngcc0.ɵɵelement(1, "span", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", ctx_r2.config.ciscoLogoRouterLink);
} }
function CngHeaderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 16);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerText", ctx_r3.config.title);
} }
function CngHeaderComponent_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngHeaderComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngHeaderComponent_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.titleTemplate);
} }
function CngHeaderComponent_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c6 = function (a0) { return { items: a0 }; };
function CngHeaderComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtemplate(1, CngHeaderComponent_div_8_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r5.config.centerHeaderPanelClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r7)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c6, ctx_r5.config.centerHeaderPanelItems));
} }
function CngHeaderComponent_div_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngHeaderComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtemplate(1, CngHeaderComponent_div_9_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.config.rightHeaderPanelClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r7)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c6, ctx_r6.config.rightHeaderPanelItems));
} }
function CngHeaderComponent_ng_template_10_ng_container_0_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 24);
    ɵngcc0.ɵɵelement(1, "cng-content", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", item_r16.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", item_r16);
} }
function CngHeaderComponent_ng_template_10_ng_container_0_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 26);
    ɵngcc0.ɵɵelement(1, "cng-content", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", item_r16);
} }
function CngHeaderComponent_ng_template_10_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngHeaderComponent_ng_template_10_ng_container_0_a_1_Template, 2, 2, "a", 22);
    ɵngcc0.ɵɵtemplate(2, CngHeaderComponent_ng_template_10_ng_container_0_a_2_Template, 2, 1, "a", 23);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r16.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r16.routerLink);
} }
function CngHeaderComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CngHeaderComponent_ng_template_10_ng_container_0_Template, 3, 2, "ng-container", 21);
} if (rf & 2) {
    const items_r14 = ctx.items;
    ɵngcc0.ɵɵproperty("ngForOf", items_r14);
} }
const _c7 = [[["", "cngLayoutHeader", ""]], [["", "cngLayoutSidebar", ""]], [["router-outlet"]]];
const _c8 = function (a0) { return { "width": a0 }; };
const _c9 = ["[cngLayoutHeader]", "[cngLayoutSidebar]", "router-outlet"];
const _c10 = function (a0, a1, a2, a3) { return { "icon-info-outline": a0, "icon-warning-outline": a1, "icon-check-outline": a2, "icon-help-outline": a3 }; };
function CngAlertComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(1, _c10, ctx_r0.color === "info", ctx_r0.color === "warning" || ctx_r0.color === "warning-alt", ctx_r0.color === "success", ctx_r0.color === "dark" || ctx_r0.color === "light"));
} }
function CngAlertComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function CngAlertComponent_a_4_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.onClose.emit()); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c11 = ["*"];
function CngAlertOutletComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "cng-alert", 1);
    ɵngcc0.ɵɵlistener("onClose", function CngAlertOutletComponent_ng_container_1_Template_cng_alert_onClose_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const alert_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.onClose(alert_r1)); });
    ɵngcc0.ɵɵelement(2, "cng-content", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const alert_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("color", alert_r1.color)("dismissable", alert_r1.dismissable)("icon", alert_r1.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", alert_r1.content);
} }
function CngTabComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function CngTabsComponent_ng_container_0_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngTabsComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngTabsComponent_ng_container_0_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.preContent.template);
} }
function CngTabsComponent_ng_container_0_ng_container_5_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerText", tab_r8.label);
} }
const _c12 = function (a0, a1, a2) { return { "active": a0, "pull-right": a1, "disabled": a2 }; };
function CngTabsComponent_ng_container_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 9);
    ɵngcc0.ɵɵlistener("click", function CngTabsComponent_ng_container_0_ng_container_5_Template_li_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const i_r9 = restoredCtx.index; const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r12.selectTab(i_r9)); })("keydown", function CngTabsComponent_ng_container_0_ng_container_5_Template_li_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r14.onKeydown($event)); });
    ɵngcc0.ɵɵelementStart(2, "a", 10)(3, "div", 11);
    ɵngcc0.ɵɵtemplate(4, CngTabsComponent_ng_container_0_ng_container_5_ng_container_4_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(5, _c12, i_r9 === ctx_r4.activeTabIndex, tab_r8.pullRight, tab_r8.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("tabindex", i_r9 === 0 ? "0" : "-1")("data-auto-id", tab_r8.autoId ? tab_r8.autoId : tab_r8.label + "Tab");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !tab_r8.labelTemplate)("ngIfElse", tab_r8.labelTemplate);
} }
function CngTabsComponent_ng_container_0_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngTabsComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngTabsComponent_ng_container_0_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.postContent.template);
} }
function CngTabsComponent_ng_container_0_ng_container_8_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngTabsComponent_ng_container_0_ng_container_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, CngTabsComponent_ng_container_0_ng_container_8_div_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r16 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tab_r16.content);
} }
function CngTabsComponent_ng_container_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngTabsComponent_ng_container_0_ng_container_8_div_1_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r17 = ctx.index;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r17 === ctx_r6.activeTabIndex);
} }
const _c13 = function (a0, a1, a2) { return { "text-left": a0, "text-right": a1, "text-center": a2 }; };
const _c14 = function (a0, a1, a2, a3, a4, a5) { return { "tabs--inline": a0, "tabs--bordered": a1, "tabs--embossed": a2, "tabs--centered": a3, "tabs--right": a4, "tabs--justified": a5 }; };
function CngTabsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, CngTabsComponent_ng_container_0_ng_container_2_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4)(4, "ul", 5);
    ɵngcc0.ɵɵtemplate(5, CngTabsComponent_ng_container_0_ng_container_5_Template, 5, 9, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(6, CngTabsComponent_ng_container_0_ng_container_6_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵtemplate(8, CngTabsComponent_ng_container_0_ng_container_8_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.inline && ctx_r0.preContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(6, _c13, ctx_r0.inline && ctx_r0.alignment === "left", ctx_r0.inline && ctx_r0.alignment === "right", ctx_r0.inline && ctx_r0.alignment === "center"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(10, _c14, ctx_r0.inline, ctx_r0.bordered, ctx_r0.embossed, ctx_r0.alignment === "center", ctx_r0.alignment === "right", ctx_r0.alignment === "justified"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.tabs);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.inline && ctx_r0.postContent);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.tabs);
} }
function CngTabsComponent_ng_template_1_ng_container_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r23 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerText", tab_r23.label);
} }
const _c15 = function (a0, a1) { return { "active": a0, "disabled": a1 }; };
function CngTabsComponent_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 9);
    ɵngcc0.ɵɵlistener("click", function CngTabsComponent_ng_template_1_ng_container_3_Template_li_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r28); const i_r24 = restoredCtx.index; const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r27.selectTab(i_r24)); })("keydown", function CngTabsComponent_ng_template_1_ng_container_3_Template_li_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r29.onKeydown($event)); });
    ɵngcc0.ɵɵelementStart(2, "a", 10)(3, "div", 11);
    ɵngcc0.ɵɵtemplate(4, CngTabsComponent_ng_template_1_ng_container_3_ng_container_4_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r23 = ctx.$implicit;
    const i_r24 = ctx.index;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c15, i_r24 === ctx_r21.activeTabIndex, tab_r23.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("tabindex", i_r24 === 0 ? "0" : "-1");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !tab_r23.labelTemplate)("ngIfElse", tab_r23.labelTemplate);
} }
function CngTabsComponent_ng_template_1_ng_container_6_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngTabsComponent_ng_template_1_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, CngTabsComponent_ng_template_1_ng_container_6_div_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r30 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tab_r30.content);
} }
function CngTabsComponent_ng_template_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngTabsComponent_ng_template_1_ng_container_6_div_1_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r31 = ctx.index;
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r31 === ctx_r22.activeTabIndex);
} }
const _c16 = function (a0) { return { "tabs--bordered": a0 }; };
function CngTabsComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "ul", 17);
    ɵngcc0.ɵɵtemplate(3, CngTabsComponent_ng_template_1_ng_container_3_Template, 5, 7, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 18)(5, "div", 7);
    ɵngcc0.ɵɵtemplate(6, CngTabsComponent_ng_template_1_ng_container_6_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c16, ctx_r2.bordered));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.tabs);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.tabs);
} }
function CngTabLinkComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function CngTabsNavComponent_ng_container_0_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngTabsNavComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngTabsNavComponent_ng_container_0_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.preContent.template);
} }
function CngTabsNavComponent_ng_container_0_ng_container_5_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerText", tab_r7.label);
} }
function CngTabsNavComponent_ng_container_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 8);
    ɵngcc0.ɵɵlistener("keydown", function CngTabsNavComponent_ng_container_0_ng_container_5_Template_li_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r12.onKeydown($event)); });
    ɵngcc0.ɵɵelementStart(2, "a", 9, 10)(4, "div", 11);
    ɵngcc0.ɵɵtemplate(5, CngTabsNavComponent_ng_container_0_ng_container_5_ng_container_5_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    const _r9 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(8, _c12, _r9.isActive, tab_r7.pullRight, tab_r7.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", tab_r7.url)("queryParams", tab_r7.urlParams)("routerLinkActiveOptions", tab_r7.routerLinkActiveOptions);
    ɵngcc0.ɵɵattribute("tabindex", i_r8 === 0 ? "0" : "-1")("data-auto-id", tab_r7.autoId ? tab_r7.autoId : tab_r7.label + "Tab");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", tab_r7.label)("ngIfElse", tab_r7.labelTemplate);
} }
function CngTabsNavComponent_ng_container_0_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngTabsNavComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngTabsNavComponent_ng_container_0_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.postContent.template);
} }
function CngTabsNavComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, CngTabsNavComponent_ng_container_0_ng_container_2_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4)(4, "ul", 5);
    ɵngcc0.ɵɵtemplate(5, CngTabsNavComponent_ng_container_0_ng_container_5_Template, 6, 12, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(6, CngTabsNavComponent_ng_container_0_ng_container_6_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.inline && ctx_r0.preContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(5, _c13, ctx_r0.inline && ctx_r0.alignment === "left", ctx_r0.inline && ctx_r0.alignment === "right", ctx_r0.inline && ctx_r0.alignment === "center"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(9, _c14, ctx_r0.inline, ctx_r0.bordered, ctx_r0.embossed, ctx_r0.alignment === "center", ctx_r0.alignment === "right", ctx_r0.alignment === "justified"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.tabs);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.inline && ctx_r0.postContent);
} }
function CngTabsNavComponent_ng_template_1_ng_container_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r16 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerText", tab_r16.label);
} }
function CngTabsNavComponent_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 8);
    ɵngcc0.ɵɵlistener("keydown", function CngTabsNavComponent_ng_template_1_ng_container_3_Template_li_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r21.onKeydown($event)); });
    ɵngcc0.ɵɵelementStart(2, "a", 9, 10)(4, "div", 11);
    ɵngcc0.ɵɵtemplate(5, CngTabsNavComponent_ng_template_1_ng_container_3_ng_container_5_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r16 = ctx.$implicit;
    const i_r17 = ctx.index;
    const _r18 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c15, _r18.isActive, tab_r16.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", tab_r16.url)("queryParams", tab_r16.urlParams)("routerLinkActiveOptions", tab_r16.routerLinkActiveOptions);
    ɵngcc0.ɵɵattribute("tabindex", i_r17 === 0 ? "0" : "-1");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", tab_r16.label)("ngIfElse", tab_r16.labelTemplate);
} }
function CngTabsNavComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "ul", 15);
    ɵngcc0.ɵɵtemplate(3, CngTabsNavComponent_ng_template_1_ng_container_3_Template, 6, 10, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c16, ctx_r2.bordered));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.tabs);
} }
function CngSidebarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelement(1, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerText", ctx_r0.config.title);
} }
function CngSidebarComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c17 = function (a0) { return { item: a0 }; };
function CngSidebarComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngSidebarComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c17, item_r6));
} }
function CngSidebarComponent_ng_template_3_li_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c18 = function (a0, a1, a2, a3) { return { "sidebar__item": a0, "sidebar__drawer": a1, "sidebar__drawer--opened": a2, "sidebar__drawer--selected": a3 }; };
const _c19 = function (a0, a1) { return { item: a0, parent: a1 }; };
function CngSidebarComponent_ng_template_3_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 10);
    ɵngcc0.ɵɵtemplate(1, CngSidebarComponent_ng_template_3_li_0_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const item_r8 = ctx_r13.item;
    const parent_r9 = ctx_r13.parent;
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(3, _c18, item_r8.type === "item", item_r8.type === "drawer", item_r8.opened, item_r8.active && item_r8.type === "drawer"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(8, _c19, item_r8, parent_r9));
} }
function CngSidebarComponent_ng_template_3_li_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c20 = function () { return ["sidebar__item--selected"]; };
const _c21 = function () { return { exact: true }; };
function CngSidebarComponent_ng_template_3_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵtemplate(1, CngSidebarComponent_ng_template_3_li_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    const item_r8 = ctx_r15.item;
    const parent_r9 = ctx_r15.parent;
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(6, _c18, item_r8.type === "item", item_r8.type === "drawer", item_r8.opened, item_r8.active && item_r8.type === "drawer"))("routerLink", item_r8.routerLink ? item_r8.routerLink : null)("routerLinkActive", ɵngcc0.ɵɵpureFunction0(11, _c20))("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction0(12, _c21));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(13, _c19, item_r8, parent_r9));
} }
function CngSidebarComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CngSidebarComponent_ng_template_3_li_0_Template, 2, 11, "li", 8);
    ɵngcc0.ɵɵtemplate(1, CngSidebarComponent_ng_template_3_li_1_Template, 2, 16, "li", 9);
} if (rf & 2) {
    const item_r8 = ctx.item;
    ɵngcc0.ɵɵproperty("ngIf", !item_r8.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r8.routerLink);
} }
function CngSidebarComponent_ng_template_5_ul_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngSidebarComponent_ng_template_5_ul_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngSidebarComponent_ng_template_5_ul_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subItem_r20 = ctx.$implicit;
    const item_r16 = ɵngcc0.ɵɵnextContext(2).item;
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c19, subItem_r20, item_r16));
} }
function CngSidebarComponent_ng_template_5_ul_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 15);
    ɵngcc0.ɵɵtemplate(1, CngSidebarComponent_ng_template_5_ul_2_ng_container_1_Template, 2, 5, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r16.items);
} }
function CngSidebarComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 12);
    ɵngcc0.ɵɵlistener("click", function CngSidebarComponent_ng_template_5_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r25); const item_r16 = restoredCtx.item; const parent_r17 = restoredCtx.parent; const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r24.onSidebarItemClick(item_r16, parent_r17)); })("keydown", function CngSidebarComponent_ng_template_5_Template_a_keydown_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r25); const item_r16 = restoredCtx.item; const parent_r17 = restoredCtx.parent; const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r26.onSidebarItemKeydown($event, item_r16, parent_r17)); });
    ɵngcc0.ɵɵelement(1, "cng-content", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, CngSidebarComponent_ng_template_5_ul_2_Template, 2, 1, "ul", 14);
} if (rf & 2) {
    const item_r16 = ctx.item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", item_r16.data);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r16.type === "drawer");
} }
const _c22 = ["wrapper"];
function CngLabelComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c23 = ["searchInput"];
function CngSelectComponent_label_4_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} }
function CngSelectComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 8);
    ɵngcc0.ɵɵtemplate(1, CngSelectComponent_label_4_span_1_Template, 1, 0, "span", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.label.content);
} }
function CngSelectComponent_ng_container_8_div_1_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c24 = function (a0) { return { "item": a0 }; };
function CngSelectComponent_ng_container_8_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngSelectComponent_ng_container_8_div_1_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(3);
    const _r4 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c24, item_r11));
} }
function CngSelectComponent_ng_container_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 11)(2, "div", 12);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, CngSelectComponent_ng_container_8_div_1_ng_container_4_Template, 2, 4, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const group_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", group_r8.groupName, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r8.filteredItems);
} }
function CngSelectComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngSelectComponent_ng_container_8_div_1_Template, 5, 2, "div", 10);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkVirtualForOf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r2.filteredGroups$));
} }
function CngSelectComponent_ng_container_9_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngSelectComponent_ng_container_9_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CngSelectComponent_ng_container_9_div_1_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r4 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c24, item_r14));
} }
function CngSelectComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngSelectComponent_ng_container_9_div_1_Template, 2, 4, "div", 10);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkVirtualForOf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r3.filteredItems$));
} }
const _c25 = function (a0, a1) { return { "selected": a0, "hover": a1 }; };
function CngSelectComponent_ng_template_10_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 15);
    ɵngcc0.ɵɵlistener("click", function CngSelectComponent_ng_template_10_ng_container_0_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); const item_r17 = ɵngcc0.ɵɵnextContext().item; const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r20.onClick(item_r17)); });
    ɵngcc0.ɵɵelement(2, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r17 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c25, item_r17.selected, item_r17.active));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", item_r17.wrappedElem.nativeElement.innerHTML, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c26 = function (a0) { return { "hover": a0 }; };
function CngSelectComponent_ng_template_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 15);
    ɵngcc0.ɵɵlistener("click", function CngSelectComponent_ng_template_10_ng_container_1_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r26); const item_r17 = ɵngcc0.ɵɵnextContext().item; const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r24.onClick(item_r17)); });
    ɵngcc0.ɵɵelementStart(2, "div", 17)(3, "label", 18);
    ɵngcc0.ɵɵlistener("click", function CngSelectComponent_ng_template_10_ng_container_1_Template_label_click_3_listener($event) { return $event.preventDefault(); });
    ɵngcc0.ɵɵelement(4, "input", 19)(5, "span", 20)(6, "span", 21);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r17 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c26, item_r17.active));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("checked", item_r17.selected);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", item_r17.wrappedElem.nativeElement.innerHTML, ɵngcc0.ɵɵsanitizeHtml);
} }
function CngSelectComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CngSelectComponent_ng_template_10_ng_container_0_Template, 3, 5, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(1, CngSelectComponent_ng_template_10_ng_container_1_Template, 7, 5, "ng-container", 6);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.multi);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.multi);
} }
const _c27 = function (a0, a1) { return { "active": a0, "form-group--error": a1 }; };
const _c28 = function (a0) { return { "height": a0 }; };
function CngPagerComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13)(1, "span", 14);
    ɵngcc0.ɵɵi18n(2, 15);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵi18nExp(ctx_r0.pageLimit)(ctx_r0.max)(ctx_r0.totalItems);
    ɵngcc0.ɵɵi18nApply(2);
} }
const _c31 = function (a0) { return { "disabled": a0 }; };
function CngPagerComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li")(1, "a", 16);
    ɵngcc0.ɵɵlistener("click", function CngPagerComponent_li_5_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r10.onClick(0, ctx_r10.page === 0)); });
    ɵngcc0.ɵɵelement(2, "span", 17);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c31, ctx_r1.page === 0));
    ɵngcc0.ɵɵattribute("tabindex", ctx_r1.page === 0 ? "-1" : "0");
} }
function CngPagerComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 18);
} }
function CngPagerComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵi18n(1, 19);
    ɵngcc0.ɵɵelementEnd();
} }
function CngPagerComponent_li_11_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 23);
} }
function CngPagerComponent_li_11_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 24);
    ɵngcc0.ɵɵlistener("click", function CngPagerComponent_li_11_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const p_r12 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.onClick(p_r12)); });
    ɵngcc0.ɵɵelement(1, "span", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵattributeInterpolate1("data-auto-id", "CNGPager-Page", p_r12 + 1, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerText", p_r12 + 1);
} }
function CngPagerComponent_li_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 20);
    ɵngcc0.ɵɵelementContainerStart(1, 5);
    ɵngcc0.ɵɵtemplate(2, CngPagerComponent_li_11_span_2_Template, 1, 0, "span", 21);
    ɵngcc0.ɵɵtemplate(3, CngPagerComponent_li_11_a_3_Template, 2, 2, "a", 22);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r12 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c4, p_r12 === ctx_r4.page));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", p_r12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "ellipses");
} }
function CngPagerComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 26);
} }
function CngPagerComponent_span_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵi18n(1, 27);
    ɵngcc0.ɵɵelementEnd();
} }
function CngPagerComponent_li_17_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li")(1, "a", 28);
    ɵngcc0.ɵɵlistener("click", function CngPagerComponent_li_17_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r20.onClick(ctx_r20.lastPage, ctx_r20.page === ctx_r20.lastPage)); });
    ɵngcc0.ɵɵelement(2, "span", 29);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c31, ctx_r7.page === ctx_r7.lastPage));
    ɵngcc0.ɵɵattribute("tabindex", ctx_r7.page === ctx_r7.lastPage ? "-1" : "0");
} }
function CngPagerComponent_span_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 30);
    ɵngcc0.ɵɵi18n(1, 31);
    ɵngcc0.ɵɵelementEnd();
} }
function CngPagerComponent_cng_select_19_cng_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "cng-option", 34);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r23 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", item_r23.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r23.name, " ");
} }
function CngPagerComponent_cng_select_19_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cng-select", 32);
    ɵngcc0.ɵɵlistener("ngModelChange", function CngPagerComponent_cng_select_19_Template_cng_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r24.onLimitChange($event)); });
    ɵngcc0.ɵɵtemplate(1, CngPagerComponent_cng_select_19_cng_option_1_Template, 2, 2, "cng-option", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.limit);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.limits);
} }
const _c38 = function (a0, a1, a2) { return { "pagination--large": a0, "pagination--small": a1, "pagination--rounded": a2 }; };
function CngLoaderComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngLoaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5);
    ɵngcc0.ɵɵtemplate(3, CngLoaderComponent_div_0_ng_container_3_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function CngLoaderComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngLoaderComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngLoaderComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function CngLoaderComponent_ng_template_2_div_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngLoaderComponent_ng_template_2_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CngLoaderComponent_ng_template_2_div_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.label.content);
} }
function CngLoaderComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, CngLoaderComponent_ng_template_2_div_0_div_1_Template, 2, 1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 9)(3, "div", 10);
    ɵngcc0.ɵɵelement(4, "div", 11);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("qtr-margin-top loader loader--", ctx_r6.size, "");
} }
function CngLoaderComponent_ng_template_2_div_1_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngLoaderComponent_ng_template_2_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CngLoaderComponent_ng_template_2_div_1_div_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r10.label.content);
} }
function CngLoaderComponent_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, CngLoaderComponent_ng_template_2_div_1_div_1_Template, 2, 1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵelement(3, "span")(4, "span")(5, "span");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("qtr-margin-top loading-dots loading-dots--", ctx_r7.color, "");
} }
function CngLoaderComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CngLoaderComponent_ng_template_2_div_0_Template, 5, 4, "div", 7);
    ɵngcc0.ɵɵtemplate(1, CngLoaderComponent_ng_template_2_div_1_Template, 6, 4, "div", 7);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.dots);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.dots);
} }
function CngProgressbarComponent_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵi18nStart(0, 3, 1);
    ɵngcc0.ɵɵelementContainer(1);
    ɵngcc0.ɵɵpipe(2, "percent");
    ɵngcc0.ɵɵi18nEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵi18nExp(ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r1.value, "1.0-0"));
    ɵngcc0.ɵɵi18nApply(0);
} }
function CngProgressbarComponent_div_3_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵi18nStart(0, 3, 3);
    ɵngcc0.ɵɵelementContainer(1);
    ɵngcc0.ɵɵi18nEnd();
} }
function CngProgressbarComponent_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵi18nStart(0, 3, 2);
    ɵngcc0.ɵɵelementContainerStart(1);
    ɵngcc0.ɵɵtemplate(2, CngProgressbarComponent_div_3_ng_container_3_ng_container_2_Template, 2, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵi18nEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.customLabel.content);
} }
function CngProgressbarComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵi18nStart(1, 3);
    ɵngcc0.ɵɵtemplate(2, CngProgressbarComponent_div_3_ng_container_2_Template, 3, 4, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(3, CngProgressbarComponent_div_3_ng_container_3_Template, 3, 1, "ng-container", 4);
    ɵngcc0.ɵɵi18nEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.customLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.customLabel);
} }
const _c45 = function (a0, a1, a2) { return { "icon-star-half": a0, "icon-star": a1, "icon-star-empty": a2 }; };
function CngRatingComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵlistener("click", function CngRatingComponent_ng_container_2_Template_div_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const star_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.onRatingChange(star_r1)); })("keydown", function CngRatingComponent_ng_container_2_Template_div_keydown_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const star_r1 = restoredCtx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.onKeydown($event, star_r1)); });
    ɵngcc0.ɵɵpipe(2, "isActive");
    ɵngcc0.ɵɵpipe(3, "getTitle");
    ɵngcc0.ɵɵelement(4, "span", 4);
    ɵngcc0.ɵɵpipe(5, "isHalf");
    ɵngcc0.ɵɵpipe(6, "isHalf");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const star_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c4, ɵngcc0.ɵɵpipeBind4(2, 4, star_r1, ctx_r0.rating, ctx_r0.showHalf, ctx_r0.halfThreshold)))("title", ɵngcc0.ɵɵpipeBind1(3, 9, star_r1));
    ɵngcc0.ɵɵattribute("data-auto-id", "CNGRating-Star-" + star_r1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(21, _c45, ɵngcc0.ɵɵpipeBind3(5, 11, ctx_r0.showHalf && star_r1, ctx_r0.rating, ctx_r0.halfThreshold), (!ctx_r0.showHalf || !ɵngcc0.ɵɵpipeBind3(6, 15, star_r1, ctx_r0.rating, ctx_r0.halfThreshold)) && ctx_r0.starStyle === "filled", ctx_r0.starStyle === "empty"));
} }
const _c46 = function (a0, a1, a2) { return { "rating--alt": a0, "rating--small": a1, "rating--large": a2 }; };
const _c47 = function (a0) { return { "inactive": a0 }; };
function CngToastIconComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function CngToastComponent_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngToastComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, CngToastComponent_ng_container_1_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.customIcon.content);
} }
function CngToastComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngToastComponent_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.customIcon)("ngIfElse", _r2);
} }
function CngToastComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function CngToastComponent_a_7_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.onClose()); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c48 = function (a0, a1, a2, a3) { return { "icon-error-outline": a0, "icon-warning-outline": a1, "icon-check-outline": a2, "icon-info-outline": a3 }; };
function CngToastComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("toast__icon text-", ctx_r3.opts.severity, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(4, _c48, ctx_r3.opts.severity === "danger", ctx_r3.opts.severity === "warning", ctx_r3.opts.severity === "success", ctx_r3.opts.severity === "info"));
} }
const _c49 = [[["", "toast-title", ""]], [["", "toast-body", ""]]];
const _c50 = ["[toast-title]", "[toast-body]"];
function CngToasterComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1)(1, "cng-toast", 2);
    ɵngcc0.ɵɵlistener("close", function CngToasterComponent_div_1_Template_cng_toast_close_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const toast_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.onClose(toast_r1)); });
    ɵngcc0.ɵɵelementStart(2, "span", 3);
    ɵngcc0.ɵɵelement(3, "cng-content", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵelement(5, "cng-content", 4);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const toast_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("@toastAnimation", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("opts", toast_r1.options);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("config", toast_r1.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("config", toast_r1.body);
} }
function CngDropdownItemComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function CngDropdownGroupComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c51 = ["triggerContainer"];
function CngDropdownWrapperComponent_ng_template_1_Template(rf, ctx) { }
function CngDropdownWrapperComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c52 = function (a0, a1, a2) { return { "active": a0, "dropdown--center": a1, "dropdown--left": a2 }; };
const _c53 = ["dropdown"];
function CngDropdownComponent_ng_template_0_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c54 = function (a0, a1) { return { "selected": a0, "focused": a1 }; };
const _c55 = function (a0) { return { "height.px": a0 }; };
function CngDropdownComponent_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵlistener("click", function CngDropdownComponent_ng_template_0_ng_container_0_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const item_r4 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r6.onItemClick(item_r4)); });
    ɵngcc0.ɵɵtemplate(2, CngDropdownComponent_ng_template_0_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c54, item_r4.selected, item_r4.active))("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c55, item_r4.overrideHeight));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r4.template);
} }
function CngDropdownComponent_ng_template_0_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const group_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerText", group_r8.header);
} }
function CngDropdownComponent_ng_template_0_ng_container_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngDropdownComponent_ng_template_0_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵlistener("click", function CngDropdownComponent_ng_template_0_ng_container_1_ng_container_2_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const item_r14 = restoredCtx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r16.onItemClick(item_r14)); });
    ɵngcc0.ɵɵtemplate(2, CngDropdownComponent_ng_template_0_ng_container_1_ng_container_2_ng_container_2_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c54, item_r14.selected, item_r14.active))("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c55, item_r14.overrideHeight));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r14.template);
} }
function CngDropdownComponent_ng_template_0_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 7);
} }
function CngDropdownComponent_ng_template_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngDropdownComponent_ng_template_0_ng_container_1_div_1_Template, 1, 1, "div", 4);
    ɵngcc0.ɵɵtemplate(2, CngDropdownComponent_ng_template_0_ng_container_1_ng_container_2_Template, 3, 8, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(3, CngDropdownComponent_ng_template_0_ng_container_1_div_3_Template, 1, 0, "div", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const group_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", group_r8.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r8.items);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r9 < (ctx_r3.groups == null ? null : ctx_r3.groups.length) - 1);
} }
function CngDropdownComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CngDropdownComponent_ng_template_0_ng_container_0_Template, 3, 8, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(1, CngDropdownComponent_ng_template_0_ng_container_1_Template, 4, 3, "ng-container", 1);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.items);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.groups);
} }
function CngFormFieldComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵelement(1, "span");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.icon);
} }
const _c56 = [[["", "cngInput", ""]], [["label"]], [["", "cngInputHint", ""]]];
const _c57 = ["[cngInput]", "label", "[cngInputHint]"];
function CngGridItemComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function CngGridComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c58 = function (a0) { return { "min-height.px": a0 }; };
const _c59 = function (a0, a1) { return { "panel panel--bordered panel--raised panel--loose": a0, "selected": a1 }; };
function CngGridComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, CngGridComponent_div_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c58, ctx_r0.minHeight))("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c59, item_r2.card, ctx_r0.isSelected(item_r2.value)))("cngClickItem", item_r2.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r2.content);
} }
function CngGridComponent_ng_container_2_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngGridComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, CngGridComponent_ng_container_2_div_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c58, ctx_r4.minHeight))("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c59, ctx_r4.dataCards, ctx_r4.isSelected(item_r5)))("cngClickItem", item_r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.dataTemplate)("ngTemplateOutletContext", item_r5);
} }
function CngGridComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngGridComponent_ng_container_2_div_1_Template, 2, 10, "div", 1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r1.dataItems$));
} }
const _c60 = function (a0) { return { "grid--selectable": a0 }; };
const _c61 = function (a0) { return { "grid-template-rows": a0 }; };
const _c62 = [[["caption"]], [["colgroup"], ["col"]]];
const _c63 = ["caption", "colgroup, col"];
function CngTableColumn_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("text-align", ctx_r0.justify);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.headerText, " ");
} }
function CngTableColumn_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("text-align", ctx_r1.justify);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.dataAccessor(data_r2, ctx_r1.name), " ");
} }
function CngSelectColumnComponent_th_1_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 5)(1, "input", 6);
    ɵngcc0.ɵɵlistener("change", function CngSelectColumnComponent_th_1_label_1_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r3.masterToggle()); })("keydown", function CngSelectColumnComponent_th_1_label_1_Template_input_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r5.handleKeydown($event, "header")); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(2, "span", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", ctx_r2.isAllSelected());
} }
function CngSelectColumnComponent_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 3);
    ɵngcc0.ɵɵtemplate(1, CngSelectColumnComponent_th_1_label_1_Template, 3, 1, "label", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isMultiple);
} }
function CngSelectColumnComponent_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 8)(1, "label", 9);
    ɵngcc0.ɵɵlistener("click", function CngSelectColumnComponent_td_2_Template_label_click_1_listener($event) { return $event.preventDefault(); })("mousedown", function CngSelectColumnComponent_td_2_Template_label_mousedown_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r10); const element_r6 = restoredCtx.$implicit; const i_r7 = restoredCtx.index; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.toggleOne(element_r6, i_r7, $event)); })("keydown", function CngSelectColumnComponent_td_2_Template_label_keydown_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r10); const element_r6 = restoredCtx.$implicit; const i_r7 = restoredCtx.index; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.handleKeydown($event, "row", element_r6, i_r7)); });
    ɵngcc0.ɵɵelement(2, "input", 10)(3, "span", 7);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const element_r6 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", ctx_r1.selection.isSelected(element_r6));
} }
const _c64 = ["cng-sort-header", ""];
const _c65 = function (a0) { return { "desc": a0 }; };
function CngSortHeaderComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c65, (ctx_r0.rootSort == null ? null : ctx_r0.rootSort.direction) === "desc"));
} }
function CngBreadcrumbsComponent_li_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "cng-content", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", crumb_r1.content);
} }
function CngBreadcrumbsComponent_li_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵelement(1, "cng-content", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", crumb_r1.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", crumb_r1.content);
} }
function CngBreadcrumbsComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtemplate(1, CngBreadcrumbsComponent_li_2_span_1_Template, 2, 1, "span", 2);
    ɵngcc0.ɵɵtemplate(2, CngBreadcrumbsComponent_li_2_ng_template_2_Template, 2, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r1 = ctx.$implicit;
    const _r3 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentItem === crumb_r1 || crumb_r1.url === null)("ngIfElse", _r3);
} }
const _c66 = [[["cng-auto-option"], ["", 8, "divider"]]];
const _c67 = ["cng-auto-option, .divider"];
const _c68 = function (a0) { return { hover: a0 }; };
const _c69 = ["panel"];
const _c70 = function (a0) { return { hidden: a0 }; };
function CngAutocompleteComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1, 2);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c70, ctx_r0.hidden));
} }
const _c71 = function (a0, a1) { return { "max-height": a0, "max-width": a1 }; };
function CngTooltipComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("tooltip-container tooltip-", ctx_r0.position, "");
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(4, _c71, ctx_r0.maxHeight, ctx_r0.maxWidth));
} }
const _c72 = ["fileInput"];
function CngDropzoneComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngDropzoneComponent_ng_template_6_ng_template_2_Template(rf, ctx) { }
function CngDropzoneComponent_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "div")(3, "span");
    ɵngcc0.ɵɵi18n(4, 14);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(5, "div", 15);
    ɵngcc0.ɵɵprojection(6);
    ɵngcc0.ɵɵelementStart(7, "span");
    ɵngcc0.ɵɵi18n(8, 16);
    ɵngcc0.ɵɵpipe(9, "fileSize");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵi18nExp(ctx_r9.files.length);
    ɵngcc0.ɵɵi18nApply(4);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵi18nExp(ɵngcc0.ɵɵpipeBind1(9, 2, ctx_r9.totalSize));
    ɵngcc0.ɵɵi18nApply(8);
} }
const _c77 = function (a0) { return { files: a0 }; };
function CngDropzoneComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    ɵngcc0.ɵɵtemplate(2, CngDropzoneComponent_ng_template_6_ng_template_2_Template, 0, 0, "ng-template", 10);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(3, CngDropzoneComponent_ng_template_6_div_3_Template, 10, 4, "div", 11);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c77, ctx_r3.files));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.multi);
} }
function CngDropzoneComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelement(1, "span", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵprojection(3, 1);
    ɵngcc0.ɵɵelementEnd();
} }
function CngDropzoneComponent_ng_template_10_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 26);
    ɵngcc0.ɵɵlistener("click", function CngDropzoneComponent_ng_template_10_div_0_span_2_Template_span_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const file_r12 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r15.removeFile($event, file_r12)); })("keydown", function CngDropzoneComponent_ng_template_10_div_0_span_2_Template_span_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const file_r12 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r18.removeFile($event, file_r12)); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c78 = function (a0, a1) { return { "flex-fill": a0, "col-lg-3 col-md-6 col-sm-6 half-margin-bottom": a1 }; };
function CngDropzoneComponent_ng_template_10_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    ɵngcc0.ɵɵtemplate(2, CngDropzoneComponent_ng_template_10_div_0_span_2_Template, 1, 0, "span", 22);
    ɵngcc0.ɵɵelement(3, "span", 23)(4, "div", 24)(5, "small", 25);
    ɵngcc0.ɵɵpipe(6, "fileSize");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const file_r12 = ctx.$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(9, _c78, !ctx_r11.multi, ctx_r11.multi));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", file_r12.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.multi);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r11.getIcon(file_r12))("title", ctx_r11.getTitle(file_r12));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", file_r12.name, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(6, 7, file_r12.size), ɵngcc0.ɵɵsanitizeHtml);
} }
function CngDropzoneComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CngDropzoneComponent_ng_template_10_div_0_Template, 7, 12, "div", 19);
} if (rf & 2) {
    const files_r10 = ctx.files;
    ɵngcc0.ɵɵproperty("ngForOf", files_r10);
} }
const _c79 = [[["", "total-text", ""]], [["", "drop-text", ""]]];
const _c80 = ["[total-text]", "[drop-text]"];
function CngStep_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function CngStepHeaderComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function CngStepHeaderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("click", function CngStepHeaderComponent_div_1_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.onClick($event)); });
    ɵngcc0.ɵɵtemplate(1, CngStepHeaderComponent_div_1_ng_container_1_Template, 2, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showNumber);
} }
function CngStepHeaderComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.index + 1);
} }
function CngStepHeaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("click", function CngStepHeaderComponent_div_2_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.onClick($event)); });
    ɵngcc0.ɵɵtemplate(1, CngStepHeaderComponent_div_2_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showNumber);
} }
function CngStepHeaderComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CngStepHeaderComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CngStepHeaderComponent_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.templateLabel.template);
} }
function CngStepHeaderComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.label);
} }
function CngHorizontalStepper_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "cng-step-header", 3);
    ɵngcc0.ɵɵlistener("keydown", function CngHorizontalStepper_ng_container_1_Template_cng_step_header_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5._onKeydown($event)); })("headerClicked", function CngHorizontalStepper_ng_container_1_Template_cng_step_header_headerClicked_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const step_r2 = restoredCtx.$implicit; return ɵngcc0.ɵɵresetView(step_r2.select()); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const step_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tabIndex", ctx_r0._getFocusIndex() === i_r3 ? 0 : -1)("id", ctx_r0._getStepLabelId(i_r3))("index", i_r3)("state", ctx_r0._getIndicatorType(i_r3, step_r2.state))("label", step_r2.stepLabel || step_r2.label)("selected", ctx_r0.selectedIndex === i_r3)("active", ctx_r0.selectedIndex === i_r3)("completed", step_r2.completed)("optional", step_r2.optional)("errorMessage", step_r2.errorMessage)("showNumber", ctx_r0.size !== "dot");
    ɵngcc0.ɵɵattribute("aria-posinset", i_r3 + 1)("aria-setsize", ctx_r0.steps.length)("aria-controls", ctx_r0._getStepContentId(i_r3))("aria-selected", ctx_r0.selectedIndex === i_r3)("aria-label", step_r2.ariaLabel || null)("aria-labelledby", !step_r2.ariaLabel && step_r2.ariaLabelledby ? step_r2.ariaLabelledby : null);
} }
function CngHorizontalStepper_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementContainer(1, 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r1._getStepContentId(i_r9));
    ɵngcc0.ɵɵattribute("tabindex", ctx_r1.selectedIndex === i_r9 ? 0 : null)("aria-labelledby", ctx_r1._getStepLabelId(i_r9))("aria-expanded", ctx_r1.selectedIndex === i_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", step_r8.content);
} }
let CngAccordionDrawerComponent = class CngAccordionDrawerComponent {
    constructor() {
        this.active = false;
    }
    ngOnInit() {
    }
};
CngAccordionDrawerComponent.ɵfac = function CngAccordionDrawerComponent_Factory(t) { return new (t || CngAccordionDrawerComponent)(); };
CngAccordionDrawerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngAccordionDrawerComponent, selectors: [["cng-accordion-drawer"]], viewQuery: function CngAccordionDrawerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.title = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, inputs: { active: "active" }, ngContentSelectors: _c3, decls: 4, vars: 0, consts: [["drawerTitle", ""], ["drawerContent", ""]], template: function CngAccordionDrawerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵtemplate(0, CngAccordionDrawerComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, CngAccordionDrawerComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } } });
__decorate([
    Input()
], CngAccordionDrawerComponent.prototype, "active", void 0);
__decorate([
    ViewChild('drawerTitle', { static: true })
], CngAccordionDrawerComponent.prototype, "title", void 0);
__decorate([
    ViewChild('drawerContent', { static: true })
], CngAccordionDrawerComponent.prototype, "content", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/accordion</example-url>
 */
let CngAccordionComponent = class CngAccordionComponent {
    constructor() {
        this.showToggle = true;
    }
    set bordered(value) {
        this._bordered = coerceBooleanProperty(value);
    }
    get bordered() { return this._bordered; }
    set singular(value) {
        this._singular = coerceBooleanProperty(value);
    }
    get singular() { return this._singular; }
    ngOnInit() {
    }
    /**
     * Toggles a single accordion
     * @param item - CngAccordionItem
     */
    toggle(item) {
        if (this.singular && !item.active) {
            // enforce one accordion opened at a time
            this.drawers.forEach(i => {
                i.active = false;
            });
        }
        item.active = !item.active;
    }
    onKeydown(event, item) {
        if (event.keyCode === ENTER) {
            this.toggle(item);
        }
    }
};
CngAccordionComponent.ɵfac = function CngAccordionComponent_Factory(t) { return new (t || CngAccordionComponent)(); };
CngAccordionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngAccordionComponent, selectors: [["cng-accordion"]], contentQueries: function CngAccordionComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngAccordionDrawerComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.drawers = _t);
    } }, inputs: { showToggle: "showToggle", bordered: "bordered", singular: "singular" }, decls: 2, vars: 4, consts: [[1, "accordion", 3, "ngClass"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], ["tabindex", "0", 1, "accordion__title", 3, "click", "keydown"], [4, "ngTemplateOutlet"], ["class", "accordion__toggle icon-chevron-down", 4, "ngIf"], [1, "accordion__content"], [1, "accordion__toggle", "icon-chevron-down"]], template: function CngAccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, CngAccordionComponent_li_1_Template, 6, 6, "li", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c5, ctx.bordered));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.drawers);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: ["a.accordion__title[_ngcontent-%COMP%]:focus{color:var(--cui-color-info)!important}"] });
__decorate([
    ContentChildren(CngAccordionDrawerComponent)
], CngAccordionComponent.prototype, "drawers", void 0);
__decorate([
    Input()
], CngAccordionComponent.prototype, "bordered", null);
__decorate([
    Input()
], CngAccordionComponent.prototype, "showToggle", void 0);
__decorate([
    Input()
], CngAccordionComponent.prototype, "singular", null);

var CngContentConfigType;
(function (CngContentConfigType) {
    CngContentConfigType["HTML"] = "html";
    CngContentConfigType["TEMPLATE"] = "template";
    CngContentConfigType["COMPONENT"] = "component";
    CngContentConfigType["TEXT"] = "text";
})(CngContentConfigType || (CngContentConfigType = {}));
let CngContentComponent = class CngContentComponent {
    constructor() { }
    ngOnInit() {
    }
};
CngContentComponent.ɵfac = function CngContentComponent_Factory(t) { return new (t || CngContentComponent)(); };
CngContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngContentComponent, selectors: [["cng-content"]], inputs: { config: "config" }, decls: 5, vars: 5, consts: [[3, "ngSwitch"], [4, "ngSwitchCase"], [3, "innerText"], [3, "innerHTML"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "component", "setInputFunction", "data"]], template: function CngContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, CngContentComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, CngContentComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(3, CngContentComponent_ng_container_3_Template, 2, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(4, CngContentComponent_ng_container_4_Template, 2, 3, "ng-container", 1);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.config.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "text");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "html");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "template");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "component");
    } }, dependencies: function () { return [CngDclComponent, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase]; } });
__decorate([
    Input()
], CngContentComponent.prototype, "config", void 0);

let CngDclHostDirective = class CngDclHostDirective {
    constructor(vcr) {
        this.vcr = vcr;
    }
};
CngDclHostDirective.ɵfac = function CngDclHostDirective_Factory(t) { return new (t || CngDclHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
CngDclHostDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngDclHostDirective, selectors: [["", "cngDCLHost", ""]] });
CngDclHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];

const CNG_DATA = 'CNG_DATA';
let CngDclComponent = class CngDclComponent {
    constructor(_cfr, _injector) {
        this._cfr = _cfr;
        this._injector = _injector;
    }
    ngOnInit() {
        this.loadComponent();
    }
    loadComponent() {
        const componentFactory = this._cfr.resolveComponentFactory(this.component);
        const hostVCR = this.host.vcr;
        const injector = Injector.create({
            providers: [{
                    provide: CNG_DATA,
                    useValue: this.data,
                }],
            parent: this._injector,
        });
        hostVCR.clear();
        const componentRef = hostVCR.createComponent(componentFactory, undefined, injector);
        if (this.setInputFunction) {
            this.setInputFunction(componentRef);
        }
    }
};
CngDclComponent.ɵfac = function CngDclComponent_Factory(t) { return new (t || CngDclComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
CngDclComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngDclComponent, selectors: [["cng-dcl"]], viewQuery: function CngDclComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CngDclHostDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.host = _t.first);
    } }, inputs: { component: "component", setInputFunction: "setInputFunction", data: "data" }, decls: 1, vars: 0, consts: [["cngDCLHost", ""]], template: function CngDclComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CngDclComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, dependencies: [CngDclHostDirective] });
CngDclComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: Injector }
];
__decorate([
    Input()
], CngDclComponent.prototype, "component", void 0);
__decorate([
    Input()
], CngDclComponent.prototype, "setInputFunction", void 0);
__decorate([
    Input()
], CngDclComponent.prototype, "data", void 0);
__decorate([
    ViewChild(CngDclHostDirective, { static: true })
], CngDclComponent.prototype, "host", void 0);

let CngDclModule = class CngDclModule {
};
CngDclModule.ɵfac = function CngDclModule_Factory(t) { return new (t || CngDclModule)(); };
CngDclModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngDclModule });
CngDclModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let CngContentModule = class CngContentModule {
};
CngContentModule.ɵfac = function CngContentModule_Factory(t) { return new (t || CngContentModule)(); };
CngContentModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngContentModule });
CngContentModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CngDclModule,
        CommonModule] });

let CngAccordionModule = class CngAccordionModule {
};
CngAccordionModule.ɵfac = function CngAccordionModule_Factory(t) { return new (t || CngAccordionModule)(); };
CngAccordionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngAccordionModule });
CngAccordionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CngContentModule,
        CommonModule] });

/**
 * Default configuration for the CngFooter component. Exposed so that others may extend
 * off of it.
 */
const CngFooterDefaultConfig = {
    items: [
        {
            link: 'http://www.cisco.com/cisco/web/siteassets/contacts/index.html',
            text: 'Contacts',
        },
        {
            link: 'https://secure.opinionlab.com/ccc01/o.asp?id=jBjOhqOJ',
            text: 'Feedback',
        },
        {
            link: 'https://www.cisco.com/c/en/us/about/help.html',
            text: 'Help',
        },
        {
            link: 'http://www.cisco.com/c/en/us/about/sitemap.html',
            text: 'Site Map',
        },
        {
            link: 'https://www.cisco.com/c/en/us/about/legal/terms-conditions.html',
            text: 'Terms & Conditions',
        },
        {
            link: 'https://www.cisco.com/c/en/us/about/legal/privacy-full.html',
            text: 'Privacy Statement',
        },
        {
            link: 'https://www.cisco.com/c/en/us/about/legal/privacy-full.html#cookies',
            text: 'Cookie Policy',
        },
        {
            link: 'https://www.cisco.com/c/en/us/about/legal/trademarks.html',
            text: 'Tradmarks',
        },
    ],
};
/**
 * CngFooter component for displaying legally required links at the bottom of applications.
 * <example-url>/pages/cx-ppd/cui-ng/examples/footer</example-url>
 */
let CngFooterComponent = class CngFooterComponent {
    constructor() { }
    /**
     * Initializes the component and assigns defaults to the
     * configuration as necessary.
     */
    ngOnInit() {
        // Assign defaults as necessary.
        this.config = Object.assign({}, CngFooterDefaultConfig, this.config);
    }
};
CngFooterComponent.ɵfac = function CngFooterComponent_Factory(t) { return new (t || CngFooterComponent)(); };
CngFooterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngFooterComponent, selectors: [["cng-footer"]], inputs: { config: "config" }, decls: 4, vars: 1, consts: [[1, "footer"], [1, "footer__links"], [1, "list", "list--inline"], [4, "ngFor", "ngForOf"], ["target", "_blank", "rel", "noopener noreferrer", 3, "href", "innerText"]], template: function CngFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "footer", 0)(1, "div", 1)(2, "ul", 2);
        ɵngcc0.ɵɵtemplate(3, CngFooterComponent_li_3_Template, 2, 2, "li", 3);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config.items);
    } }, dependencies: [ɵngcc1.NgForOf], encapsulation: 2 });
__decorate([
    Input()
], CngFooterComponent.prototype, "config", void 0);

let CngFooterModule = class CngFooterModule {
};
CngFooterModule.ɵfac = function CngFooterModule_Factory(t) { return new (t || CngFooterModule)(); };
CngFooterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngFooterModule });
CngFooterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let CngTitleDirective = class CngTitleDirective {
    constructor() { }
};
CngTitleDirective.ɵfac = function CngTitleDirective_Factory(t) { return new (t || CngTitleDirective)(); };
CngTitleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngTitleDirective, selectors: [["", "cngTitle", ""]] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/header</example-url>
 */
let CngHeaderComponent = class CngHeaderComponent {
    constructor() {
        this.sidebarToggle = new EventEmitter();
    }
    ngOnInit() {
        this.config = Object.assign({}, 
        // default values
        {
            centerHeaderPanelClasses: '',
            centerHeaderPanelItems: [],
            ciscoLogoHREF: 'https://www.cisco.com',
            ciscoLogoRouterLink: '',
            rightHeaderPanelClasses: '',
            rightHeaderPanelItems: [],
            showCiscoLogo: true,
            showSearch: false,
            showSidebarToggle: false,
            title: '',
        }, 
        // input values
        this.config);
    }
};
CngHeaderComponent.ɵfac = function CngHeaderComponent_Factory(t) { return new (t || CngHeaderComponent)(); };
CngHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngHeaderComponent, selectors: [["cng-header"]], contentQueries: function CngHeaderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTitleDirective, 5, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.titleTemplate = _t.first);
    } }, hostAttrs: [1, "header"], inputs: { config: "config" }, outputs: { sidebarToggle: "sidebarToggle" }, decls: 12, vars: 7, consts: [[1, "container"], [1, "header-panels"], [1, "header-panel"], ["class", "header-item half-margin-left dbl-margin-right", 3, "click", 4, "ngIf"], ["class", "header__logo", "target", "_blank", 3, "href", 4, "ngIf"], ["class", "header__logo", 3, "routerLink", 4, "ngIf"], ["class", "header__title", 3, "innerText", 4, "ngIf"], [4, "ngIf"], ["class", "header-panel header-panel--center", 3, "ngClass", 4, "ngIf"], ["class", "header-panel header-panel--right", 3, "ngClass", 4, "ngIf"], ["headerItem", ""], [1, "header-item", "half-margin-left", "dbl-margin-right", 3, "click"], [1, "icon-list-menu"], ["target", "_blank", 1, "header__logo", 3, "href"], [1, "icon-cisco"], [1, "header__logo", 3, "routerLink"], [1, "header__title", 3, "innerText"], [4, "ngTemplateOutlet"], [1, "header-panel", "header-panel--center", 3, "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "header-panel", "header-panel--right", 3, "ngClass"], [4, "ngFor", "ngForOf"], ["class", "header-item", 3, "routerLink", 4, "ngIf"], ["class", "header-item", 4, "ngIf"], [1, "header-item", 3, "routerLink"], [3, "config"], [1, "header-item"]], template: function CngHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, CngHeaderComponent_a_3_Template, 2, 0, "a", 3);
        ɵngcc0.ɵɵtemplate(4, CngHeaderComponent_a_4_Template, 2, 1, "a", 4);
        ɵngcc0.ɵɵtemplate(5, CngHeaderComponent_a_5_Template, 2, 1, "a", 5);
        ɵngcc0.ɵɵtemplate(6, CngHeaderComponent_div_6_Template, 1, 1, "div", 6);
        ɵngcc0.ɵɵtemplate(7, CngHeaderComponent_ng_container_7_Template, 2, 1, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, CngHeaderComponent_div_8_Template, 2, 5, "div", 8);
        ɵngcc0.ɵɵtemplate(9, CngHeaderComponent_div_9_Template, 2, 5, "div", 9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(10, CngHeaderComponent_ng_template_10_Template, 1, 1, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.showSidebarToggle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.showCiscoLogo && !ctx.config.ciscoLogoRouterLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.showCiscoLogo && ctx.config.ciscoLogoRouterLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.titleTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.centerHeaderPanelItems == null ? null : ctx.config.centerHeaderPanelItems.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.rightHeaderPanelItems == null ? null : ctx.config.rightHeaderPanelItems.length);
    } }, dependencies: [CngContentComponent, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.RouterLinkWithHref] });
__decorate([
    Input()
], CngHeaderComponent.prototype, "config", void 0);
__decorate([
    ContentChild(CngTitleDirective, { read: TemplateRef })
], CngHeaderComponent.prototype, "titleTemplate", void 0);
__decorate([
    Output()
], CngHeaderComponent.prototype, "sidebarToggle", void 0);

let CngHeaderModule = class CngHeaderModule {
};
CngHeaderModule.ɵfac = function CngHeaderModule_Factory(t) { return new (t || CngHeaderModule)(); };
CngHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngHeaderModule });
CngHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CngContentModule,
        CommonModule,
        RouterModule] });

/**
 * Directive used for content projection and element reference of the Header element
 */
let CngLayoutHeader = class CngLayoutHeader {
    constructor(element) {
        this.element = element;
    }
};
CngLayoutHeader.ɵfac = function CngLayoutHeader_Factory(t) { return new (t || CngLayoutHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngLayoutHeader.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngLayoutHeader, selectors: [["", "cngLayoutHeader", ""]] });
CngLayoutHeader.ctorParameters = () => [
    { type: ElementRef }
];
/**
 * Directive used for content projection and element reference of the Sidebar element
 */
let CngLayoutSidebar = class CngLayoutSidebar {
    constructor(element) {
        this.element = element;
    }
};
CngLayoutSidebar.ɵfac = function CngLayoutSidebar_Factory(t) { return new (t || CngLayoutSidebar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngLayoutSidebar.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngLayoutSidebar, selectors: [["", "cngLayoutSidebar", ""]] });
CngLayoutSidebar.ctorParameters = () => [
    { type: ElementRef }
];
/**
 * Max width of an 'xs' screen. (Breakpoint for hiding the sidebar)
 */
const UI_KIT_SM_WIDTH = 576;
let CngLayoutComponent = class CngLayoutComponent {
    constructor(renderer) {
        this.renderer = renderer;
        this.destroyed$ = new Subject();
        /** Whether or not the sidebar is currently displayed */
        this.sidebarVisible = true;
        /** The sidebars current position (range from -100 to 0) */
        this.sidebarXTranslation = 0;
        /** On small devices, the sidebar should overlap the main content */
        this.lockContentWidth = false;
    }
    /**
     * @param event - Event
     * When window is resized, check the window width
     */
    onResize(event) {
        this.detectView(event.target);
    }
    /**
     * Getter for the sidebar's current X position
     * (Used to calculate the main content width)
     */
    get sidebarXPosition() {
        if (this.sidebarElem) {
            return this.sidebarElem.element.nativeElement.getBoundingClientRect().x;
        }
    }
    /**
     * Getter for the sidebar's width
     * (Used to calculate the main content width)
     */
    get sidebarWidth() {
        if (this.sidebarElem) {
            return this.sidebarElem.element.nativeElement.getBoundingClientRect().width;
        }
    }
    /**
     * Getter for the header's height
     * (Used to calculate the main content height)
     */
    get headerHeight() {
        if (this.headerElem) {
            return this.headerElem.element.nativeElement.getBoundingClientRect().height;
        }
    }
    /**
     * @param win - Window
     * Checks the window innerWidth and shows/hides the sidebar accordingly
     */
    detectView(win) {
        const windowWidth = win.innerWidth;
        if (windowWidth < UI_KIT_SM_WIDTH && this.sidebarVisible) {
            this.animateSidebar('hide');
            this.sidebarVisible = false;
            this.lockContentWidth = true;
        }
        else if (windowWidth >= UI_KIT_SM_WIDTH && !this.sidebarVisible) {
            this.animateSidebar('show');
            this.sidebarVisible = true;
            this.lockContentWidth = false;
        }
    }
    /**
     * Shows/hides the sidebar manually (from user input)
     */
    toggleView() {
        if (this.sidebarVisible) {
            this.animateSidebar('hide');
            this.sidebarVisible = false;
        }
        else {
            this.animateSidebar('show');
            this.sidebarVisible = true;
        }
    }
    /**
     * @param task - 'show' | 'hide'
     * Animates showing/hiding the sidebar. Tranlates the sidebar to the left off of
     * the screen when task is 'hide'. Returns sidebar to initial location when task is 'show'.
     */
    animateSidebar(task) {
        function step() {
            if (task === 'hide') {
                this.sidebarXTranslation -= 20;
            }
            else {
                this.sidebarXTranslation += 20;
            }
            if (this.sidebarElem) {
                this.renderer.setStyle(this.sidebarElem.element.nativeElement, 'transform', `translateX(${this.sidebarXTranslation}%)`);
            }
            if ((task === 'hide' && this.sidebarXTranslation > -100)
                || (task === 'show' && this.sidebarXTranslation < 0)) {
                window.requestAnimationFrame(step.bind(this));
            }
        }
        window.requestAnimationFrame(step.bind(this));
    }
    ngAfterContentInit() {
        this.detectView(window);
        // if header (CngHeaderComponent) is present, subscribe to sidebar toggle events
        if (this.header) {
            this.header.sidebarToggle
                .pipe(takeUntil(this.destroyed$))
                .subscribe(() => {
                this.toggleView();
            });
        }
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    /**
     * On small screens, clicking the main content section should hide the sidebar.
     * This function enforces the logic.
     */
    handleContentClick() {
        if (this.lockContentWidth && this.sidebarVisible) {
            this.toggleView();
        }
    }
};
CngLayoutComponent.ɵfac = function CngLayoutComponent_Factory(t) { return new (t || CngLayoutComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
CngLayoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngLayoutComponent, selectors: [["cng-layout"]], contentQueries: function CngLayoutComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngLayoutSidebar, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngLayoutHeader, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngHeaderComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sidebarElem = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerElem = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.header = _t.first);
    } }, hostBindings: function CngLayoutComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function CngLayoutComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, ngContentSelectors: _c9, decls: 11, vars: 7, consts: [["mainId", "main"], [1, "content"], [1, "container-fluid"], [1, "row"], ["role", "main", "id", "main", "tabindex", "-1", 1, "base-padding", 3, "ngStyle", "click"], ["main", ""]], template: function CngLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "skip-nav", 0);
        ɵngcc0.ɵɵtext(1, "Skip to Main Content");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "div", 1)(4, "div", 2)(5, "div", 3);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementStart(7, "div", 4, 5);
        ɵngcc0.ɵɵlistener("click", function CngLayoutComponent_Template_div_click_7_listener() { return ctx.handleContentClick(); });
        ɵngcc0.ɵɵpipe(9, "contentWidth");
        ɵngcc0.ɵɵprojection(10, 2);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c8, ɵngcc0.ɵɵpipeBind3(9, 1, ctx.sidebarXPosition, ctx.sidebarWidth, ctx.lockContentWidth)));
    } }, dependencies: function () { return [ɵngcc1.NgStyle, ɵngcc3.SkipNavComponent, CngLayoutContentWidthPipe]; }, styles: ["#main[_ngcontent-%COMP%]:focus{outline:0}"] });
CngLayoutComponent.ctorParameters = () => [
    { type: Renderer2 }
];
__decorate([
    ContentChild(CngLayoutSidebar, { static: false })
], CngLayoutComponent.prototype, "sidebarElem", void 0);
__decorate([
    ContentChild(CngLayoutHeader, { static: false })
], CngLayoutComponent.prototype, "headerElem", void 0);
__decorate([
    ContentChild(CngHeaderComponent, { static: false })
], CngLayoutComponent.prototype, "header", void 0);
__decorate([
    HostListener('window:resize', ['$event'])
], CngLayoutComponent.prototype, "onResize", null);

/**
 * Computes the css width property value for the router-outlet section of the layout
 * given the sidebar width and location on the screen.
 *
 * (Since sidebar is translated off to the left of the screen, the sidebar x position
 * is subtracted from the sidebar width to get the number of pixels in the sidebar that are
 * currently visible on the screen. This number is then subtracted from the total view width.)
 */
let CngLayoutContentWidthPipe = class CngLayoutContentWidthPipe {
    transform(x, width, lock) {
        if (lock) {
            return '100vw';
        }
        const sidebarVisibleWidth = width - (-1 * x);
        return `calc(100vw - ${sidebarVisibleWidth + 20}px)`;
    }
};
CngLayoutContentWidthPipe.ɵfac = function CngLayoutContentWidthPipe_Factory(t) { return new (t || CngLayoutContentWidthPipe)(); };
CngLayoutContentWidthPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "contentWidth", type: CngLayoutContentWidthPipe, pure: true });

let CngLayoutModule = class CngLayoutModule {
};
CngLayoutModule.ɵfac = function CngLayoutModule_Factory(t) { return new (t || CngLayoutModule)(); };
CngLayoutModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngLayoutModule });
CngLayoutModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        SkipNavModule] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/modal</example-url>
 */
let CngModalComponent = class CngModalComponent {
    constructor() {
        this.close = new EventEmitter();
    }
    ngOnInit() {
    }
    /**
     * Emits a close event when the top-right X button is clicked
     */
    handleClose() {
        this.close.emit();
    }
};
CngModalComponent.ɵfac = function CngModalComponent_Factory(t) { return new (t || CngModalComponent)(); };
CngModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngModalComponent, selectors: [["cng-modal"]], inputs: { content: "content", size: "size" }, outputs: { close: "close" }, decls: 6, vars: 2, consts: [[1, "modal", 3, "ngClass"], [1, "modal__dialog"], [1, "modal__content"], [1, "modal__close", 3, "click"], [1, "icon-close"], [3, "config"]], template: function CngModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "a", 3);
        ɵngcc0.ɵɵlistener("click", function CngModalComponent_Template_a_click_3_listener() { return ctx.handleClose(); });
        ɵngcc0.ɵɵelement(4, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "cng-content", 5);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.size);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("config", ctx.content);
    } }, dependencies: [CngContentComponent, ɵngcc1.NgClass] });
__decorate([
    Input()
], CngModalComponent.prototype, "content", void 0);
__decorate([
    Input()
], CngModalComponent.prototype, "size", void 0);
__decorate([
    Output()
], CngModalComponent.prototype, "close", void 0);

var CngModalSize;
(function (CngModalSize) {
    CngModalSize["SMALL"] = "modal--small";
    CngModalSize["DEFAULT"] = "";
    CngModalSize["LARGE"] = "modal--large";
    CngModalSize["FULL"] = "modal--full";
    CngModalSize["FLUID"] = "modal--fluid";
})(CngModalSize || (CngModalSize = {}));

const modalOptionsDefaults = {
    injectTarget: 'body',
    size: CngModalSize.DEFAULT,
};
/**
 * Service for dynamically displaying modal content anywhere in an app
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/modal</example-url>
 */
let CngModalService = class CngModalService {
    constructor(appRef, componentFactoryResolver, injector) {
        this.appRef = appRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        /** Maintain a stack of Modals */
        this.modalRefs = [];
    }
    /**
     * Appends a CngModalComponent to the provided injectTarget (<body> by default)
     * @param options - CngModalOptions
     * @returns CngModalRef
     */
    open(options) {
        const opts = Object.assign({}, modalOptionsDefaults, options);
        const currentIdx = this.modalRefs.length;
        const modalRef = {
            componentRef: this.componentFactoryResolver
                .resolveComponentFactory(CngModalComponent)
                .create(this.injector),
            onDismiss: new Subject(),
        };
        // 1. Create a component reference from the component
        this.modalRefs.push(modalRef);
        const componentRef = this.modalRefs[currentIdx].componentRef;
        componentRef.instance.content = opts.content;
        componentRef.instance.size = opts.size;
        const closeSub = componentRef.instance.close
            .subscribe(() => {
            closeSub.unsubscribe();
            this.close();
        });
        // 2. Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(componentRef.hostView);
        // 3. Get DOM element from component
        const domElem = componentRef.hostView
            .rootNodes[0];
        // 4. Append DOM element to the supplied injectTarget
        document.querySelector(opts.injectTarget).appendChild(domElem);
        return modalRef;
    }
    /**
     * Closes the modal at the top of the stack
     * @param data - any
     */
    close(data) {
        if (this.modalRefs.length) {
            const topModalRef = this.modalRefs.pop();
            this.appRef.detachView(topModalRef.componentRef.hostView);
            topModalRef.componentRef.destroy();
            topModalRef.onDismiss.next(data);
            topModalRef.onDismiss.complete();
        }
    }
    /**
     * Closes all of the modals
     * @param data - any
     */
    closeAll(data) {
        const length = this.modalRefs.length;
        for (let i = 0; i < length; i += 1) {
            this.close(data);
        }
    }
};
CngModalService.ɵfac = function CngModalService_Factory(t) { return new (t || CngModalService)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
CngModalService.ctorParameters = () => [
    { type: ApplicationRef },
    { type: ComponentFactoryResolver },
    { type: Injector }
];
CngModalService.ɵprov = ɵɵdefineInjectable({ factory: function CngModalService_Factory() { return new CngModalService(ɵɵinject(ApplicationRef), ɵɵinject(ComponentFactoryResolver), ɵɵinject(INJECTOR)); }, token: CngModalService, providedIn: "root" });

var CngModalModule_1;
let CngModalModule = CngModalModule_1 = class CngModalModule {
    static forRoot() {
        return {
            ngModule: CngModalModule_1,
            providers: [
                CngModalService,
            ],
        };
    }
};
CngModalModule.ɵfac = function CngModalModule_Factory(t) { return new (t || CngModalModule)(); };
CngModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngModalModule });
CngModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CngContentModule,
        CommonModule] });

var CngAlertColor;
(function (CngAlertColor) {
    CngAlertColor["INFO"] = "info";
    CngAlertColor["SUCCESS"] = "success";
    CngAlertColor["WARNING"] = "warning";
    CngAlertColor["WARNING_ALT"] = "warning-alt";
    CngAlertColor["DARK"] = "dark";
    CngAlertColor["LIGHT"] = "light";
})(CngAlertColor || (CngAlertColor = {}));
/**
 * A simple component for displaying alerts with the correct colors/icons/style
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/alert</example-url>
 */
let CngAlertComponent = class CngAlertComponent {
    constructor() {
        /** Show an "x" to dismiss the alert */
        this.dismissable = false;
        /** Whether to show an icon in the alert */
        this.icon = false;
        /** Fired event when close button is clicked */
        this.onClose = new EventEmitter();
    }
    ngOnInit() {
    }
};
CngAlertComponent.ɵfac = function CngAlertComponent_Factory(t) { return new (t || CngAlertComponent)(); };
CngAlertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngAlertComponent, selectors: [["cng-alert"]], inputs: { dismissable: "dismissable", icon: "icon", color: "color" }, outputs: { onClose: "onClose" }, ngContentSelectors: _c11, decls: 5, vars: 5, consts: [[4, "ngIf"], [1, "alert__message", "flex-fluid"], ["href", "javascript:;", "class", "alert__close icon-close", 3, "click", 4, "ngIf"], [1, "alert__icon", 3, "ngClass"], ["href", "javascript:;", 1, "alert__close", "icon-close", 3, "click"]], template: function CngAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, CngAlertComponent_ng_container_1_Template, 2, 6, "ng-container", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, CngAlertComponent_a_4_Template, 1, 0, "a", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("alert alert--", ctx.color, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dismissable);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf] });
__decorate([
    Input()
], CngAlertComponent.prototype, "dismissable", void 0);
__decorate([
    Input()
], CngAlertComponent.prototype, "color", void 0);
__decorate([
    Input()
], CngAlertComponent.prototype, "icon", void 0);
__decorate([
    Output()
], CngAlertComponent.prototype, "onClose", void 0);

let CngAlertModule = class CngAlertModule {
};
CngAlertModule.ɵfac = function CngAlertModule_Factory(t) { return new (t || CngAlertModule)(); };
CngAlertModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngAlertModule });
CngAlertModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let CngAlertService = class CngAlertService {
    constructor() {
        this._nextAlert$ = new Subject();
        this._clearAlerts$ = new Subject();
    }
    get nextAlert$() {
        return this._nextAlert$.asObservable();
    }
    get clearAlerts$() {
        return this._clearAlerts$.asObservable();
    }
    postAlert(item) {
        this._nextAlert$.next(item);
    }
    clearAlerts() {
        this._clearAlerts$.next();
    }
};
CngAlertService.ɵfac = function CngAlertService_Factory(t) { return new (t || CngAlertService)(); };
CngAlertService.ɵprov = ɵɵdefineInjectable({ factory: function CngAlertService_Factory() { return new CngAlertService(); }, token: CngAlertService, providedIn: "root" });

/**
 * An outlet for dynamically dispaying/hiding alerts on the page
 * To push/clear alerts to the outlet, use the CngAlertService
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/alert-outlet</example-url>
 */
let CngAlertOutletComponent = class CngAlertOutletComponent {
    constructor(alertService) {
        this.destroy$ = new Subject();
        this.items = [];
        alertService.nextAlert$.pipe(takeUntil(this.destroy$))
            .subscribe(alert => {
            this.items.push(alert);
        });
        alertService.clearAlerts$.pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this.items = [];
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    onClose(alert) {
        const idx = this.items.indexOf(alert);
        if (idx !== -1) {
            this.items.splice(idx, 1);
        }
    }
};
CngAlertOutletComponent.ɵfac = function CngAlertOutletComponent_Factory(t) { return new (t || CngAlertOutletComponent)(ɵngcc0.ɵɵdirectiveInject(CngAlertService)); };
CngAlertOutletComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngAlertOutletComponent, selectors: [["cng-alert-outlet"]], decls: 2, vars: 1, consts: [[4, "ngFor", "ngForOf"], [3, "color", "dismissable", "icon", "onClose"], [3, "config"]], template: function CngAlertOutletComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, CngAlertOutletComponent_ng_container_1_Template, 3, 4, "ng-container", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [ɵngcc1.NgForOf, CngAlertComponent, CngContentComponent] });
CngAlertOutletComponent.ctorParameters = () => [
    { type: CngAlertService }
];

let CngAlertOutletModule = class CngAlertOutletModule {
};
CngAlertOutletModule.ɵfac = function CngAlertOutletModule_Factory(t) { return new (t || CngAlertOutletModule)(); };
CngAlertOutletModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngAlertOutletModule });
CngAlertOutletModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        CngAlertService,
    ], imports: [CommonModule,
        CngAlertModule,
        CngContentModule] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/tabs</example-url>
 */
let CngTabContentDirective = class CngTabContentDirective {
    constructor() { }
};
CngTabContentDirective.ɵfac = function CngTabContentDirective_Factory(t) { return new (t || CngTabContentDirective)(); };
CngTabContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngTabContentDirective, selectors: [["", "cngTabContent", ""]] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/tabs</example-url>
 */
let CngTabLabelDirective = class CngTabLabelDirective {
    constructor() { }
};
CngTabLabelDirective.ɵfac = function CngTabLabelDirective_Factory(t) { return new (t || CngTabLabelDirective)(); };
CngTabLabelDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngTabLabelDirective, selectors: [["", "cngTabLabel", ""]] });

/**
 * Represents a single tab. Contains a text label
 * and uses content projection to accept tab content
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/tabs</example-url>
 */
let CngTabComponent = 
/**
 * Component for a loader element
 */
class CngTabComponent {
    constructor() {
        /**
         * If you need to pull a single tab to the right, set pullRight to true on that tab
         */
        this.pullRight = false;
        /**
         * Set 'disabled' css class on tab
         */
        this.disabled = false;
    }
    /**
     * Getter for _content
     */
    get content() {
        return this._content;
    }
    /**
     * Getter for label template
     */
    get labelTemplate() {
        return this._labelTemplate;
    }
    ngOnInit() {
        this._content = this._explicitContent || this._implicitContent;
    }
};
CngTabComponent.ɵfac = function CngTabComponent_Factory(t) { return new (t || CngTabComponent)(); };
CngTabComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngTabComponent, selectors: [["cng-tab"]], contentQueries: function CngTabComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTabLabelDirective, 5, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTabContentDirective, 5, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._labelTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._explicitContent = _t.first);
    } }, viewQuery: function CngTabComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._implicitContent = _t.first);
    } }, inputs: { pullRight: "pullRight", disabled: "disabled", autoId: "autoId", label: "label" }, ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngTabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngTabComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
__decorate([
    Input()
], CngTabComponent.prototype, "autoId", void 0);
__decorate([
    Input()
], CngTabComponent.prototype, "label", void 0);
__decorate([
    ContentChild(CngTabLabelDirective, { read: TemplateRef })
], CngTabComponent.prototype, "_labelTemplate", void 0);
__decorate([
    Input()
], CngTabComponent.prototype, "pullRight", void 0);
__decorate([
    Input()
], CngTabComponent.prototype, "disabled", void 0);
__decorate([
    ViewChild(TemplateRef, { static: true })
], CngTabComponent.prototype, "_implicitContent", void 0);
__decorate([
    ContentChild(CngTabContentDirective, { read: TemplateRef })
], CngTabComponent.prototype, "_explicitContent", void 0);

/**
 * Simple directive to fetch template decorated with cuiTabPre and expose it
 * This content will be placed before the tabs if they are inline.
 */
let CngTabPreDirective = class CngTabPreDirective {
    constructor(template) {
        this.template = template;
    }
};
CngTabPreDirective.ɵfac = function CngTabPreDirective_Factory(t) { return new (t || CngTabPreDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
CngTabPreDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngTabPreDirective, selectors: [["", "cngTabPre", ""]] });
CngTabPreDirective.ctorParameters = () => [
    { type: TemplateRef }
];

/**
 * Simple directive to fetch template decorated with cuiTabPost and expose it
 * This content will be placed after the tabs if they are inline.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/tabs</example-url>
 */
let CngTabPostDirective = class CngTabPostDirective {
    constructor(template) {
        this.template = template;
    }
};
CngTabPostDirective.ɵfac = function CngTabPostDirective_Factory(t) { return new (t || CngTabPostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
CngTabPostDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngTabPostDirective, selectors: [["", "cngTabPost", ""]] });
CngTabPostDirective.ctorParameters = () => [
    { type: TemplateRef }
];

// Directive to apply to actual anchor element inside cng-tab header
// Contains a focus() method for the cdk keymanager
/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/tabs</example-url>
 */
let CngTabAnchorDirective = class CngTabAnchorDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    focus() {
        this.elementRef.nativeElement.focus();
    }
};
CngTabAnchorDirective.ɵfac = function CngTabAnchorDirective_Factory(t) { return new (t || CngTabAnchorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngTabAnchorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngTabAnchorDirective, selectors: [["", "cngTabAnchor", ""]] });
CngTabAnchorDirective.ctorParameters = () => [
    { type: ElementRef }
];

let CngTabsComponent = 
/**
 * Component for a tabs element. Will project tabs placed inside
 * and respond to user clicks or binding to determine the active tab
 * Options are available for eager and lazy loading.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/tabs</example-url>
 */
class CngTabsComponent {
    constructor() {
        this._inline = false;
        this._bordered = false;
        this._embossed = false;
        this._vertical = false;
        /**
         * Alignment of the tabs
         */
        this.alignment = 'left';
        /**
         * Optionally bind a value to control the tab index programatically
         */
        this.activeTabIndex = 0;
        /**
         * Outputs the current index for 2-way binding
         */
        this.activeTabIndexChange = new EventEmitter();
    }
    get inline() {
        return this._inline;
    }
    get bordered() {
        return this._bordered;
    }
    get embossed() {
        return this._embossed;
    }
    get vertical() {
        return this._vertical;
    }
    /**
     * Apply inline styling to tab labels. Defaults to false (block)
     */
    set inline(inline) {
        this._inline = coerceBooleanProperty(inline);
    }
    /**
     * Whether the tabs are bordered or not. Defaults to false
     */
    set bordered(bordered) {
        this._bordered = coerceBooleanProperty(bordered);
    }
    /**
     * Whether the tabs are embossed or not. Defaults to false
     */
    set embossed(embossed) {
        this._embossed = coerceBooleanProperty(embossed);
    }
    /**
     * Present a vertical alignment, with tab content on the right
     * default is false, with tabs on top and content below.
     */
    set vertical(vertical) {
        this._vertical = coerceBooleanProperty(vertical);
    }
    /**
     * Select tab on user click on header
     * @param index index of selected tab
     */
    selectTab(index) {
        this.activeTabIndex = index;
        this.activeTabIndexChange.emit(index);
    }
    ngAfterViewInit() {
        this._keyManager = new FocusKeyManager(this.tabAnchors)
            .withWrap()
            .withHorizontalOrientation('ltr');
        this._keyManager.updateActiveItem(0);
    }
    onKeydown(event) {
        switch (event.keyCode) {
            case ENTER:
            case SPACE:
                return this.selectTab(this._keyManager ? this._keyManager.activeItemIndex : 0);
            default:
                this._keyManager.onKeydown(event);
        }
    }
};
CngTabsComponent.ɵfac = function CngTabsComponent_Factory(t) { return new (t || CngTabsComponent)(); };
CngTabsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngTabsComponent, selectors: [["cng-tabs"]], contentQueries: function CngTabsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTabPreDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTabPostDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTabComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.preContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.postContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabs = _t);
    } }, viewQuery: function CngTabsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CngTabAnchorDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabAnchors = _t);
    } }, inputs: { alignment: "alignment", activeTabIndex: "activeTabIndex", inline: "inline", bordered: "bordered", embossed: "embossed", vertical: "vertical" }, outputs: { activeTabIndexChange: "activeTabIndexChange" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["verticalTemplate", ""], [1, "flex-center-vertical", "overflow-auto"], [4, "ngIf"], [1, "flex-fluid", 3, "ngClass"], [1, "tabs", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "tab-content"], [4, "ngTemplateOutlet"], [1, "tab", 3, "ngClass", "click", "keydown"], ["cngTabAnchor", ""], [1, "tab__heading"], [3, "innerText"], ["class", "tab-pane active", 4, "ngIf"], [1, "tab-pane", "active"], [1, "row"], [1, "col-md-3"], [1, "tabs", "tabs--vertical", 3, "ngClass"], [1, "col-md-9"]], template: function CngTabsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CngTabsComponent_ng_container_0_Template, 9, 17, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, CngTabsComponent_ng_template_1_Template, 7, 5, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.vertical)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, CngTabAnchorDirective], encapsulation: 2 });
__decorate([
    ContentChildren(CngTabComponent)
], CngTabsComponent.prototype, "tabs", void 0);
__decorate([
    ViewChildren(CngTabAnchorDirective)
], CngTabsComponent.prototype, "tabAnchors", void 0);
__decorate([
    ContentChild(CngTabPreDirective)
], CngTabsComponent.prototype, "preContent", void 0);
__decorate([
    ContentChild(CngTabPostDirective)
], CngTabsComponent.prototype, "postContent", void 0);
__decorate([
    Input()
], CngTabsComponent.prototype, "inline", null);
__decorate([
    Input()
], CngTabsComponent.prototype, "bordered", null);
__decorate([
    Input()
], CngTabsComponent.prototype, "embossed", null);
__decorate([
    Input()
], CngTabsComponent.prototype, "alignment", void 0);
__decorate([
    Input()
], CngTabsComponent.prototype, "vertical", null);
__decorate([
    Input()
], CngTabsComponent.prototype, "activeTabIndex", void 0);
__decorate([
    Output()
], CngTabsComponent.prototype, "activeTabIndexChange", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/tabs-nav</example-url>
 */
let CngTabLinkComponent = class CngTabLinkComponent {
    constructor() {
        /**
         * If you need to pull a single tab to the right, set pullRight to true on that tab
         */
        this.pullRight = false;
        /**
         * Set 'disabled' css class on tab
         */
        this.disabled = false;
        /**
         * Set routerLinkActiveOptions
         */
        this.routerLinkActiveOptions = { exact: false };
    }
};
CngTabLinkComponent.ɵfac = function CngTabLinkComponent_Factory(t) { return new (t || CngTabLinkComponent)(); };
CngTabLinkComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngTabLinkComponent, selectors: [["cng-tab-link"]], viewQuery: function CngTabLinkComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.labelTemplate = _t.first);
    } }, inputs: { pullRight: "pullRight", disabled: "disabled", routerLinkActiveOptions: "routerLinkActiveOptions", label: "label", url: "url", urlParams: "urlParams" }, ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngTabLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngTabLinkComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
__decorate([
    Input()
], CngTabLinkComponent.prototype, "label", void 0);
__decorate([
    Input()
], CngTabLinkComponent.prototype, "url", void 0);
__decorate([
    Input()
], CngTabLinkComponent.prototype, "urlParams", void 0);
__decorate([
    Input()
], CngTabLinkComponent.prototype, "pullRight", void 0);
__decorate([
    Input()
], CngTabLinkComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], CngTabLinkComponent.prototype, "routerLinkActiveOptions", void 0);
__decorate([
    ViewChild(TemplateRef, { static: true })
], CngTabLinkComponent.prototype, "labelTemplate", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/tabs-nav</example-url>
 */
let CngTabsNavComponent = class CngTabsNavComponent {
    constructor() {
        this._inline = false;
        this._bordered = false;
        this._embossed = false;
        this._vertical = false;
        /**
         * Alignment of the tabs
         */
        this.alignment = 'left';
        /**
         * Optionally bind a value to control the tab index programatically
         */
        this.activeTabIndex = 0;
    }
    get inline() {
        return this._inline;
    }
    get bordered() {
        return this._bordered;
    }
    get embossed() {
        return this._embossed;
    }
    get vertical() {
        return this._vertical;
    }
    /**
     * Apply inline styling to tab labels. Defaults to false (block)
     */
    set inline(inline) {
        this._inline = coerceBooleanProperty(inline);
    }
    /**
     * Whether the tabs are bordered or not. Defaults to false
     */
    set bordered(bordered) {
        this._bordered = coerceBooleanProperty(bordered);
    }
    /**
     * Whether the tabs are embossed or not. Defaults to false
     */
    set embossed(embossed) {
        this._embossed = coerceBooleanProperty(embossed);
    }
    /**
     * Present a vertical alignment, with tab content on the right
     * default is false, with tabs on top and content below.
     */
    set vertical(vertical) {
        this._vertical = coerceBooleanProperty(vertical);
    }
    ngAfterViewInit() {
        this._keyManager = new FocusKeyManager(this.tabAnchors)
            .withWrap()
            .withHorizontalOrientation('ltr');
        this._keyManager.updateActiveItem(0);
    }
    onKeydown(event) {
        this._keyManager.onKeydown(event);
    }
};
CngTabsNavComponent.ɵfac = function CngTabsNavComponent_Factory(t) { return new (t || CngTabsNavComponent)(); };
CngTabsNavComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngTabsNavComponent, selectors: [["cng-tabs-nav"]], contentQueries: function CngTabsNavComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTabPreDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTabPostDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngTabLinkComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.preContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.postContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabs = _t);
    } }, viewQuery: function CngTabsNavComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CngTabAnchorDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabAnchors = _t);
    } }, inputs: { alignment: "alignment", activeTabIndex: "activeTabIndex", inline: "inline", bordered: "bordered", embossed: "embossed", vertical: "vertical" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["verticalTemplate", ""], [1, "flex-center-vertical", "overflow-auto"], [4, "ngIf"], [1, "flex-fluid", 3, "ngClass"], [1, "tabs", 3, "ngClass"], [4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet"], [1, "tab", 3, "ngClass", "keydown"], ["routerLinkActive", "", "cngTabAnchor", "", 3, "routerLink", "queryParams", "routerLinkActiveOptions"], ["rla", "routerLinkActive"], [1, "tab__heading"], [3, "innerText"], [1, "row"], [1, "col-md-3"], [1, "tabs", "tabs--vertical", 3, "ngClass"]], template: function CngTabsNavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CngTabsNavComponent_ng_container_0_Template, 7, 16, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, CngTabsNavComponent_ng_template_1_Template, 4, 4, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.vertical)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.RouterLinkWithHref, ɵngcc2.RouterLinkActive, CngTabAnchorDirective] });
__decorate([
    ContentChildren(CngTabLinkComponent)
], CngTabsNavComponent.prototype, "tabs", void 0);
__decorate([
    ViewChildren(CngTabAnchorDirective)
], CngTabsNavComponent.prototype, "tabAnchors", void 0);
__decorate([
    ContentChild(CngTabPreDirective)
], CngTabsNavComponent.prototype, "preContent", void 0);
__decorate([
    ContentChild(CngTabPostDirective)
], CngTabsNavComponent.prototype, "postContent", void 0);
__decorate([
    Input()
], CngTabsNavComponent.prototype, "inline", null);
__decorate([
    Input()
], CngTabsNavComponent.prototype, "bordered", null);
__decorate([
    Input()
], CngTabsNavComponent.prototype, "embossed", null);
__decorate([
    Input()
], CngTabsNavComponent.prototype, "alignment", void 0);
__decorate([
    Input()
], CngTabsNavComponent.prototype, "vertical", null);
__decorate([
    Input()
], CngTabsNavComponent.prototype, "activeTabIndex", void 0);

let CngTabsModule = class CngTabsModule {
};
CngTabsModule.ɵfac = function CngTabsModule_Factory(t) { return new (t || CngTabsModule)(); };
CngTabsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngTabsModule });
CngTabsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        RouterModule] });

var CngSidebarItemType;
(function (CngSidebarItemType) {
    CngSidebarItemType["ITEM"] = "item";
    CngSidebarItemType["DRAWER"] = "drawer";
})(CngSidebarItemType || (CngSidebarItemType = {}));
var CngSidebarColor;
(function (CngSidebarColor) {
    CngSidebarColor["DEFAULT"] = "default";
    CngSidebarColor["PRIMARY"] = "primary";
    CngSidebarColor["SECONDARY"] = "secondary";
    CngSidebarColor["TERTIARY"] = "tertiary";
    CngSidebarColor["LIGHT"] = "light";
})(CngSidebarColor || (CngSidebarColor = {}));
/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/sidebar</example-url>
 */
let CngSidebarComponent = class CngSidebarComponent {
    constructor(_element, _router) {
        this._element = _element;
        this._router = _router;
        this.destroyed$ = new Subject();
        this._activeDrawers = [];
        this._openedDrawers = [];
        // Listen for route changes and update which drawers are opened/closed
        // We do this instead of a simple routerLinkActive because we want to change
        // more than just classes (open/close various drawers)
        this._router.events.pipe(takeUntil(this.destroyed$))
            .subscribe(event => {
            if (event instanceof NavigationEnd) {
                const currentRoute = event.url;
                this._clearDrawers(this._activeDrawers, 'active');
                if (this.config && this.config.items) {
                    this.config.items.forEach(item => {
                        const matches = this._findCurrentRouteMatchParents(item, currentRoute);
                        if (matches.length) {
                            matches.forEach(match => {
                                if (!this.config.mini) {
                                    match.opened = true;
                                }
                                match.active = true;
                            });
                            this._activeDrawers = matches;
                        }
                    });
                }
            }
        });
    }
    get sidebarWidth() {
        if (this.config.mini) {
            return '';
        }
        return `${this.config.width}px`;
    }
    get sidebarTopOffset() {
        return `${this.config.topOffset}px`;
    }
    get colorPrimary() {
        return this.config.color === CngSidebarColor.PRIMARY;
    }
    get colorSecondary() {
        return this.config.color === CngSidebarColor.SECONDARY;
    }
    get colorTertiary() {
        return this.config.color === CngSidebarColor.TERTIARY;
    }
    get colorLight() {
        return this.config.color === CngSidebarColor.LIGHT;
    }
    get isMini() {
        return this.config.mini;
    }
    onDocumentClick(event) {
        if (this.config && this.config.mini
            && this._openedDrawers.length
            && !this._element.nativeElement.contains(event.target)) {
            this._clearDrawers(this._openedDrawers, 'opened');
        }
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    ngOnInit() {
        this.config = Object.assign({}, 
        // default values
        {
            title: '',
            topOffset: 0,
            items: [],
            width: 200,
            color: CngSidebarColor.DEFAULT,
        }, 
        // input values
        this.config);
    }
    onSidebarItemClick(item, parent) {
        if (item.type === CngSidebarItemType.DRAWER) {
            if (parent && this.config.mini && !item.opened) {
                // close all sibling drawers
                parent.items.forEach(pItem => {
                    pItem.opened = false;
                    this._removeDrawer(this._openedDrawers, pItem);
                });
            }
            item.opened = !item.opened;
            if (item.opened) {
                this._openedDrawers.push(item);
            }
            else {
                this._removeDrawer(this._openedDrawers, item);
            }
        }
        else if (this.config.mini) {
            this._clearDrawers(this._openedDrawers, 'opened');
        }
    }
    /**
     * Finds all parents from leaf to root for an item selected by the current route
     * @param p - CngSidebarItemConfig
     * @param currentRoute - string
     * @returns CngSidebarItemConfig[]
     */
    _findCurrentRouteMatchParents(p, currentRoute) {
        let parents = [];
        if (p.items && p.items.length) {
            for (let i = 0; i < p.items.length; i += 1) {
                const item = p.items[i];
                let link;
                if (typeof item.routerLink !== 'undefined') {
                    link = this._routerLinkToString(item.routerLink);
                    if (currentRoute.startsWith(link)) {
                        parents.push(p);
                    }
                }
                if (item.items && item.items.length) {
                    const nestedMatches = this._findCurrentRouteMatchParents(item, currentRoute);
                    if (nestedMatches.length) {
                        parents.push(p);
                        parents = [...parents, ...nestedMatches];
                    }
                }
            }
        }
        return parents;
    }
    /**
     * Clear the active/opened property from all previously active/opened drawers
     * @param drawers - array of drawers
     * @param property - 'active' | 'opened'
     */
    _clearDrawers(drawers, property) {
        drawers.forEach(drawer => drawer[property] = false);
        drawers.splice(0, drawers.length);
    }
    /**
     * Remove a particular drawer from a given list of drawers
     * @param drawers - array of drawers
     * @param itemToRemove - CngSidebarItemConfig
     */
    _removeDrawer(drawers, itemToRemove) {
        const itemIdx = drawers.indexOf(itemToRemove);
        if (itemIdx !== -1) {
            drawers.splice(itemIdx, 1);
        }
    }
    /**
     * Response to a keydown event if a sidebar item is in focus
     * @param event - KeyboarEvent
     * @param item - CngSidebarItemConfig
     * @param parent - CngSidebarItemConfig
     */
    onSidebarItemKeydown(event, item, parent) {
        if (event.keyCode === SPACE || event.keyCode === ENTER) {
            this.onSidebarItemClick(item, parent);
            if (item.routerLink) {
                this._router.navigate([this._routerLinkToString(item.routerLink)]);
            }
        }
    }
    /**
     * Converts a routerLink value to string
     * @param routerLink - string
     * @returns string
     */
    _routerLinkToString(routerLink) {
        let link;
        if (Array.isArray(routerLink)) {
            link = routerLink.join('/');
        }
        else {
            link = routerLink;
        }
        return link;
    }
};
CngSidebarComponent.ɵfac = function CngSidebarComponent_Factory(t) { return new (t || CngSidebarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
CngSidebarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngSidebarComponent, selectors: [["cng-sidebar"]], hostAttrs: [1, "sidebar"], hostVars: 14, hostBindings: function CngSidebarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CngSidebarComponent_click_HostBindingHandler($event) { return ctx.onDocumentClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.sidebarWidth)("top", ctx.sidebarTopOffset);
        ɵngcc0.ɵɵclassProp("sidebar--primary", ctx.colorPrimary)("sidebar--secondary", ctx.colorSecondary)("sidebar--tertiary", ctx.colorTertiary)("sidebar--light", ctx.colorLight)("sidebar--mini", ctx.isMini);
    } }, inputs: { config: "config" }, decls: 7, vars: 2, consts: [["class", "sidebar__header", 4, "ngIf"], ["role", "navigation", "aria-label", "Main"], [4, "ngFor", "ngForOf"], ["sidebarItem", ""], ["sidebarItemContents", ""], [1, "sidebar__header"], [1, "sidebar__header-title", 3, "innerText"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "-1", 3, "ngClass", 4, "ngIf"], ["tabindex", "-1", 3, "ngClass", "routerLink", "routerLinkActive", "routerLinkActiveOptions", 4, "ngIf"], ["tabindex", "-1", 3, "ngClass"], ["tabindex", "-1", 3, "ngClass", "routerLink", "routerLinkActive", "routerLinkActiveOptions"], ["tabindex", "0", 3, "click", "keydown"], [3, "config"], ["role", "navigation", "aria-label", "Sub-Nav", 4, "ngIf"], ["role", "navigation", "aria-label", "Sub-Nav"]], template: function CngSidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CngSidebarComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵtemplate(2, CngSidebarComponent_ng_container_2_Template, 2, 4, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, CngSidebarComponent_ng_template_3_Template, 2, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, CngSidebarComponent_ng_template_5_Template, 3, 2, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config.items);
    } }, dependencies: [CngContentComponent, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.RouterLink, ɵngcc2.RouterLinkActive], styles: ["[_nghost-%COMP%]   li[_ngcontent-%COMP%]:focus{outline:0}"] });
CngSidebarComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Router }
];
__decorate([
    Input()
], CngSidebarComponent.prototype, "config", void 0);
__decorate([
    HostBinding('style.width')
], CngSidebarComponent.prototype, "sidebarWidth", null);
__decorate([
    HostBinding('style.top')
], CngSidebarComponent.prototype, "sidebarTopOffset", null);
__decorate([
    HostBinding('class.sidebar--primary')
], CngSidebarComponent.prototype, "colorPrimary", null);
__decorate([
    HostBinding('class.sidebar--secondary')
], CngSidebarComponent.prototype, "colorSecondary", null);
__decorate([
    HostBinding('class.sidebar--tertiary')
], CngSidebarComponent.prototype, "colorTertiary", null);
__decorate([
    HostBinding('class.sidebar--light')
], CngSidebarComponent.prototype, "colorLight", null);
__decorate([
    HostBinding('class.sidebar--mini')
], CngSidebarComponent.prototype, "isMini", null);
__decorate([
    HostListener('document:click', ['$event'])
], CngSidebarComponent.prototype, "onDocumentClick", null);

let CngSidebarModule = class CngSidebarModule {
};
CngSidebarModule.ɵfac = function CngSidebarModule_Factory(t) { return new (t || CngSidebarModule)(); };
CngSidebarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngSidebarModule });
CngSidebarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CngContentModule,
        CommonModule,
        RouterModule] });

/**
 * A very simple directive for detecting if a click happened outside the related element
 * Helpful for situations such as seeing if a user clicked outside of a menu to trigger
 * closing the menu, etc.
 */
let CngClickedOutsideDirective = class CngClickedOutsideDirective {
    constructor(_element) {
        this._element = _element;
        this.cngClickedOutside = new EventEmitter();
    }
    /** Host listener for global document:click. Will compare the target element
     * to the element this directive is applied to
     * @param event the MouseEvent
     */
    onClick(event) {
        if (!this._element.nativeElement.contains(event.target)) {
            this.cngClickedOutside.emit(event);
        }
    }
};
CngClickedOutsideDirective.ɵfac = function CngClickedOutsideDirective_Factory(t) { return new (t || CngClickedOutsideDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngClickedOutsideDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngClickedOutsideDirective, selectors: [["", "cngClickedOutside", ""]], hostBindings: function CngClickedOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CngClickedOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, outputs: { cngClickedOutside: "cngClickedOutside" } });
CngClickedOutsideDirective.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Output()
], CngClickedOutsideDirective.prototype, "cngClickedOutside", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], CngClickedOutsideDirective.prototype, "onClick", null);

let CngClickedOutsideModule = class CngClickedOutsideModule {
};
CngClickedOutsideModule.ɵfac = function CngClickedOutsideModule_Factory(t) { return new (t || CngClickedOutsideModule)(); };
CngClickedOutsideModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngClickedOutsideModule });
CngClickedOutsideModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

var CngOptionType;
(function (CngOptionType) {
    CngOptionType["ITEM"] = "item";
    CngOptionType["SELECT_ALL"] = "selectAll";
})(CngOptionType || (CngOptionType = {}));
/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/select</example-url>
 */
let CngOptionComponent = class CngOptionComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.selected = false;
        this._active = false;
        this.type = CngOptionType.ITEM;
    }
    ngOnInit() {
    }
    /** This string version of the option is used to fill in the select <input> */
    get viewValue() {
        return (this.wrappedElem.nativeElement.textContent || '').trim();
    }
    get active() {
        return this._active;
    }
    select() {
        this.selected = true;
        this.cdr.detectChanges();
    }
    deselect() {
        this.selected = false;
        this.cdr.detectChanges();
    }
    setActiveStyles() {
        this._active = true;
    }
    setInactiveStyles() {
        this._active = false;
    }
};
CngOptionComponent.ɵfac = function CngOptionComponent_Factory(t) { return new (t || CngOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CngOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngOptionComponent, selectors: [["cng-option"]], viewQuery: function CngOptionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c22, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrappedElem = _t.first);
    } }, inputs: { value: "value" }, ngContentSelectors: _c11, decls: 3, vars: 0, consts: [["wrapper", ""]], template: function CngOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } } });
CngOptionComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], CngOptionComponent.prototype, "value", void 0);
__decorate([
    ViewChild('wrapper', { static: true })
], CngOptionComponent.prototype, "wrappedElem", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/select</example-url>
 */
let CngGroupComponent = class CngGroupComponent {
    constructor() {
        this.filteredItems = [];
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        this.filteredItems = this._items.toArray();
    }
    get items() {
        return this._items.toArray();
    }
};
CngGroupComponent.ɵfac = function CngGroupComponent_Factory(t) { return new (t || CngGroupComponent)(); };
CngGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngGroupComponent, selectors: [["cng-group"]], contentQueries: function CngGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngOptionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._items = _t);
    } }, inputs: { groupName: "groupName" }, decls: 0, vars: 0, template: function CngGroupComponent_Template(rf, ctx) { } });
__decorate([
    Input()
], CngGroupComponent.prototype, "groupName", void 0);
__decorate([
    ContentChildren(CngOptionComponent)
], CngGroupComponent.prototype, "_items", void 0);

/**
 * Generic component that represents a label. Simply wraps the inner content
 * in a template which can be projected later.
 * This is used for example in cng-select as a way to define a label over the input.
 * (it queries for a CngLabelComponent ContentChild)
 */
let CngLabelComponent = class CngLabelComponent {
};
CngLabelComponent.ɵfac = function CngLabelComponent_Factory(t) { return new (t || CngLabelComponent)(); };
CngLabelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngLabelComponent, selectors: [["cng-label"]], viewQuery: function CngLabelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngLabelComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
__decorate([
    ViewChild(TemplateRef, { static: true })
], CngLabelComponent.prototype, "content", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/select</example-url>
 */
let CngSelectComponent = class CngSelectComponent {
    constructor(control) {
        this.control = control;
        this.destroy$ = new Subject();
        this.kmReset$ = new Subject();
        this.filteredItemsReset$ = new Subject();
        this.writeValue$ = new ReplaySubject(1);
        /** Set the max-height of the dropdown */
        this.dropdownMaxHeight = 175;
        /** Set the height of a single row */
        this.rowSize = 35;
        /** If true, user can type in the text input and filter shown results */
        this.searchable = false;
        this._active = false;
        this._multi = false;
        this.inputControl = new FormControl('');
        this.disabled = false;
        this.onChange = () => { };
        control.valueAccessor = this;
    }
    /** Set if this is a multi select or not.
     * This is a setter so we can coerce the boolean
     */
    set multi(value) {
        if (this.selectionModel) {
            throw new Error(`cng-select: it appears you tried to bind a dynamic property to 'multi'
			or otherwise change it after instantiation. 'multi' should remain static for
			the lifetime of the cng-select. If you need to have a multi/single select
			with the same options, consider 2 separate cng-selects toggled with an *ngIf.`);
        }
        this._multi = coerceBooleanProperty(value);
    }
    get multi() {
        return this._multi;
    }
    get items() {
        return this._items.toArray();
    }
    get groups() {
        return this._groups.toArray();
    }
    get active() {
        return this._active;
    }
    set active(a) {
        this._active = a;
        if (!this._active) {
            this.searchInput.nativeElement.blur();
            this.updateText();
        }
        else {
            // We want to clear the search text on open
            this.inputControl.setValue('');
        }
    }
    ngOnInit() {
        this.selectionModel = new SelectionModel(this._multi);
        this.selectionModel.changed.pipe(takeUntil(this.destroy$))
            .subscribe(event => {
            event.added.forEach(item => {
                item.select();
            });
            event.removed.forEach(item => {
                item.deselect();
            });
            if (this._multi) {
                this.onChange(this.selectionModel.selected.map(item => item.value));
            }
            else {
                this.onChange(this.selectionModel.selected[0] ? this.selectionModel.selected[0].value : null);
            }
        });
        // Listen for typing in the text input, filter shown items accordingly
        this.filteredItems$ = merge(this.inputControl.valueChanges, this.filteredItemsReset$)
            .pipe(startWith(''), map(val => this.searchable ? this._filter(val) : this._items.toArray()), tap(items => this._resetKeyManager(items)));
        // Update groups as well whenever items change
        this.filteredGroups$ = this.filteredItems$.pipe(map(items => this._filterGroups(items)), takeUntil(this.destroy$));
    }
    ngOnChanges(changes) {
        // If the user turns 'searchable' off, reset filtered items to all items
        if (changes.searchable && !changes.searchable.currentValue) {
            this.filteredItemsReset$.next('');
        }
        if (changes.customTrigger && !changes.customTrigger.isFirstChange()
            && (!this._multi || !this._active)) {
            this.updateText();
        }
    }
    ngAfterContentInit() {
        // Listen for the forms controller to write a new value, update items accordingly
        this.writeValue$.pipe(takeUntil(this.destroy$))
            .subscribe(value => {
            let selected;
            if (!this._items) {
                selected = [];
            }
            else if (this._multi && Array.isArray(value)) {
                selected = this._items.filter(item => value.includes(item.value));
            }
            else {
                selected = this._items.filter(item => item.value === value);
            }
            this.selectionModel.clear();
            this.selectionModel.select(...selected);
            this.updateText();
        });
        // Register the keyboard event manager to highlight select items
        // We have to wait until the items actually exist to register them, so we do it here
        this._resetKeyManager(this._items.toArray());
        // Listen for items to change, we will reset the filtered items when that happens
        merge(this._items.changes, this._groups.changes)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this.filteredItemsReset$.next('');
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    updateText() {
        if (this.customTrigger) {
            return this.inputControl.setValue(this.customTrigger);
        }
        if (!this._multi) {
            const selected = this.selectionModel.selected[0];
            if (selected) {
                this.inputControl.setValue(selected.viewValue);
            }
            else {
                this.inputControl.setValue('');
            }
        }
        else {
            this.inputControl.setValue(this.selectionModel.selected.map(item => `${item.viewValue}`)
                .join(','));
        }
    }
    toggleActive() {
        if (!this.disabled) {
            this.active = !this.active;
        }
    }
    onClick(item) {
        if (!this._multi) {
            // Single select
            this.selectionModel.select(item);
            this.active = false;
        }
        else if (!(item.type === CngOptionType.SELECT_ALL)) {
            // Multiselect an item
            this.selectionModel.toggle(item);
        }
        else {
            // On "Select All" multiselect option
            this._onSelectAll();
        }
    }
    _onSelectAll() {
        if (this.selectionModel.selected.length < this.items.length - 1) {
            this.selectionModel.select(...this.items.filter(i => i.type !== CngOptionType.SELECT_ALL));
        }
        else {
            this.selectionModel.clear();
        }
    }
    // Note I'm following @angular/cdks lead and still using keyCode
    // This can change when they update to use non-deprecated "code"
    onKeydown(event) {
        if (event.keyCode === ENTER) {
            if (this._active && this._keyManager.activeItem) {
                if (!this._multi) {
                    this.selectionModel.select(this._keyManager.activeItem);
                    this.active = false;
                }
                else {
                    this.selectionModel.toggle(this._keyManager.activeItem);
                }
            }
            else {
                this.active = true;
            }
        }
        else if (!this.active && (event.keyCode === UP_ARROW || event.keyCode === DOWN_ARROW)) {
            this.active = true;
        }
        else {
            this._keyManager.onKeydown(event);
        }
    }
    // ControlValueAccessor functions
    writeValue(value) {
        this.writeValue$.next(value);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched() { }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        if (this.disabled) {
            this.inputControl.disable();
        }
        else {
            this.inputControl.enable();
        }
    }
    _filter(filterStr) {
        const filterValue = filterStr.toLowerCase();
        return this._items.filter(item => item.viewValue.toLowerCase().includes(filterValue));
    }
    // Based on given items, filter groups to ONLY those with at least 1 item,
    // and filter the group's items to only include those in the items array
    _filterGroups(items) {
        const newGroups = this._groups.map(group => {
            group.filteredItems = group.items.filter(item => items.includes(item));
            return group;
        });
        return newGroups.filter(group => group.filteredItems.length > 0);
    }
    calcDropdownHeight(items, groups) {
        const currentHeight = this.rowSize * items.length +
            this.rowSize * groups.length;
        return (currentHeight > this.dropdownMaxHeight ? this.dropdownMaxHeight : currentHeight);
    }
    // Create a new key manager whenever the items change
    _resetKeyManager(items) {
        this.kmReset$.next();
        if (this._keyManager) {
            this._keyManager.setActiveItem(null);
        }
        this._keyManager = new ActiveDescendantKeyManager(items).withWrap();
        // If something's selected, active key is first selected.
        if (this.selectionModel.selected && this.selectionModel.selected[0]
            && items.indexOf(this.selectionModel.selected[0]) !== -1) {
            this._keyManager.setActiveItem(items.indexOf(this.selectionModel.selected[0]));
        }
        else {
            this._keyManager.setFirstItemActive();
        }
        // Listen for tabbing out of focus
        this._keyManager.tabOut.pipe(takeUntil(this.destroy$), takeUntil(this.kmReset$))
            .subscribe(() => {
            this.active = false;
        });
        // Listen and scroll virtual scroll to keep up with index
        this._keyManager.change.pipe(takeUntil(this.destroy$), takeUntil(this.kmReset$))
            .subscribe(index => {
            if (this.virtualScroll) {
                this.virtualScroll.scrollToIndex(index);
            }
        });
    }
};
CngSelectComponent.ɵfac = function CngSelectComponent_Factory(t) { return new (t || CngSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl)); };
CngSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngSelectComponent, selectors: [["cng-select"]], contentQueries: function CngSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngLabelComponent, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngOptionComponent, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngGroupComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.label = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._items = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._groups = _t);
    } }, viewQuery: function CngSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c23, 5);
        ɵngcc0.ɵɵviewQuery(CdkVirtualScrollViewport, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.virtualScroll = _t.first);
    } }, inputs: { dropdownMaxHeight: "dropdownMaxHeight", rowSize: "rowSize", searchable: "searchable", multi: "multi", customTrigger: "customTrigger" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 12, vars: 16, consts: [[1, "form-group", "dropdown", 3, "ngClass", "cngClickedOutside"], [1, "form-group__text", "select", 3, "click"], [3, "formControl", "keydown"], ["searchInput", ""], ["for", "searchInput", 4, "ngIf"], [1, "dropdown__menu", 3, "itemSize", "ngStyle"], [4, "ngIf"], ["itemTemplate", ""], ["for", "searchInput"], [4, "ngTemplateOutlet"], [4, "cdkVirtualFor", "cdkVirtualForOf"], [1, "dropdown__group"], [1, "dropdown__group-header"], [4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngClass", "click"], [1, "form-group", "form-group--inline", 3, "innerHTML"], [1, "form-group", "form-group--inline"], [1, "checkbox", 3, "click"], ["type", "checkbox", 3, "checked"], [1, "checkbox__input"], [1, "checkbox__label", 3, "innerHTML"]], template: function CngSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("cngClickedOutside", function CngSelectComponent_Template_div_cngClickedOutside_0_listener() { return ctx.active = false; });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function CngSelectComponent_Template_div_click_1_listener() { return ctx.toggleActive(); });
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("keydown", function CngSelectComponent_Template_input_keydown_2_listener($event) { return ctx.onKeydown($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, CngSelectComponent_label_4_Template, 2, 1, "label", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "cdk-virtual-scroll-viewport", 5);
        ɵngcc0.ɵɵpipe(6, "async");
        ɵngcc0.ɵɵpipe(7, "async");
        ɵngcc0.ɵɵtemplate(8, CngSelectComponent_ng_container_8_Template, 3, 3, "ng-container", 6);
        ɵngcc0.ɵɵtemplate(9, CngSelectComponent_ng_container_9_Template, 3, 3, "ng-container", 6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(10, CngSelectComponent_ng_template_10_Template, 2, 2, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c27, ctx.active, ctx.control.invalid));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formControl", ctx.inputControl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("itemSize", ctx.rowSize)("ngStyle", ɵngcc0.ɵɵpureFunction1(14, _c28, ctx.calcDropdownHeight(ɵngcc0.ɵɵpipeBind1(6, 7, ctx.filteredItems$), ɵngcc0.ɵɵpipeBind1(7, 9, ctx.filteredGroups$)) + "px"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.groups.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.groups.length);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgStyle, CngClickedOutsideDirective, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlDirective, ɵngcc5.CdkFixedSizeVirtualScroll, ɵngcc5.CdkVirtualForOf, ɵngcc5.CdkVirtualScrollViewport, ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]   .select[_ngcontent-%COMP%]{--cui-form-icon-yoffset:calc(calc(var(--cui-form-size) * 0.5) - (calc(var(--cui-form-icon-dropdown-font-size) * 0.5)))}[_nghost-%COMP%]   a.hover[_ngcontent-%COMP%]{background-color:var(--cui-background-hover)!important}[_nghost-%COMP%]   input[_ngcontent-%COMP%]{text-overflow:ellipsis}"] });
CngSelectComponent.ctorParameters = () => [
    { type: NgControl }
];
__decorate([
    Input()
], CngSelectComponent.prototype, "dropdownMaxHeight", void 0);
__decorate([
    Input()
], CngSelectComponent.prototype, "rowSize", void 0);
__decorate([
    Input()
], CngSelectComponent.prototype, "multi", null);
__decorate([
    Input()
], CngSelectComponent.prototype, "searchable", void 0);
__decorate([
    Input()
], CngSelectComponent.prototype, "customTrigger", void 0);
__decorate([
    ContentChildren(CngOptionComponent, { descendants: true })
], CngSelectComponent.prototype, "_items", void 0);
__decorate([
    ContentChildren(CngGroupComponent)
], CngSelectComponent.prototype, "_groups", void 0);
__decorate([
    ViewChild('searchInput')
], CngSelectComponent.prototype, "searchInput", void 0);
__decorate([
    ViewChild(CdkVirtualScrollViewport)
], CngSelectComponent.prototype, "virtualScroll", void 0);
__decorate([
    ContentChild(CngLabelComponent)
], CngSelectComponent.prototype, "label", void 0);

let CngLabelModule = class CngLabelModule {
};
CngLabelModule.ɵfac = function CngLabelModule_Factory(t) { return new (t || CngLabelModule)(); };
CngLabelModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngLabelModule });
CngLabelModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

var CngSelectAllComponent_1;
let CngSelectAllComponent = CngSelectAllComponent_1 = class CngSelectAllComponent extends CngOptionComponent {
    constructor(_cdr, _select) {
        super(_cdr);
        this._cdr = _cdr;
        this._select = _select;
        this._destroy$ = new Subject();
        this.type = CngOptionType.SELECT_ALL;
    }
    ngOnInit() {
        this._select.selectionModel.changed
            .pipe(takeUntil(this._destroy$))
            .subscribe(changes => {
            if (changes.source.selected.length === this._select.items.length - 1) {
                this.select();
                this.setActiveStyles();
            }
            else {
                this.deselect();
                this.setInactiveStyles();
            }
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
    }
};
CngSelectAllComponent.ɵfac = function CngSelectAllComponent_Factory(t) { return new (t || CngSelectAllComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CngSelectComponent)); };
CngSelectAllComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngSelectAllComponent, selectors: [["cng-select-all"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: CngOptionComponent,
                useExisting: forwardRef(() => CngSelectAllComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c11, decls: 3, vars: 0, consts: [["wrapper", ""]], template: function CngSelectAllComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
CngSelectAllComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: CngSelectComponent }
];

let CngSelectModule = class CngSelectModule {
};
CngSelectModule.ɵfac = function CngSelectModule_Factory(t) { return new (t || CngSelectModule)(); };
CngSelectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngSelectModule });
CngSelectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        CngClickedOutsideModule,
        CngLabelModule,
        ReactiveFormsModule,
        ScrollingModule] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/pager</example-url>
 */
let CngPagerComponent = class CngPagerComponent {
    constructor() {
        /**
         * The current page index.
         */
        this.page = 0;
        /**
         * The number of items displayed per page.
         */
        this.limit = 10;
        /**
         * Whether the page limit can be changed
         */
        this.changeLimit = false;
        /**
         * Available limit counts. Zero means no limit.
         */
        this.availableLimits = [10, 25, 50, 100, 0];
        /**
         * Number of pages at a time to display in the bar NOT counting first/last page
         * (default of 3 is recommended, for 5 clickable buttons total)
         */
        this.displayedPages = 3;
        /**
         * Whether to show the page details "x-y of z" next to the buttons
         */
        this.showPageDetails = false;
        /**
         * Whether to use icons. If true, will display arrow icons for forward/back/fast forward/back
         * Otherwise will display the words "Next" and "Previous" by default
         */
        this.useIcons = false;
        /**
         * Use rounded style (false, using boxed style by default)
         */
        this.rounded = false;
        /**
         * Size of pagination buttons
         */
        this.size = 'default';
        /**
         * Event emitted when the page is changed.
         */
        this.onPageChanged = new EventEmitter();
        /**
         * Event emits after first init
         */
        this.onInit = new EventEmitter();
        this.pages = [];
        this.pageLimit = 0;
        this.max = 0;
    }
    ngOnInit() {
        this.limits = this.availableLimits.map((count) => ({
            name: count === 0 ? 'All' : count.toString(),
            value: count === 0 ? 999999 : count,
        }));
        this.updateVisiblePages();
        this.refreshPageDetails();
        this.onInit.next({ page: this.page, limit: this.limit });
    }
    ngOnChanges(changes) {
        this.refreshPageDetails();
        if (changes.page || changes.totalItems || changes.limit || changes.displayedPages) {
            this.updateVisiblePages();
            if (changes.page || changes.limit) {
                this.onPageChanged.emit({
                    page: this.page,
                    limit: this.limit,
                });
            }
        }
    }
    onLimitChange(newLimit) {
        if (newLimit !== this.limit) {
            this.limit = newLimit;
            this.gotoPage(0);
        }
    }
    onClick(page, disabled) {
        if (disabled) {
            return;
        }
        this.gotoPage(page);
    }
    gotoPage(page) {
        this.page = page;
        this.updateVisiblePages();
        this.onPageChanged.emit({
            page: this.page,
            limit: this.limit,
        });
        this.refreshPageDetails();
    }
    /**
     * Updates the clickable page buttons to show a max of (displayedPages + 2) at any time
     * So, at most the first page, last page, and 3 additional page buttons.
     * General strategy works by
     * 1. insert page 0
     * 2. building out displayedPages buttons with the current page
     * in the middle (so odd # pages recommended).
     * 3. Then adds last page and any ellipses if needed.
     */
    updateVisiblePages() {
        this.lastPage = Math.ceil(this.totalItems / this.limit) - 1;
        this.pages = [0];
        const startingPage = Math.max(1, this.page - Math.floor(this.displayedPages / 2));
        if (startingPage > 1) {
            this.pages.push('ellipses');
        }
        const endingPage = Math.min(this.lastPage - 1, startingPage + this.displayedPages - 1);
        for (let i = startingPage; i <= endingPage; i += 1) {
            this.pages.push(i);
        }
        if (endingPage < this.lastPage - 1) {
            this.pages.push('ellipses');
        }
        if (this.lastPage > 0) {
            this.pages.push(this.lastPage);
        }
    }
    refreshPageDetails() {
        this.pageLimit = this.page * this.limit + 1;
        this.max = Math.min(this.page * this.limit + this.limit, this.totalItems);
    }
};
CngPagerComponent.ɵfac = function CngPagerComponent_Factory(t) { return new (t || CngPagerComponent)(); };
CngPagerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngPagerComponent, selectors: [["cng-pager"]], inputs: { page: "page", limit: "limit", changeLimit: "changeLimit", availableLimits: "availableLimits", displayedPages: "displayedPages", showPageDetails: "showPageDetails", useIcons: "useIcons", rounded: "rounded", size: "size", totalItems: "totalItems" }, outputs: { onPageChanged: "onPageChanged", onInit: "onInit" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 20, vars: 23, consts: function () { let i18n_29; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_8442977324419636238$$FESM2015_CISCO_CUI_NG_JS__30 = goog.getMsg(" {$interpolation}-{$interpolation_1} of {$interpolation_2} ", { "interpolation": "\uFFFD0\uFFFD", "interpolation_1": "\uFFFD1\uFFFD", "interpolation_2": "\uFFFD2\uFFFD" }, { original_code: { "interpolation": "{{pageLimit}}", "interpolation_1": "{{max}}", "interpolation_2": "{{totalItems}}" } });
        i18n_29 = MSG_EXTERNAL_8442977324419636238$$FESM2015_CISCO_CUI_NG_JS__30;
    }
    else {
        i18n_29 = $localize `:␟5e738e407162a1ccc168e69df4208750032bc69a␟8442977324419636238: ${"\uFFFD0\uFFFD"}:INTERPOLATION:-${"\uFFFD1\uFFFD"}:INTERPOLATION_1: of ${"\uFFFD2\uFFFD"}:INTERPOLATION_2: `;
    } let i18n_32; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc cng-pager 'Prev' button
         */
        const MSG_EXTERNAL_2501522447884928778$$FESM2015_CISCO_CUI_NG_JS__33 = goog.getMsg("Prev");
        i18n_32 = MSG_EXTERNAL_2501522447884928778$$FESM2015_CISCO_CUI_NG_JS__33;
    }
    else {
        i18n_32 = $localize `:cng-pager 'Prev' button␟c2375280c2228be7eb5fc89446188193eb20f03b␟2501522447884928778:Prev`;
    } let i18n_34; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc cng-pager 'Next' button
         */
        const MSG_EXTERNAL_3885497195825665706$$FESM2015_CISCO_CUI_NG_JS__35 = goog.getMsg("Next");
        i18n_34 = MSG_EXTERNAL_3885497195825665706$$FESM2015_CISCO_CUI_NG_JS__35;
    }
    else {
        i18n_34 = $localize `:cng-pager 'Next' button␟f732c304c7433e5a83ffcd862c3dce709a0f4982␟3885497195825665706:Next`;
    } let i18n_36; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc cng-pager limit select
         */
        const MSG_EXTERNAL_3313305464759255603$$FESM2015_CISCO_CUI_NG_JS__37 = goog.getMsg("Showing");
        i18n_36 = MSG_EXTERNAL_3313305464759255603$$FESM2015_CISCO_CUI_NG_JS__37;
    }
    else {
        i18n_36 = $localize `:cng-pager limit select␟b105f50be6bdd52a475bf46361e7170687032843␟3313305464759255603:Showing`;
    } return [[1, "flex", "flex-middle"], ["class", "base-margin-right", 4, "ngIf"], [1, "pagination", 2, "margin", "0", 3, "ngClass"], [4, "ngIf"], ["href", "javascript:;", "data-auto-id", "CNGPager-PrevPage", 3, "ngClass", "click"], [3, "ngSwitch"], ["class", "icon-chevron-left", 4, "ngSwitchCase"], [4, "ngSwitchDefault"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["href", "javascript:;", "data-auto-id", "CNGPager-NextPage", 3, "ngClass", "click"], ["class", "icon-chevron-right", 4, "ngSwitchCase"], ["class", "half-margin-left", 4, "ngIf"], ["class", "qtr-margin-left limit-select", 3, "ngModel", "ngModelChange", 4, "ngIf"], [1, "base-margin-right"], ["data-auto-id", "CNGPager-PageDetails", 1, "text-muted"], i18n_29, ["href", "javascript:;", "data-auto-id", "CNGPager-FirstPage", 3, "ngClass", "click"], [1, "icon-chevron-left-double"], [1, "icon-chevron-left"], i18n_32, [3, "ngClass"], ["class", "icon-more", 4, "ngSwitchCase"], ["class", "cng-pager-page", "href", "javascript:;", 3, "click", 4, "ngSwitchDefault"], [1, "icon-more"], ["href", "javascript:;", 1, "cng-pager-page", 3, "click"], [3, "innerText"], [1, "icon-chevron-right"], i18n_34, ["href", "javascript:;", "data-auto-id", "CNGPager-LastPage", 3, "ngClass", "click"], [1, "icon-chevron-right-double"], [1, "half-margin-left"], i18n_36, [1, "qtr-margin-left", "limit-select", 3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]]; }, template: function CngPagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 0);
        ɵngcc0.ɵɵtemplate(2, CngPagerComponent_div_2_Template, 3, 3, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div")(4, "ul", 2);
        ɵngcc0.ɵɵtemplate(5, CngPagerComponent_li_5_Template, 3, 4, "li", 3);
        ɵngcc0.ɵɵelementStart(6, "li")(7, "a", 4);
        ɵngcc0.ɵɵlistener("click", function CngPagerComponent_Template_a_click_7_listener() { return ctx.onClick(ctx.page - 1, ctx.page === 0); });
        ɵngcc0.ɵɵelementContainerStart(8, 5);
        ɵngcc0.ɵɵtemplate(9, CngPagerComponent_span_9_Template, 1, 0, "span", 6);
        ɵngcc0.ɵɵtemplate(10, CngPagerComponent_span_10_Template, 2, 0, "span", 7);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(11, CngPagerComponent_li_11_Template, 4, 5, "li", 8);
        ɵngcc0.ɵɵelementStart(12, "li")(13, "a", 9);
        ɵngcc0.ɵɵlistener("click", function CngPagerComponent_Template_a_click_13_listener() { return ctx.onClick(ctx.page + 1, ctx.page === ctx.lastPage); });
        ɵngcc0.ɵɵelementContainerStart(14, 5);
        ɵngcc0.ɵɵtemplate(15, CngPagerComponent_span_15_Template, 1, 0, "span", 10);
        ɵngcc0.ɵɵtemplate(16, CngPagerComponent_span_16_Template, 2, 0, "span", 7);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(17, CngPagerComponent_li_17_Template, 3, 4, "li", 3);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(18, CngPagerComponent_span_18_Template, 2, 0, "span", 11);
        ɵngcc0.ɵɵtemplate(19, CngPagerComponent_cng_select_19_Template, 2, 2, "cng-select", 12);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPageDetails);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(15, _c38, ctx.size === "large", ctx.size === "small", ctx.rounded));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useIcons);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c31, ctx.page === 0));
        ɵngcc0.ɵɵattribute("tabindex", ctx.page === 0 ? "-1" : "0");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.useIcons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.pages);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(21, _c31, ctx.page === ctx.lastPage));
        ɵngcc0.ɵɵattribute("tabindex", ctx.page === ctx.lastPage ? "-1" : "0");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.useIcons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useIcons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.changeLimit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.changeLimit);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, CngSelectComponent, CngOptionComponent], encapsulation: 2 });
__decorate([
    Input()
], CngPagerComponent.prototype, "page", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "limit", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "totalItems", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "changeLimit", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "availableLimits", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "displayedPages", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "showPageDetails", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "useIcons", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "rounded", void 0);
__decorate([
    Input()
], CngPagerComponent.prototype, "size", void 0);
__decorate([
    Output()
], CngPagerComponent.prototype, "onPageChanged", void 0);
__decorate([
    Output()
], CngPagerComponent.prototype, "onInit", void 0);

let CngPagerModule = class CngPagerModule {
};
CngPagerModule.ɵfac = function CngPagerModule_Factory(t) { return new (t || CngPagerModule)(); };
CngPagerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngPagerModule });
CngPagerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        CngSelectModule] });

/**
 * All possible colors for the loader dots
 */
var CngLoaderColor;
(function (CngLoaderColor) {
    CngLoaderColor["PRIMARY"] = "primary";
    CngLoaderColor["SECONDARY"] = "secondary";
    CngLoaderColor["TERTIARY"] = "tertiary";
    CngLoaderColor["SUCCESS"] = "success";
    CngLoaderColor["INFO"] = "info";
    CngLoaderColor["WARNING"] = "warning";
    CngLoaderColor["WARNING_ALT"] = "warning-alt";
    CngLoaderColor["DANGER"] = "danger";
    CngLoaderColor["DARK"] = "dark";
    CngLoaderColor["LIGHT"] = "light";
})(CngLoaderColor || (CngLoaderColor = {}));
/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/loader</example-url>
 */
let CngLoaderComponent = class CngLoaderComponent {
    constructor() {
        /** Possible sizes */
        this.size = 'default';
        /** Specify the color, defaults to primary */
        this.color = CngLoaderColor.PRIMARY;
        this._fullscreen = false;
    }
    get dots() {
        return this._dots;
    }
    /** Attribute which if specified, changes the loader from a spinning gauge
     * to animated dots
     */
    set dots(value) {
        this._dots = coerceBooleanProperty(value);
    }
    get fullscreen() {
        return this._fullscreen;
    }
    /**
     * Whether or not the loader should be fullscreen.
     */
    set fullscreen(value) {
        this._fullscreen = coerceBooleanProperty(value);
    }
    ngOnInit() {
    }
};
CngLoaderComponent.ɵfac = function CngLoaderComponent_Factory(t) { return new (t || CngLoaderComponent)(); };
CngLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngLoaderComponent, selectors: [["cng-loader"]], contentQueries: function CngLoaderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngLabelComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.label = _t.first);
    } }, inputs: { size: "size", color: "color", dots: "dots", fullscreen: "fullscreen" }, decls: 4, vars: 2, consts: function () { let i18n_39; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_4970917682340515037$$FESM2015_CISCO_CUI_NG_JS___40 = goog.getMsg("Loading, please wait...");
        i18n_39 = MSG_EXTERNAL_4970917682340515037$$FESM2015_CISCO_CUI_NG_JS___40;
    }
    else {
        i18n_39 = $localize `:␟f614f69c28a799f9e04f879a2d1f114ad66b111b␟4970917682340515037:Loading, please wait...`;
    } let i18n_41; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_4970917682340515037$$FESM2015_CISCO_CUI_NG_JS___42 = goog.getMsg("Loading, please wait...");
        i18n_41 = MSG_EXTERNAL_4970917682340515037$$FESM2015_CISCO_CUI_NG_JS___42;
    }
    else {
        i18n_41 = $localize `:␟f614f69c28a799f9e04f879a2d1f114ad66b111b␟4970917682340515037:Loading, please wait...`;
    } return [["class", "modal", 4, "ngIf"], [4, "ngIf"], ["loader", ""], [1, "modal"], [1, "absolute", "max-width", "max-height"], [1, "absolute-center"], [4, "ngTemplateOutlet"], ["class", "text-center", 4, "ngIf"], [1, "text-center"], ["aria-label", i18n_39], [1, "wrapper", "flex", "flex-center"], [1, "wheel"], ["aria-label", i18n_41]]; }, template: function CngLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CngLoaderComponent_div_0_Template, 4, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, CngLoaderComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, CngLoaderComponent_ng_template_2_Template, 2, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.fullscreen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.fullscreen);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet] });
__decorate([
    ContentChild(CngLabelComponent)
], CngLoaderComponent.prototype, "label", void 0);
__decorate([
    Input()
], CngLoaderComponent.prototype, "dots", null);
__decorate([
    Input()
], CngLoaderComponent.prototype, "size", void 0);
__decorate([
    Input()
], CngLoaderComponent.prototype, "color", void 0);
__decorate([
    Input()
], CngLoaderComponent.prototype, "fullscreen", null);

let CngLoaderModule = class CngLoaderModule {
};
CngLoaderModule.ɵfac = function CngLoaderModule_Factory(t) { return new (t || CngLoaderModule)(); };
CngLoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngLoaderModule });
CngLoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        CngLabelModule] });

/**
 * All possible colors for progressbar
 */
var CngProgressbarColor;
(function (CngProgressbarColor) {
    CngProgressbarColor["PRIMARY"] = "primary";
    CngProgressbarColor["SECONDARY"] = "secondary";
    CngProgressbarColor["TERTIARY"] = "tertiary";
    CngProgressbarColor["SUCCESS"] = "success";
    CngProgressbarColor["INFO"] = "info";
    CngProgressbarColor["WARNING_ALT"] = "warning-alt";
    CngProgressbarColor["WARNING"] = "warning";
    CngProgressbarColor["DANGER"] = "danger";
    CngProgressbarColor["DARK"] = "dark";
})(CngProgressbarColor || (CngProgressbarColor = {}));
/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/progressbar</example-url>
 */
let CngProgressbarComponent = class CngProgressbarComponent {
    constructor() {
        /** Size of the bar, defaults to, you guessed it, 'default' */
        this.size = 'default';
        /** Color of the bar */
        this.color = CngProgressbarColor.PRIMARY;
    }
    ngOnInit() {
    }
};
CngProgressbarComponent.ɵfac = function CngProgressbarComponent_Factory(t) { return new (t || CngProgressbarComponent)(); };
CngProgressbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngProgressbarComponent, selectors: [["cng-progressbar"]], contentQueries: function CngProgressbarComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngLabelComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customLabel = _t.first);
    } }, inputs: { size: "size", color: "color", value: "value", label: "label" }, decls: 4, vars: 9, consts: function () { let i18n_43; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc cng-progressbar loading label
         */
        const MSG_EXTERNAL_5277854751687674014$$FESM2015_CISCO_CUI_NG_JS___44 = goog.getMsg("{$startTagNgContainer} {$interpolation} Complete {$closeTagNgContainer}{$startTagNgContainer_2}{$startTagNgContainer_1}{$closeTagNgContainer}{$closeTagNgContainer}", { "startTagNgContainer": "\uFFFD*2:1\uFFFD\uFFFD#1:1\uFFFD", "closeTagNgContainer": "[\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD|\uFFFD/#1:3\uFFFD\uFFFD/*2:3\uFFFD|\uFFFD/#1:2\uFFFD\uFFFD/*3:2\uFFFD]", "startTagNgContainer_2": "\uFFFD*3:2\uFFFD\uFFFD#1:2\uFFFD", "interpolation": "\uFFFD0:1\uFFFD", "startTagNgContainer_1": "\uFFFD*2:3\uFFFD\uFFFD#1:3\uFFFD" }, { original_code: { "startTagNgContainer": "<ng-container *ngIf=\\\"!customLabel\\\">", "closeTagNgContainer": "</ng-container>", "startTagNgContainer_2": "<ng-container *ngIf=\\\"customLabel\\\">", "interpolation": "{{ (value | percent:'1.0-0') }}", "startTagNgContainer_1": "<ng-container *ngTemplateOutlet=\\\"customLabel.content\\\">" } });
        i18n_43 = MSG_EXTERNAL_5277854751687674014$$FESM2015_CISCO_CUI_NG_JS___44;
    }
    else {
        i18n_43 = $localize `:cng-progressbar loading label␟4dfc552a3860fd842afb43649a5db89c1e5d9fdd␟5277854751687674014:${"\uFFFD*2:1\uFFFD\uFFFD#1:1\uFFFD"}:START_TAG_NG_CONTAINER: ${"\uFFFD0:1\uFFFD"}:INTERPOLATION: Complete ${"[\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD|\uFFFD/#1:3\uFFFD\uFFFD/*2:3\uFFFD|\uFFFD/#1:2\uFFFD\uFFFD/*3:2\uFFFD]"}:CLOSE_TAG_NG_CONTAINER:${"\uFFFD*3:2\uFFFD\uFFFD#1:2\uFFFD"}:START_TAG_NG_CONTAINER_2:${"\uFFFD*2:3\uFFFD\uFFFD#1:3\uFFFD"}:START_TAG_NG_CONTAINER_1:${"[\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD|\uFFFD/#1:3\uFFFD\uFFFD/*2:3\uFFFD|\uFFFD/#1:2\uFFFD\uFFFD/*3:2\uFFFD]"}:CLOSE_TAG_NG_CONTAINER:${"[\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD|\uFFFD/#1:3\uFFFD\uFFFD/*2:3\uFFFD|\uFFFD/#1:2\uFFFD\uFFFD/*3:2\uFFFD]"}:CLOSE_TAG_NG_CONTAINER:`;
    } i18n_43 = ɵngcc0.ɵɵi18nPostprocess(i18n_43); return [[1, "progressbar__fill"], ["class", "progressbar__label", 4, "ngIf"], [1, "progressbar__label"], i18n_43, [4, "ngIf"], [4, "ngTemplateOutlet"]]; }, template: function CngProgressbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵpipe(1, "number");
        ɵngcc0.ɵɵelement(2, "div", 0);
        ɵngcc0.ɵɵtemplate(3, CngProgressbarComponent_div_3_Template, 4, 2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate2("progressbar progressbar--", ctx.size, " progressbar--", ctx.color, "");
        ɵngcc0.ɵɵattribute("data-percentage", ɵngcc0.ɵɵpipeBind2(1, 6, ctx.value * 100, "1.0-0"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.DecimalPipe, ɵngcc1.PercentPipe] });
__decorate([
    Input()
], CngProgressbarComponent.prototype, "value", void 0);
__decorate([
    Input()
], CngProgressbarComponent.prototype, "label", void 0);
__decorate([
    Input()
], CngProgressbarComponent.prototype, "size", void 0);
__decorate([
    Input()
], CngProgressbarComponent.prototype, "color", void 0);
__decorate([
    ContentChild(CngLabelComponent)
], CngProgressbarComponent.prototype, "customLabel", void 0);

let CngProgressbarModule = class CngProgressbarModule {
};
CngProgressbarModule.ɵfac = function CngProgressbarModule_Factory(t) { return new (t || CngProgressbarModule)(); };
CngProgressbarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngProgressbarModule });
CngProgressbarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        CngLabelModule] });

var CngRatingComponent_1;
/**
 * Cisco NG Rating component
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/rating</example-url>
 */
let CngRatingComponent = CngRatingComponent_1 = class CngRatingComponent {
    constructor() {
        /**
         * Output so that an application can detect when a user selects a new rating.
         */
        this.onRatingChanged = new EventEmitter();
        /**
         * The color to give the stars.
         *
         * @usageNotes
         * Normal = blue, alt = yellow.
         */
        this.color = 'normal';
        /**
         * The size for the stars to be.
         */
        this.size = 'default';
        /**
         * The style that the rating stars should be rendered in.
         *
         * @usageNotes
         * Empty = outlined stars, filled = normal stars
         */
        this.starStyle = 'filled';
        /**
         * Determine if this is a clickable form control or simply a static display of rating
         * true = clickable, false = static
         */
        this.clickable = true;
        this._totalStars = 5;
        this._showHalf = false;
        this._halfThreshold = 0.11;
    }
    get totalStars() {
        return this._totalStars;
    }
    /**
     * The total number of stars to display and have as selectable. Users may
     * rate between 1 and this number inclusively.
     */
    set totalStars(value) {
        this._totalStars = coerceNumberProperty(value, 5);
    }
    get showHalf() {
        return this._showHalf;
    }
    /**
     * Whether to show half-stars if the rating is some floating point value in a certain threshold
     * Set halfThreshold to change this threshold (defaults to 0.1)
     */
    set showHalf(show) {
        this._showHalf = coerceBooleanProperty(show);
    }
    get halfThreshold() {
        return this._halfThreshold;
    }
    /**
     * The threshold around 0.5 within which to show half a star.
     * Defaults to 0.1 (i.e. ratings from 3.49 - 3.61 will show 3 and a half stars)
     */
    set halfThreshold(t) {
        this._halfThreshold = coerceNumberProperty(t, 0.1);
    }
    /**
     * Builds the stars array which is used by the component to render stars in HTML.
     */
    buildStars() {
        this.stars = [];
        // Fill array in backwards.
        for (let i = 1; i <= this.totalStars; i += 1) {
            this.stars.unshift(i);
        }
    }
    /**
     * Initialize the component.
     */
    ngOnInit() {
        // ngOnChanges() runs prior to this if totalStars has been changed via Input.
        // If the user leaves it at the default value, then ngOnChanges() is never run!
        // tslint:disable-next-line
        // See https://stackoverflow.com/questions/36071942/how-to-set-default-values-for-angular-2-component-properties
        if (!this.stars) {
            this.buildStars();
        }
    }
    /**
     * Reacts when the component changes.
     * @param changes The changes detected.
     */
    ngOnChanges(changes) {
        if (changes.totalStars) {
            this.buildStars();
        }
    }
    /**
     * Handles when the user changes the rating for this given component.
     * @param newRating The new rating selected by the user.
     */
    onRatingChange(newRating) {
        this.rating = newRating;
        this.onRatingChanged.emit(newRating);
        this._changePropagation(newRating);
    }
    /**
     * Handles when user presses a key on a star. Select with "ENTER"
     * @param event
     * @param newRating selected star value
     */
    onKeydown(event, newRating) {
        if (event.keyCode === ENTER) {
            this.onRatingChange(newRating);
        }
    }
    /**
     * Used by Angular Forms when the value has been changed externally.
     * @param value The external value set.
     */
    writeValue(value) {
        // Only accept the value if it exists and is a number.
        if (value !== null && value !== undefined && typeof value === 'number') {
            this.rating = value;
        }
    }
    /**
     * Used by Angular Forms to give us a function to call when the value has been
     * changed internally to the component.
     * @param fn The function to call with the new value.
     */
    registerOnChange(fn) {
        this._changePropagation = fn;
    }
    /**
     * Used by Angular Forms to give us a function to call when the component has been
     * "touched". This is not used for ratings, so we will do nothing with it.
     */
    registerOnTouched() { }
};
CngRatingComponent.ɵfac = function CngRatingComponent_Factory(t) { return new (t || CngRatingComponent)(); };
CngRatingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngRatingComponent, selectors: [["cng-rating"]], inputs: { color: "color", size: "size", starStyle: "starStyle", clickable: "clickable", totalStars: "totalStars", showHalf: "showHalf", halfThreshold: "halfThreshold" }, outputs: { onRatingChanged: "onRatingChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CngRatingComponent_1),
                multi: true
            },
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 9, consts: [[1, "rating", 3, "ngClass"], [1, "rating__stars", 3, "ngClass"], [4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "rating__star", 3, "ngClass", "title", "click", "keydown"], [3, "ngClass"]], template: function CngRatingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, CngRatingComponent_ng_container_2_Template, 7, 25, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(3, _c46, ctx.color === "alt", ctx.size === "small", ctx.size === "large"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c47, !ctx.clickable));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.stars);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, GetStarTitlePipe, IsHalfPipe, IsActivePipe]; }, styles: [".inactive[_ngcontent-%COMP%]{pointer-events:none}"] });
__decorate([
    Output()
], CngRatingComponent.prototype, "onRatingChanged", void 0);
__decorate([
    Input()
], CngRatingComponent.prototype, "color", void 0);
__decorate([
    Input()
], CngRatingComponent.prototype, "size", void 0);
__decorate([
    Input()
], CngRatingComponent.prototype, "starStyle", void 0);
__decorate([
    Input()
], CngRatingComponent.prototype, "clickable", void 0);
__decorate([
    Input()
], CngRatingComponent.prototype, "totalStars", null);
__decorate([
    Input()
], CngRatingComponent.prototype, "showHalf", null);
__decorate([
    Input()
], CngRatingComponent.prototype, "halfThreshold", null);

/**
 * Helper pipe for CNG-Rating that localizes the star tooltip text.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/rating</example-url>
 */
let GetStarTitlePipe = class GetStarTitlePipe {
    /**
     * Transforms the piped content.
     * @param star The star number to transform.
     * @returns Text to display in the star tooltip.
     */
    transform(star) {
        if (star > 1) {
            return $localize `${star} stars`;
        }
        return $localize `${star} star`;
    }
};
GetStarTitlePipe.ɵfac = function GetStarTitlePipe_Factory(t) { return new (t || GetStarTitlePipe)(); };
GetStarTitlePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "getTitle", type: GetStarTitlePipe, pure: true });

let IsHalfPipe = class IsHalfPipe {
    transform(star, rating, threshold) {
        // Get fractional portion of star
        const diff = rating - star + 1;
        if (!(diff > 0) || !(diff < 1)) {
            return false;
        }
        if (Math.abs(0.5 - diff) <= threshold) {
            return true;
        }
        return false;
    }
};
IsHalfPipe.ɵfac = function IsHalfPipe_Factory(t) { return new (t || IsHalfPipe)(); };
IsHalfPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "isHalf", type: IsHalfPipe, pure: true });

let IsActivePipe = class IsActivePipe {
    transform(star, rating, rounding, threshold = 0) {
        if (!rounding) {
            return rating >= star;
        }
        // Highlight star if at least high enough for 1/2 star
        return rating >= star - 0.5 - threshold;
    }
};
IsActivePipe.ɵfac = function IsActivePipe_Factory(t) { return new (t || IsActivePipe)(); };
IsActivePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "isActive", type: IsActivePipe, pure: true });

let CngRatingModule = class CngRatingModule {
};
CngRatingModule.ɵfac = function CngRatingModule_Factory(t) { return new (t || CngRatingModule)(); };
CngRatingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngRatingModule });
CngRatingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/toast</example-url>
 */
let CngToastIconComponent = class CngToastIconComponent {
};
CngToastIconComponent.ɵfac = function CngToastIconComponent_Factory(t) { return new (t || CngToastIconComponent)(); };
CngToastIconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngToastIconComponent, selectors: [["cng-toast-icon"]], viewQuery: function CngToastIconComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngToastIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngToastIconComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
__decorate([
    ViewChild(TemplateRef, { static: true })
], CngToastIconComponent.prototype, "content", void 0);

// import { TemplateRef } from '@angular/core';
var CngToastPadding;
(function (CngToastPadding) {
    CngToastPadding["COMPRESSED"] = "compressed";
    CngToastPadding["LOOSE"] = "loose";
    CngToastPadding["REGULAR"] = "regular";
})(CngToastPadding || (CngToastPadding = {}));
var CngToastSeverity;
(function (CngToastSeverity) {
    CngToastSeverity["DANGER"] = "danger";
    CngToastSeverity["INFO"] = "info";
    CngToastSeverity["SUCCESS"] = "success";
    CngToastSeverity["WARNING"] = "warning";
})(CngToastSeverity || (CngToastSeverity = {}));
/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/toast</example-url>
 */
class CngToastOptions {
    constructor(padding, severity, ttl) {
        /**
         * Toast padding (regular, compressed, loose)
         */
        this.padding = CngToastPadding.REGULAR;
        /**
         * Toast severity (info, success, warning, danger)
         */
        this.severity = CngToastSeverity.INFO;
        this.padding = padding ? padding : this.padding;
        this.severity = severity ? severity : this.severity;
        this.ttl = ttl;
    }
}

/**
 * A single toast card, with title, content, and optional image icon/close icon
 * NOTE: You will typically never need to use this component directly. See cng-toast.service.ts
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/toast</example-url>
 */
let CngToastComponent = class CngToastComponent {
    constructor() {
        /** Options for the toast, such as padding/severity */
        this.opts = new CngToastOptions();
        /** Whether to show/hide close button */
        this.showClose = true;
        /** Whether to show/hide icon */
        this.showIcon = true;
        /** Notify when close is clicked */
        this.close = new EventEmitter();
    }
    ngOnInit() {
    }
    onClose() {
        this.close.next();
    }
};
CngToastComponent.ɵfac = function CngToastComponent_Factory(t) { return new (t || CngToastComponent)(); };
CngToastComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngToastComponent, selectors: [["cng-toast"]], contentQueries: function CngToastComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngToastIconComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customIcon = _t.first);
    } }, inputs: { opts: "opts", showClose: "showClose", showIcon: "showIcon" }, outputs: { close: "close" }, ngContentSelectors: _c50, decls: 10, vars: 5, consts: [[4, "ngIf"], [1, "toast__body"], [1, "toast__title"], ["href", "javascript:;", "class", "toast__close icon-close", 3, "click", 4, "ngIf"], ["defaultIconTmpl", ""], [4, "ngIf", "ngIfElse"], [1, "toast__icon"], [4, "ngTemplateOutlet"], ["href", "javascript:;", 1, "toast__close", "icon-close", 3, "click"], [3, "ngClass"]], template: function CngToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c49);
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, CngToastComponent_ng_container_1_Template, 2, 2, "ng-container", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(7, CngToastComponent_a_7_Template, 1, 0, "a", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, CngToastComponent_ng_template_8_Template, 1, 9, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("toast toast--", ctx.opts.padding, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showIcon);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClose);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: [".toast__close[_ngcontent-%COMP%]{position:absolute;top:.25rem;right:.375rem}"] });
__decorate([
    Input()
], CngToastComponent.prototype, "opts", void 0);
__decorate([
    Input()
], CngToastComponent.prototype, "showClose", void 0);
__decorate([
    Input()
], CngToastComponent.prototype, "showIcon", void 0);
__decorate([
    ContentChild(CngToastIconComponent)
], CngToastComponent.prototype, "customIcon", void 0);
__decorate([
    Output()
], CngToastComponent.prototype, "close", void 0);

var CngToastPosition;
(function (CngToastPosition) {
    CngToastPosition["TOP"] = "top";
    CngToastPosition["BOTTOM"] = "bottom";
})(CngToastPosition || (CngToastPosition = {}));
/**
 * Global configuration for CngToast module. Provide this in the forRoot()
 * when importing the CngToastModule with any custom values you like
 */
let CngToastConfiguration = class CngToastConfiguration {
};
CngToastConfiguration.ɵfac = function CngToastConfiguration_Factory(t) { return new (t || CngToastConfiguration)(); };
CngToastConfiguration.ɵprov = ɵɵdefineInjectable({ factory: function CngToastConfiguration_Factory() { return new CngToastConfiguration(); }, token: CngToastConfiguration, providedIn: "root" });
const CngToastConfigurationDefaults = {
    position: CngToastPosition.BOTTOM,
    maxToasts: 3,
    ttl: null,
};

/**
 * A simple wrapper around the CngToasterComponent. This is dynamically created
 * by the cng-toast.service. This is necessary to prevent a circular dependency
 * between that service and the CngToasterComponent
 *
 * It also handles injecting the CngToastConfiguration and providing those options
 * to the cng-toaster
 */
let CngToasterWrapperComponent = class CngToasterWrapperComponent {
    constructor(config) {
        this.config = config;
    }
    ngOnInit() {
    }
};
CngToasterWrapperComponent.ɵfac = function CngToasterWrapperComponent_Factory(t) { return new (t || CngToasterWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(CngToastConfiguration)); };
CngToasterWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngToasterWrapperComponent, selectors: [["cng-toaster-wrapper"]], decls: 1, vars: 2, consts: [[3, "position", "maxToasts"]], template: function CngToasterWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "cng-toaster", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("position", ctx.config.position)("maxToasts", ctx.config.maxToasts);
    } }, dependencies: function () { return [CngToasterComponent]; }, encapsulation: 2 });
CngToasterWrapperComponent.ctorParameters = () => [
    { type: CngToastConfiguration }
];

/**
 * A service for app-wide toast alert messages.
 * Simply inject the CngToastModule in your app root, optionally providing
 * options via forRoot(). Then inject this service anywhere and call
 * addToast/removeToast to add and remove toasts.
 * addToast will return a reference to the created toast. You can use this reference
 * to subsequently close that toast in your own code, or to listen for when it closes.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/toast</example-url>
 */
let CngToastService = class CngToastService {
    constructor(appRef, _globalConfig, componentFactoryResolver, injector) {
        this.appRef = appRef;
        this._globalConfig = _globalConfig;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this._nextToast$ = new Subject();
        this._removeToast$ = new Subject();
    }
    get nextToast$() {
        return this._nextToast$.asObservable();
    }
    get removeToast$() {
        return this._removeToast$.asObservable();
    }
    /** If the toast outlet component doesn't exist yet, dynamically create one */
    initToastOutlet() {
        // 1. Create CngToasterWrapperComponent
        this._toastRef = this.componentFactoryResolver
            .resolveComponentFactory(CngToasterWrapperComponent)
            .create(this.injector);
        // 2. Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(this._toastRef.hostView);
        this._toastRef.changeDetectorRef.detectChanges();
        // 3. Get DOM element from component
        const domElem = this._toastRef.hostView
            .rootNodes[0];
        // 4. Append DOM element to the body
        document.querySelector('body').appendChild(domElem);
    }
    /** If TTL is provided, create a sub to count down and delete it after TTL ms
     * @param toast the Toast of interest
     */
    subToDelete(toast) {
        timer(0, 50)
            .pipe(takeWhile(() => toast.options.ttl > 0), takeUntil(toast.onClose$), finalize(() => {
            toast.close();
        }))
            .subscribe(() => {
            toast.options.ttl -= 50;
        });
    }
    /** Push a new toast to the cng-toaster outlet component
     * Returns a reference to the new toast. You can use this ref to delete it later.
     * or detect when it has been closed (by user interaction)
     * @param title title of toast, either a plain string or CngContent (templateRef/component/etc)
     * @param body body of toast, either a plain string or CngContent (templateRef/component/etc)
     * @param options various options for the toast, like Severity
     * @returns CngToast reference
     */
    addToast(title, body, options) {
        // Construct options, overriding in this order
        // 1. Defaults
        // 2. Global configurations
        // 3. Provided options in the call
        const config = Object.assign(Object.assign(Object.assign({}, new CngToastOptions()), { ttl: this._globalConfig.ttl }), options);
        if (!this._toastRef) {
            this.initToastOutlet();
        }
        let finalTitle;
        let finalBody;
        if (typeof title === 'string') {
            finalTitle = {
                type: CngContentConfigType.TEXT,
                content: title,
            };
        }
        else {
            finalTitle = title;
        }
        if (typeof body === 'string') {
            finalBody = {
                type: CngContentConfigType.TEXT,
                content: body,
            };
        }
        else {
            finalBody = body;
        }
        const onClose$ = new Subject();
        const newToast = {
            onClose$: onClose$.asObservable(),
            options: config,
            title: finalTitle,
            body: finalBody,
            close: () => {
                this.removeToast(newToast);
                onClose$.next();
            },
        };
        if (newToast.options.ttl) {
            this.subToDelete(newToast);
        }
        this._nextToast$.next(newToast);
        return newToast;
    }
    /**
     * Remove the provided toast reference from the outlet.
     * @param toast the Toast to remove
     */
    removeToast(toast) {
        this._removeToast$.next(toast);
    }
};
CngToastService.ɵfac = function CngToastService_Factory(t) { return new (t || CngToastService)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(CngToastConfiguration), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
CngToastService.ctorParameters = () => [
    { type: ApplicationRef },
    { type: CngToastConfiguration },
    { type: ComponentFactoryResolver },
    { type: Injector }
];
CngToastService.ɵprov = ɵɵdefineInjectable({ factory: function CngToastService_Factory() { return new CngToastService(ɵɵinject(ApplicationRef), ɵɵinject(CngToastConfiguration), ɵɵinject(ComponentFactoryResolver), ɵɵinject(INJECTOR)); }, token: CngToastService, providedIn: "root" });

/**
 * Component for displaying dynamic toast messages
 * NOTE: You should basically never need to use this component directly
 * Instead you should inject the CngToastService and call its functions to push
 * or remove toasts. It will handle dynamically creating this component for you.
 */
let CngToasterComponent = class CngToasterComponent {
    constructor(toastService) {
        this.toastService = toastService;
        this.position = CngToastPosition.BOTTOM;
        this.maxToasts = 3;
        this.toasts = [];
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.toastService.nextToast$
            .pipe(takeUntil(this.destroy$))
            .subscribe(toast => {
            this.toasts.push(toast);
            if (this.toasts.length > this.maxToasts) {
                this.toasts[0].close();
            }
        });
        this.toastService.removeToast$
            .pipe(takeUntil(this.destroy$))
            .subscribe(toast => {
            this.toasts = this.toasts.filter(item => item !== toast);
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
    onClose(toast) {
        toast.close();
    }
};
CngToasterComponent.ɵfac = function CngToasterComponent_Factory(t) { return new (t || CngToasterComponent)(ɵngcc0.ɵɵdirectiveInject(CngToastService)); };
CngToasterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngToasterComponent, selectors: [["cng-toaster"]], inputs: { position: "position", maxToasts: "maxToasts" }, decls: 2, vars: 4, consts: [["class", "base-margin-top", 4, "ngFor", "ngForOf"], [1, "base-margin-top"], ["role", "alert", "aria-live", "polite", 3, "opts", "close"], ["toast-title", ""], [3, "config"], ["toast-body", ""]], template: function CngToasterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, CngToasterComponent_div_1_Template, 6, 4, "div", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("cui-toasts ", ctx.position, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.toasts);
    } }, dependencies: [ɵngcc1.NgForOf, CngContentComponent, CngToastComponent], styles: [".cui-toasts[_ngcontent-%COMP%]{position:fixed!important;right:var(--cui-spacing);bottom:var(--cui-spacing);width:300px;z-index:2000}.cui-toasts.bottom[_ngcontent-%COMP%]{bottom:var(--cui-spacing)}.cui-toasts.top[_ngcontent-%COMP%]{top:var(--cui-spacing);bottom:unset}"], data: { animation: [
            trigger('toastAnimation', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('500ms', style({ opacity: 1 })),
                ]),
                transition(':leave', [
                    style({ opacity: 1 }),
                    animate('500ms', style({ opacity: 0 })),
                ]),
            ]),
        ] } });
CngToasterComponent.ctorParameters = () => [
    { type: CngToastService }
];
__decorate([
    Input()
], CngToasterComponent.prototype, "position", void 0);
__decorate([
    Input()
], CngToasterComponent.prototype, "maxToasts", void 0);

var CngToastModule_1;
let CngToastModule = CngToastModule_1 = class CngToastModule {
    static forRoot(config) {
        return {
            ngModule: CngToastModule_1,
            providers: [
                {
                    provide: CngToastConfiguration,
                    useValue: Object.assign(Object.assign({}, CngToastConfigurationDefaults), config),
                },
                CngToastService,
            ],
        };
    }
};
CngToastModule.ɵfac = function CngToastModule_Factory(t) { return new (t || CngToastModule)(); };
CngToastModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngToastModule });
CngToastModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        CngContentModule] });

let CngDropdownItemComponent = class CngDropdownItemComponent {
    constructor() {
        this.selected = false;
        this.click = new EventEmitter();
        this.active = false;
    }
    ngOnInit() {
    }
    setActiveStyles() {
        this.active = true;
    }
    setInactiveStyles() {
        this.active = false;
    }
};
CngDropdownItemComponent.ɵfac = function CngDropdownItemComponent_Factory(t) { return new (t || CngDropdownItemComponent)(); };
CngDropdownItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngDropdownItemComponent, selectors: [["cng-dropdown-item"]], viewQuery: function CngDropdownItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { selected: "selected", overrideHeight: "overrideHeight" }, outputs: { click: "click" }, ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngDropdownItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngDropdownItemComponent_ng_template_0_Template, 1, 0, "ng-template");
    } } });
__decorate([
    Input()
], CngDropdownItemComponent.prototype, "selected", void 0);
__decorate([
    Input()
], CngDropdownItemComponent.prototype, "overrideHeight", void 0);
__decorate([
    Output()
], CngDropdownItemComponent.prototype, "click", void 0);
__decorate([
    ViewChild(TemplateRef, { static: true })
], CngDropdownItemComponent.prototype, "template", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/dropdown</example-url>
 */
let CngDropdownGroupComponent = class CngDropdownGroupComponent {
    constructor() { }
    ngOnInit() {
    }
};
CngDropdownGroupComponent.ɵfac = function CngDropdownGroupComponent_Factory(t) { return new (t || CngDropdownGroupComponent)(); };
CngDropdownGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngDropdownGroupComponent, selectors: [["cng-dropdown-group"]], contentQueries: function CngDropdownGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngDropdownItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, viewQuery: function CngDropdownGroupComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { header: "header" }, ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngDropdownGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngDropdownGroupComponent_ng_template_0_Template, 1, 0, "ng-template");
    } } });
__decorate([
    ContentChildren(CngDropdownItemComponent)
], CngDropdownGroupComponent.prototype, "items", void 0);
__decorate([
    Input()
], CngDropdownGroupComponent.prototype, "header", void 0);
__decorate([
    ViewChild(TemplateRef, { static: true })
], CngDropdownGroupComponent.prototype, "template", void 0);

var CngDropdownDirection;
(function (CngDropdownDirection) {
    CngDropdownDirection["LEFT"] = "left";
    CngDropdownDirection["RIGHT"] = "";
    CngDropdownDirection["CENTER"] = "center";
})(CngDropdownDirection || (CngDropdownDirection = {}));
let CngDropdownWrapperComponent = class CngDropdownWrapperComponent {
    constructor(elem, renderer) {
        this.elem = elem;
        this.renderer = renderer;
        this.active = false;
        this.direction = CngDropdownDirection.RIGHT;
        this.activeChange = new EventEmitter();
        this.destroyed$ = new Subject();
    }
    ngAfterViewInit() {
        const triggerElem = (this.triggerVcr
            .createEmbeddedView(this.trigger)).rootNodes[0];
        this.clickUnlisten = this.renderer.listen(triggerElem, 'click', () => {
            this.active = !this.active;
            this.activeChange.emit(this.active);
        });
        this.keydownUnlisten = this.renderer.listen(triggerElem, 'keydown', (event) => {
            if (!this.active
                && (event.keyCode === ENTER
                    || event.keyCode === SPACE
                    || event.keyCode === DOWN_ARROW)) {
                event.preventDefault();
                this.active = !this.active;
                this.activeChange.emit(this.active);
            }
            else if (this.active) {
                this.dropdownComp.onDropdownKeydown(event);
            }
        });
        merge(this.dropdownComp.escaped, this.dropdownComp.itemSelected)
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => {
            this.active = false;
            this.activeChange.emit(this.active);
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
        if (this.clickUnlisten) {
            this.clickUnlisten();
        }
        if (this.keydownUnlisten) {
            this.keydownUnlisten();
        }
    }
    onClickOutside(event) {
        if (!this.elem.nativeElement.contains(event.target)) {
            this.active = false;
            this.activeChange.emit(this.active);
        }
    }
};
CngDropdownWrapperComponent.ɵfac = function CngDropdownWrapperComponent_Factory(t) { return new (t || CngDropdownWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
CngDropdownWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngDropdownWrapperComponent, selectors: [["cng-dropdown-wrapper"]], viewQuery: function CngDropdownWrapperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c51, 5, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.triggerVcr = _t.first);
    } }, inputs: { direction: "direction", trigger: "trigger", dropdownComp: "dropdownComp" }, outputs: { activeChange: "activeChange" }, decls: 5, vars: 6, consts: [[1, "dropdown", "ignore", 3, "ngClass"], ["triggerContainer", ""], [1, "dropdown__menu", 3, "cngClickedOutside"], [4, "ngTemplateOutlet"]], template: function CngDropdownWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, CngDropdownWrapperComponent_ng_template_1_Template, 0, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵlistener("cngClickedOutside", function CngDropdownWrapperComponent_Template_div_cngClickedOutside_3_listener($event) { return ctx.onClickOutside($event); });
        ɵngcc0.ɵɵtemplate(4, CngDropdownWrapperComponent_ng_container_4_Template, 1, 0, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(2, _c52, ctx.active, ctx.direction === "center", ctx.direction === "left"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.dropdownComp == null ? null : ctx.dropdownComp.dropdownTmpl);
    } }, dependencies: [CngClickedOutsideDirective, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]   .dropdown__menu[_ngcontent-%COMP%]{z-index:10000}"] });
CngDropdownWrapperComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
__decorate([
    Input()
], CngDropdownWrapperComponent.prototype, "trigger", void 0);
__decorate([
    Input()
], CngDropdownWrapperComponent.prototype, "dropdownComp", void 0);
__decorate([
    Input()
], CngDropdownWrapperComponent.prototype, "direction", void 0);
__decorate([
    Output()
], CngDropdownWrapperComponent.prototype, "activeChange", void 0);
__decorate([
    ViewChild('triggerContainer', { read: ViewContainerRef })
], CngDropdownWrapperComponent.prototype, "triggerVcr", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/dropdown</example-url>
 */
let CngDropdownTriggerForDirective = class CngDropdownTriggerForDirective {
    constructor(cdr, templateRef, viewContainerRef, componentFactoryResolver) {
        this.cdr = cdr;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.destroyed$ = new Subject();
        this.wrapperInitialized$ = new Subject();
    }
    set cngDropdownTriggerForActiveSubject(active) {
        this._activeSubject = active;
    }
    set cngDropdownTriggerForDirection(direction) {
        this._setWrapperField('direction', direction);
    }
    set cngDropdownTriggerFor(comp) {
        this._triggerForComponent = comp;
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    ngOnInit() {
        const containerFactory = this.componentFactoryResolver
            .resolveComponentFactory(CngDropdownWrapperComponent);
        this._wrapper = this.viewContainerRef.createComponent(containerFactory);
        this._wrapper.instance.trigger = this.templateRef;
        this._wrapper.instance.dropdownComp = this._triggerForComponent;
        this._wrapper.instance.activeChange
            .pipe(takeUntil(this.destroyed$))
            .subscribe(this._onActiveChange.bind(this));
        this.wrapperInitialized$.next();
        this.cdr.detectChanges();
    }
    get active() {
        return this._wrapper && this._wrapper.instance.active;
    }
    set active(active) {
        this._setWrapperField('active', active);
    }
    _onActiveChange(active) {
        if (this._activeSubject) {
            this._activeSubject.next(active);
        }
    }
    _setWrapperField(field, value) {
        if (this._wrapper) {
            this._wrapper.instance[field] = value;
        }
        else {
            this.wrapperInitialized$
                .pipe(take(1))
                .subscribe(() => {
                this._wrapper.instance[field] = value;
            });
        }
    }
};
CngDropdownTriggerForDirective.ɵfac = function CngDropdownTriggerForDirective_Factory(t) { return new (t || CngDropdownTriggerForDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
CngDropdownTriggerForDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngDropdownTriggerForDirective, selectors: [["", "cngDropdownTriggerFor", ""]], inputs: { cngDropdownTriggerForActiveSubject: "cngDropdownTriggerForActiveSubject", cngDropdownTriggerForDirection: "cngDropdownTriggerForDirection", cngDropdownTriggerFor: "cngDropdownTriggerFor" } });
CngDropdownTriggerForDirective.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
__decorate([
    Input()
], CngDropdownTriggerForDirective.prototype, "cngDropdownTriggerForActiveSubject", null);
__decorate([
    Input()
], CngDropdownTriggerForDirective.prototype, "cngDropdownTriggerForDirection", null);
__decorate([
    Input('cngDropdownTriggerFor')
], CngDropdownTriggerForDirective.prototype, "cngDropdownTriggerFor", null);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/dropdown</example-url>
 */
let CngDropdownComponent = class CngDropdownComponent {
    constructor(elem) {
        this.elem = elem;
        this.itemSelected = new EventEmitter();
        this.escaped = new EventEmitter();
        this.viewInit = new EventEmitter();
        this.destroyed$ = new Subject();
        this.kmReset$ = new Subject();
    }
    ngAfterViewInit() {
        this._resetKeyManager(this.items.toArray(), this.groups.toArray());
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    onItemClick(item) {
        item.click.emit();
        this.itemSelected.emit();
    }
    // Create a new key manager whenever the items change
    _resetKeyManager(items, groups) {
        // make a flat list of the grouped options
        const groupedItemsFlat = groups.map(group => group.items.toArray())
            .reduce((memo, itemArray) => memo.concat(itemArray), []);
        const allItems = [
            ...items,
            ...groupedItemsFlat,
        ];
        this.kmReset$.next();
        this._keyManager = new ActiveDescendantKeyManager(allItems).withWrap();
        // Listen for tabbing out of focus
        this._keyManager.tabOut.pipe(takeUntil(this.destroyed$), takeUntil(this.kmReset$))
            .subscribe(() => {
            this.escaped.emit();
        });
    }
    /**
     * Handles keyboard events
     * @param event - KeyboardEvent
     */
    onDropdownKeydown(event) {
        if ((event.keyCode === ENTER || event.keyCode === SPACE) && this._keyManager.activeItem) {
            event.preventDefault();
            this.onItemClick(this._keyManager.activeItem);
            this._keyManager.setActiveItem(null);
        }
        else if (event.keyCode === ESCAPE) {
            event.preventDefault();
            this.escaped.emit();
            this._keyManager.setActiveItem(null);
        }
        else {
            this._keyManager.onKeydown(event);
        }
    }
};
CngDropdownComponent.ɵfac = function CngDropdownComponent_Factory(t) { return new (t || CngDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngDropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngDropdownComponent, selectors: [["cng-dropdown"]], contentQueries: function CngDropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngDropdownItemComponent, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngDropdownGroupComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.groups = _t);
    } }, viewQuery: function CngDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c53, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownTmpl = _t.first);
    } }, outputs: { itemSelected: "itemSelected", escaped: "escaped", viewInit: "viewInit" }, decls: 2, vars: 0, consts: [["dropdown", ""], [4, "ngFor", "ngForOf"], [3, "ngClass", "ngStyle", "click"], [4, "ngTemplateOutlet"], ["class", "dropdown__group-header", 3, "innerText", 4, "ngIf"], ["class", "divider", 4, "ngIf"], [1, "dropdown__group-header", 3, "innerText"], [1, "divider"]], template: function CngDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CngDropdownComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgStyle], styles: ["a.focused[_ngcontent-%COMP%]{color:var(--cui-active-color)!important;background:var(--cui-background-hover)!important;text-decoration:none!important}"] });
CngDropdownComponent.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Output()
], CngDropdownComponent.prototype, "itemSelected", void 0);
__decorate([
    Output()
], CngDropdownComponent.prototype, "escaped", void 0);
__decorate([
    Output()
], CngDropdownComponent.prototype, "viewInit", void 0);
__decorate([
    ContentChildren(CngDropdownItemComponent)
], CngDropdownComponent.prototype, "items", void 0);
__decorate([
    ContentChildren(CngDropdownGroupComponent)
], CngDropdownComponent.prototype, "groups", void 0);
__decorate([
    ViewChild('dropdown')
], CngDropdownComponent.prototype, "dropdownTmpl", void 0);

let CngDropdownModule = class CngDropdownModule {
};
CngDropdownModule.ɵfac = function CngDropdownModule_Factory(t) { return new (t || CngDropdownModule)(); };
CngDropdownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngDropdownModule });
CngDropdownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CngClickedOutsideModule,
        CommonModule] });

var ThemeType;
(function (ThemeType) {
    ThemeType["LIGHT"] = "default";
    ThemeType["DARK"] = "dark";
})(ThemeType || (ThemeType = {}));
let CngThemePickerDirective = class CngThemePickerDirective {
    constructor(doc, renderer) {
        this.doc = doc;
        this.renderer = renderer;
        this.currentTheme = ThemeType.LIGHT;
    }
    /**
     * Set data-theme attribute based on the currentTheme input
     */
    onThemeChange() {
        if (this.currentTheme === ThemeType.DARK) {
            this.renderer.setAttribute(this.doc.body, 'data-theme', ThemeType.DARK);
        }
        else {
            this.renderer.setAttribute(this.doc.body, 'data-theme', ThemeType.LIGHT);
        }
    }
    /**
     * Any time the input changes, check the value and change the body data-theme attribute
     * accordingly
     */
    ngOnChanges() {
        this.onThemeChange();
    }
};
CngThemePickerDirective.ɵfac = function CngThemePickerDirective_Factory(t) { return new (t || CngThemePickerDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
CngThemePickerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngThemePickerDirective, selectors: [["", "cngThemePicker", ""]], inputs: { currentTheme: "currentTheme" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
CngThemePickerDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
__decorate([
    Input()
], CngThemePickerDirective.prototype, "currentTheme", void 0);
CngThemePickerDirective = __decorate([ __param(0, Inject(DOCUMENT))
], CngThemePickerDirective);

let CngThemePickerModule = class CngThemePickerModule {
};
CngThemePickerModule.ɵfac = function CngThemePickerModule_Factory(t) { return new (t || CngThemePickerModule)(); };
CngThemePickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngThemePickerModule });
CngThemePickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CngDropdownModule,
        CommonModule] });

const SCROLL_PIXEL_OFFSET = 2;
/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/form-field</example-url>
 */
let CngInputDirective = class CngInputDirective {
    constructor(control, elementRef, renderer) {
        this.control = control;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this._autoresize = false;
        this._destroy$ = new Subject();
        this.maxHeight = 500;
    }
    get resizeClass() {
        return this._autoresize ? 'unset' : '1';
    }
    onInput() {
        // Listen on a plain textarea for resize
        // Ignore this input event if there's an Angular FormControl attached
        // We will be listening to its change events instead
        if (!this.control && this.elementRef.nativeElement.localName === 'textarea') {
            this._adjust();
        }
    }
    set autoresize(value) {
        this._autoresize = coerceBooleanProperty(value);
    }
    _adjust() {
        const nativeElement = this.elementRef.nativeElement;
        if (this._autoresize) {
            this.renderer.setStyle(nativeElement, 'overflow', 'hidden');
            this.renderer.setStyle(nativeElement, 'height', 'auto');
            if (nativeElement.scrollHeight < this.maxHeight) {
                this.renderer.setStyle(nativeElement, 'height', `${nativeElement.scrollHeight + SCROLL_PIXEL_OFFSET}px`);
            }
            else {
                this.renderer.setStyle(nativeElement, 'height', `${this.maxHeight}px`);
            }
            this.renderer.setStyle(nativeElement, 'overflow', 'auto');
        }
    }
    onFocus() {
        this.focused = true;
    }
    onBlur() {
        this.focused = false;
    }
    ngOnInit() {
        if (this.elementRef.nativeElement.localName === 'textarea') {
            this._adjust();
        }
        if (this.control) {
            this.control.valueChanges
                .pipe(takeUntil(this._destroy$))
                .subscribe(() => {
                if (this.elementRef.nativeElement.localName === 'textarea') {
                    this._adjust();
                }
            });
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
    }
};
CngInputDirective.ɵfac = function CngInputDirective_Factory(t) { return new (t || CngInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
CngInputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngInputDirective, selectors: [["", "cngInput", ""]], hostVars: 2, hostBindings: function CngInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function CngInputDirective_focus_HostBindingHandler() { return ctx.onFocus(); })("input", function CngInputDirective_input_HostBindingHandler() { return ctx.onInput(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("flex", ctx.resizeClass);
    } }, inputs: { maxHeight: "maxHeight", autoresize: "autoresize" } });
CngInputDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }] },
    { type: ElementRef },
    { type: Renderer2 }
];
__decorate([
    Input()
], CngInputDirective.prototype, "maxHeight", void 0);
__decorate([
    HostBinding('style.flex')
], CngInputDirective.prototype, "resizeClass", null);
__decorate([
    HostListener('input')
], CngInputDirective.prototype, "onInput", null);
__decorate([
    Input()
], CngInputDirective.prototype, "autoresize", null);
CngInputDirective = __decorate([ __param(0, Optional())
], CngInputDirective);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/form-field</example-url>
 */
let CngFormFieldComponent = class CngFormFieldComponent {
    constructor() {
        this._hasError = false;
        this._destroyed$ = new Subject();
    }
    get hasIcon() {
        return this.icon;
    }
    get hasErrorClass() {
        if (this._hasError) {
            return this._hasError;
        }
        return this.input.control
            && this.input.control.touched
            && this.input.control.errors;
    }
    get hasError() {
        return this._hasError;
    }
    set hasError(hasError) {
        this._hasError = hasError;
    }
    set inline(value) {
        this._inline = coerceBooleanProperty(value);
    }
    set horizontal(value) {
        this._horizontal = coerceBooleanProperty(value);
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
    ngAfterContentInit() {
        if (!this.input) {
            throw new Error('CngInputDirective not found inside CngFormFieldComponent.' +
                ' Did you forget to add the cngInput attribute?');
        }
    }
};
CngFormFieldComponent.ɵfac = function CngFormFieldComponent_Factory(t) { return new (t || CngFormFieldComponent)(); };
CngFormFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngFormFieldComponent, selectors: [["cng-form-field"]], contentQueries: function CngFormFieldComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngInputDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostAttrs: [1, "form-group"], hostVars: 8, hostBindings: function CngFormFieldComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("input--icon", ctx.hasIcon)("form-group--error", ctx.hasErrorClass)("form-group--inline", ctx._inline)("form-group--horizontal", ctx._horizontal);
    } }, inputs: { hasError: "hasError", inline: "inline", horizontal: "horizontal", icon: "icon" }, ngContentSelectors: _c57, decls: 6, vars: 1, consts: [[1, "form-group__text"], ["type", "button", "class", "link", "tabindex", "-1", 4, "ngIf"], [1, "form-group__help"], ["type", "button", "tabindex", "-1", 1, "link"]], template: function CngFormFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c56);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵtemplate(3, CngFormFieldComponent_button_3_Template, 2, 2, "button", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵprojection(5, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
    } }, dependencies: [ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]{display:block}"] });
__decorate([
    ContentChild(CngInputDirective)
], CngFormFieldComponent.prototype, "input", void 0);
__decorate([
    Input()
], CngFormFieldComponent.prototype, "icon", void 0);
__decorate([
    HostBinding('class.input--icon')
], CngFormFieldComponent.prototype, "hasIcon", null);
__decorate([
    HostBinding('class.form-group--error')
], CngFormFieldComponent.prototype, "hasErrorClass", null);
__decorate([
    Input()
], CngFormFieldComponent.prototype, "hasError", null);
__decorate([
    HostBinding('class.form-group--inline')
], CngFormFieldComponent.prototype, "_inline", void 0);
__decorate([
    Input()
], CngFormFieldComponent.prototype, "inline", null);
__decorate([
    HostBinding('class.form-group--horizontal')
], CngFormFieldComponent.prototype, "_horizontal", void 0);
__decorate([
    Input()
], CngFormFieldComponent.prototype, "horizontal", null);

let CngFormFieldModule = class CngFormFieldModule {
};
CngFormFieldModule.ɵfac = function CngFormFieldModule_Factory(t) { return new (t || CngFormFieldModule)(); };
CngFormFieldModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngFormFieldModule });
CngFormFieldModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/grid</example-url>
 */
let CngGridItemComponent = class CngGridItemComponent {
    constructor() {
        this._card = false;
    }
    get card() {
        return this._card;
    }
    set card(card) {
        this._card = coerceBooleanProperty(card);
    }
    get classes() {
        return this._card ? 'panel panel--bordered panel--raised panel--loose' : '';
    }
    ngOnInit() {
    }
};
CngGridItemComponent.ɵfac = function CngGridItemComponent_Factory(t) { return new (t || CngGridItemComponent)(); };
CngGridItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngGridItemComponent, selectors: [["cng-grid-item"]], viewQuery: function CngGridItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, hostVars: 2, hostBindings: function CngGridItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.classes);
    } }, inputs: { card: "card", value: "value" }, ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngGridItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngGridItemComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
__decorate([
    Input()
], CngGridItemComponent.prototype, "card", null);
__decorate([
    Input()
], CngGridItemComponent.prototype, "value", void 0);
__decorate([
    HostBinding('class')
], CngGridItemComponent.prototype, "classes", null);
__decorate([
    ViewChild(TemplateRef)
], CngGridItemComponent.prototype, "content", void 0);

/**
 * A grid/card based view. Often used as an alternate view to a table.
 * Supports optional selection ability which integrates with Angular cdk's SelectionModel
 * There are 2 main ways to use this component:
 * 1. Adding manual items with content children
 * <cng-grid>
 * 	<cng-grid-item></cng-grid-item>
 * </cng-grid>
 * 2. Using a data source (can be an array, obervable or DataSource, like with the table)
 * <cng-grid [dataSource]="source">
 * 	<ng-template></ng-template>
 * </cng-grid>
 * Where ng-template defines the template for every item
 * Generally you should use the second approach for more complex situations
 * The first is a convenince thing for simple grid layouts
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/grid</example-url>
 */
let CngGridComponent = class CngGridComponent {
    constructor() {
        // Dummy to fulfill CollectionViewer interface
        this.viewChange = of({ start: 0, end: 0 });
        /** Number of columns per row */
        this.columns = 4;
        /** Minimum Height of a cell (in pixels) */
        this.minHeight = 275;
        /** Specify if dataItems should be cards */
        this.dataCards = false;
    }
    /** Optional data source to feed in from. Use this to do more complex data logic or
     * hook up with an API.
     * See the cngAPIDatasource for contacting an API and using params from the cng-pager etc.
     */
    set dataSource(dataSource) {
        if (this._dataSource !== dataSource) {
            this._switchDataSource(dataSource);
        }
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        if (this._dataSource && isDataSource(this._dataSource)) {
            this._dataSource.disconnect(this);
        }
    }
    /**
     * Determine if data-driven item is selected
     * @param item
     * @returns true/false
     */
    isSelected(item) {
        if (this.selection) {
            return this.selection.isSelected(item);
        }
        return false;
    }
    _switchDataSource(dataSource) {
        // Disconnect from previous source
        if (isDataSource(this._dataSource)) {
            this._dataSource.disconnect(this);
        }
        if (dataSource) {
            this._dataSource = dataSource;
            if (isDataSource(this._dataSource)) {
                this.dataItems$ = this._dataSource.connect(this);
            }
            else if (this._dataSource instanceof Observable) {
                this.dataItems$ = this._dataSource;
            }
            else {
                this.dataItems$ = of(this._dataSource);
            }
        }
        else {
            this._dataSource = [];
            this.dataItems$ = of(this._dataSource);
        }
    }
};
CngGridComponent.ɵfac = function CngGridComponent_Factory(t) { return new (t || CngGridComponent)(); };
CngGridComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngGridComponent, selectors: [["cng-grid"]], contentQueries: function CngGridComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngGridItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dataTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, inputs: { columns: "columns", minHeight: "minHeight", dataCards: "dataCards", dataSource: "dataSource", selection: "selection" }, decls: 3, vars: 13, consts: [[3, "ngClass", "ngStyle", "cngShiftclick", "selectEnabled"], ["class", "grid-item", 3, "ngStyle", "ngClass", "cngClickItem", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "grid-item", 3, "ngStyle", "ngClass", "cngClickItem"], [4, "ngTemplateOutlet"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function CngGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, CngGridComponent_div_1_Template, 2, 9, "div", 1);
        ɵngcc0.ɵɵtemplate(2, CngGridComponent_ng_container_2_Template, 3, 3, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("grid grid--", ctx.columns, "up");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c60, ctx.selection))("ngStyle", ɵngcc0.ɵɵpureFunction1(11, _c61, "repeat(auto-fill, minmax(" + ctx.minHeight + "px, 1fr))"))("cngShiftclick", ctx.selection)("selectEnabled", ctx.selection);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dataItems$);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgStyle, CngShiftclickDirective, CngClickItemDirective, ɵngcc1.AsyncPipe]; }, styles: [".grid[_ngcontent-%COMP%]{grid-gap:var(--cui-spacing-qtr)}.grid-item.selected[_ngcontent-%COMP%]::before{background:var(--cui-theme-primary);opacity:.2;content:'';position:absolute;top:0;right:0;bottom:0;left:0;z-index:10}.panel.panel--bordered.grid-item.selected[_ngcontent-%COMP%]{border:1px solid var(--cui-link-color)}.grid.grid--selectable[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:hover{border:1px solid var(--cui-link-color);cursor:pointer}"] });
__decorate([
    Input()
], CngGridComponent.prototype, "columns", void 0);
__decorate([
    Input()
], CngGridComponent.prototype, "minHeight", void 0);
__decorate([
    Input()
], CngGridComponent.prototype, "selection", void 0);
__decorate([
    Input()
], CngGridComponent.prototype, "dataSource", null);
__decorate([
    Input()
], CngGridComponent.prototype, "dataCards", void 0);
__decorate([
    ContentChild(TemplateRef, { static: true })
], CngGridComponent.prototype, "dataTemplate", void 0);
__decorate([
    ContentChildren(CngGridItemComponent)
], CngGridComponent.prototype, "items", void 0);

/**
 * Apply this directive to every DOM element you want managed by cngShifclick
 * It automatically finds all ContentChildren with this directive and subscribes
 * to 'clicked'
 */
let CngClickItemDirective = class CngClickItemDirective {
    constructor() {
        this._clicked = new Subject();
        /** Prevent default mousedown event, see onMousedown below */
        this.preventDefault = true;
    }
    get clicked() {
        return this._clicked.asObservable();
    }
    onClick(event) {
        this._clicked.next({
            event,
            targetDir: this,
        });
    }
    /** We preventDefault() on the mousedown event so when the user shift-clicks
     * on some DOM elements they don't select all of the text and crap in between
     * You can turn it off with [preventDefault]="false"
     * @param event the mousedown event
     *
     */
    onMousedown(event) {
        if (this.preventDefault) {
            event.preventDefault();
        }
    }
};
CngClickItemDirective.ɵfac = function CngClickItemDirective_Factory(t) { return new (t || CngClickItemDirective)(); };
CngClickItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngClickItemDirective, selectors: [["", "cngClickItem", ""]], hostBindings: function CngClickItemDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CngClickItemDirective_click_HostBindingHandler($event) { return ctx.onClick($event); })("mousedown", function CngClickItemDirective_mousedown_HostBindingHandler($event) { return ctx.onMousedown($event); });
    } }, inputs: { preventDefault: "preventDefault", cngClickItem: "cngClickItem" } });
__decorate([
    Input()
], CngClickItemDirective.prototype, "cngClickItem", void 0);
__decorate([
    Input()
], CngClickItemDirective.prototype, "preventDefault", void 0);
__decorate([
    HostListener('click', ['$event'])
], CngClickItemDirective.prototype, "onClick", null);
__decorate([
    HostListener('mousedown', ['$event'])
], CngClickItemDirective.prototype, "onMousedown", null);

/**
 * A directive for enabling shift-click multi-select functionality on some elements.
 * If a regular click comes in, that element is toggled. If a shift click arrives,
 * every element from the index of the shift-clicked element to the last element
 * regular-clicked (or 0 if there isn't one) is selected (inclusive)
 */
let CngShiftclickDirective = class CngShiftclickDirective {
    constructor() {
        this._destroy$ = new Subject();
        /** Starting index for shift click */
        this._startIndex = 0;
        /** Enable/disable selection with this prop */
        this.selectEnabled = true;
    }
    ngAfterContentInit() {
        this.items.changes.pipe(startWith(null), // Start with null to trigger the pipe for the initial content
        switchMap(() => merge(...this.items.map(item => item.clicked))), takeUntil(this._destroy$))
            .subscribe(event => {
            if (!this.selectEnabled) {
                return;
            }
            const item = event.targetDir.cngClickItem;
            // Handle plain clicks.
            // Start by toggling as normal
            // Set the last clicked as the starting index if the item was just selected
            if (!event.event.shiftKey) {
                this.cngShiftclick.toggle(item);
                if (this.cngShiftclick.isSelected(item)) {
                    this._startIndex = this.items.toArray().findIndex(i => i.cngClickItem === item);
                }
                else {
                    this._startIndex = 0;
                }
            }
            else {
                this.cngShiftclick.clear();
                // Handle shift click. Select all items between last selected
                //  and shift clicked item inclusive
                let endIndex = this.items.toArray().findIndex(i => i.cngClickItem === item);
                // If start > end, swap them
                if (this._startIndex > endIndex) {
                    const temp = this._startIndex;
                    this._startIndex = endIndex;
                    endIndex = temp;
                }
                const arr = this.items.toArray();
                for (let i = this._startIndex; i <= endIndex; i += 1) {
                    this.cngShiftclick.select(arr[i].cngClickItem);
                }
            }
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
    }
};
CngShiftclickDirective.ɵfac = function CngShiftclickDirective_Factory(t) { return new (t || CngShiftclickDirective)(); };
CngShiftclickDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngShiftclickDirective, selectors: [["", "cngShiftclick", ""]], contentQueries: function CngShiftclickDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngClickItemDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, inputs: { selectEnabled: "selectEnabled", cngShiftclick: "cngShiftclick" } });
__decorate([
    Input()
], CngShiftclickDirective.prototype, "cngShiftclick", void 0);
__decorate([
    Input()
], CngShiftclickDirective.prototype, "selectEnabled", void 0);
__decorate([
    ContentChildren(CngClickItemDirective, { descendants: true })
], CngShiftclickDirective.prototype, "items", void 0);

let CngShiftclickModule = class CngShiftclickModule {
};
CngShiftclickModule.ɵfac = function CngShiftclickModule_Factory(t) { return new (t || CngShiftclickModule)(); };
CngShiftclickModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngShiftclickModule });
CngShiftclickModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let CngGridModule = class CngGridModule {
};
CngGridModule.ɵfac = function CngGridModule_Factory(t) { return new (t || CngGridModule)(); };
CngGridModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngGridModule });
CngGridModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        CngShiftclickModule] });

var CngApiDatasourceEventType;
(function (CngApiDatasourceEventType) {
    CngApiDatasourceEventType["PAGER"] = "pager";
    CngApiDatasourceEventType["FILTER"] = "filter";
    CngApiDatasourceEventType["RELOAD"] = "reload";
    CngApiDatasourceEventType["SEARCH"] = "search";
    CngApiDatasourceEventType["SORT"] = "sort";
})(CngApiDatasourceEventType || (CngApiDatasourceEventType = {}));
/**
 * A datasource for handling API calls to fetch pages of data
 * Supports sorting/filtering/paging
 * Accepted by the cng-table and cng-grid as a valid data source
 * Some code in here adapted from the mat-table data source
 * https://github.com/angular/components/blob/master/src/material/table/table-data-source.ts
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/examples/data-view</example-url>
 */
class CngApiDatasource extends DataSource {
    constructor(apiFn) {
        super();
        /**
         * Final subject that sends data to the component that calls "connect()"
         */
        this._renderData = new BehaviorSubject([]);
        this._renderChangesSub = Subscription.EMPTY;
        /** Subject to trigger reloads */
        this._reload = new Subject();
        this._connectionCount = 0;
        this.apiFn = apiFn;
        this._resetDataChain();
    }
    get pager() {
        return this._pager;
    }
    set pager(pager) {
        this._pager = pager;
        this._resetDataChain();
    }
    get sorter() {
        return this._sorter;
    }
    set sorter(sorter) {
        this._sorter = sorter;
        this._resetDataChain();
    }
    get filterer() {
        return this._filterer;
    }
    set filterer(filterer) {
        this._filterer = filterer;
        this._resetDataChain();
    }
    get searcher() {
        return this._searcher;
    }
    set searcher(searcher) {
        this._searcher = searcher;
        this._resetDataChain();
    }
    _resetDataChain() {
        this._renderChangesSub.unsubscribe();
        let trigger;
        let pager$;
        if (this._pager) {
            pager$ = merge(this._pager.onInit, this._pager.onPageChanged)
                .pipe(tap(() => trigger = CngApiDatasourceEventType.PAGER));
        }
        else {
            pager$ = of({ page: -1, limit: -1 });
        }
        let sorter$;
        if (this._sorter) {
            sorter$ = this.sorter.sortChange
                .pipe(tap(() => trigger = CngApiDatasourceEventType.SORT));
        }
        else {
            sorter$ = of({ active: '', direction: 'asc' });
        }
        let filterer$;
        if (this._filterer) {
            filterer$ = this.filterer.filterChange
                .pipe(tap(() => trigger = CngApiDatasourceEventType.FILTER));
        }
        else {
            filterer$ = of({});
        }
        let searcher$;
        if (this._searcher) {
            searcher$ = this.searcher.onSearch
                .pipe(tap(() => trigger = CngApiDatasourceEventType.SEARCH));
        }
        else {
            searcher$ = of('');
        }
        const reload$ = this._reload
            .pipe(tap(() => trigger = CngApiDatasourceEventType.RELOAD));
        const base$ = combineLatest(reload$, pager$, sorter$, filterer$, searcher$);
        let cancel;
        this._renderChangesSub = base$.pipe(tap(() => {
            cancel = false;
            if (Boolean(this._pager)
                && this._pager.page !== 0
                && (trigger === CngApiDatasourceEventType.FILTER
                    || trigger === CngApiDatasourceEventType.SEARCH
                    || trigger === CngApiDatasourceEventType.SORT)) {
                // If a search/sort/filter event comes in, reset the pager and cancel the
                // current event so that only 1 event is emitted
                this._pager.gotoPage(0);
                cancel = true;
            }
        }), filter(() => !cancel), switchMap(([, pageEvt, sortEvt, filterEvt, searchEvt]) => this.apiFn({
            trigger,
            page: pageEvt.page,
            pageSize: pageEvt.limit,
            search: searchEvt,
            sortKey: sortEvt.active,
            sortDir: sortEvt.direction,
            filter: filterEvt,
        })))
            .subscribe(data => this._renderData.next(data));
    }
    /**
     * Manually trigger a reload - fire request with latest params
     */
    reload() {
        this._reload.next();
    }
    connect() {
        this._connectionCount += 1;
        return this._renderData.asObservable();
    }
    disconnect() {
        this._connectionCount -= 1;
        if (!this._connectionCount) {
            this._renderChangesSub.unsubscribe();
        }
    }
}

var CngTableComponent_1;
/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngTableComponent = CngTableComponent_1 = class CngTableComponent extends CdkTable {
    set lined(value) {
        this._lined = coerceBooleanProperty(value);
    }
    set bordered(value) {
        this._bordered = coerceBooleanProperty(value);
    }
    set striped(value) {
        this._striped = coerceBooleanProperty(value);
    }
    set selectable(value) {
        this._selectable = coerceBooleanProperty(value);
    }
    set fixed(value) {
        this._fixed = coerceBooleanProperty(value);
    }
    set wrapped(value) {
        this._wrapped = coerceBooleanProperty(value);
    }
    set compressed(value) {
        this._compressed = coerceBooleanProperty(value);
    }
    set loose(value) {
        this._loose = coerceBooleanProperty(value);
    }
    get data() {
        return this._data;
    }
};
CngTableComponent.ɵfac = /*@__PURE__*/ function () { let ɵCngTableComponent_BaseFactory; return function CngTableComponent_Factory(t) { return (ɵCngTableComponent_BaseFactory || (ɵCngTableComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngTableComponent)))(t || CngTableComponent); }; }();
CngTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngTableComponent, selectors: [["cng-table"], ["table", "cng-table", ""]], hostAttrs: [1, "table"], hostVars: 16, hostBindings: function CngTableComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("table--lined", ctx._lined)("table--bordered", ctx._bordered)("table--striped", ctx._striped)("table--selectable", ctx._selectable)("table--fixed", ctx._fixed)("table--wrapped", ctx._wrapped)("table--compressed", ctx._compressed)("table--loose", ctx._loose);
    } }, inputs: { lined: "lined", bordered: "bordered", striped: "striped", selectable: "selectable", fixed: "fixed", wrapped: "wrapped", compressed: "compressed", loose: "loose" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkTable, useExisting: CngTableComponent_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c63, decls: 6, vars: 0, consts: [["headerRowOutlet", ""], ["rowOutlet", ""], ["noDataRowOutlet", ""], ["footerRowOutlet", ""]], template: function CngTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c62);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵprojection(1, 1);
        ɵngcc0.ɵɵelementContainer(2, 0)(3, 1)(4, 2)(5, 3);
    } }, dependencies: [ɵngcc6.DataRowOutlet, ɵngcc6.HeaderRowOutlet, ɵngcc6.FooterRowOutlet, ɵngcc6.NoDataRowOutlet], encapsulation: 2 });
__decorate([
    HostBinding('class.table--lined')
], CngTableComponent.prototype, "_lined", void 0);
__decorate([
    Input()
], CngTableComponent.prototype, "lined", null);
__decorate([
    HostBinding('class.table--bordered')
], CngTableComponent.prototype, "_bordered", void 0);
__decorate([
    Input()
], CngTableComponent.prototype, "bordered", null);
__decorate([
    HostBinding('class.table--striped')
], CngTableComponent.prototype, "_striped", void 0);
__decorate([
    Input()
], CngTableComponent.prototype, "striped", null);
__decorate([
    HostBinding('class.table--selectable')
], CngTableComponent.prototype, "_selectable", void 0);
__decorate([
    Input()
], CngTableComponent.prototype, "selectable", null);
__decorate([
    HostBinding('class.table--fixed')
], CngTableComponent.prototype, "_fixed", void 0);
__decorate([
    Input()
], CngTableComponent.prototype, "fixed", null);
__decorate([
    HostBinding('class.table--wrapped')
], CngTableComponent.prototype, "_wrapped", void 0);
__decorate([
    Input()
], CngTableComponent.prototype, "wrapped", null);
__decorate([
    HostBinding('class.table--compressed')
], CngTableComponent.prototype, "_compressed", void 0);
__decorate([
    Input()
], CngTableComponent.prototype, "compressed", null);
__decorate([
    HostBinding('class.table--loose')
], CngTableComponent.prototype, "_loose", void 0);
__decorate([
    Input()
], CngTableComponent.prototype, "loose", null);

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CngCellDef_1, CngHeaderCellDef_1, CngFooterCellDef_1, CngColumnDef_1;
/**
 * Cell definition for the cng-table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngCellDef = CngCellDef_1 = class CngCellDef extends CdkCellDef {
};
CngCellDef.ɵfac = /*@__PURE__*/ function () { let ɵCngCellDef_BaseFactory; return function CngCellDef_Factory(t) { return (ɵCngCellDef_BaseFactory || (ɵCngCellDef_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngCellDef)))(t || CngCellDef); }; }();
CngCellDef.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngCellDef, selectors: [["", "cngCellDef", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkCellDef, useExisting: CngCellDef_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/**
 * Header cell definition for the cng-table.
 * Captures the template of a column's header cell and as well as cell-specific properties.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngHeaderCellDef = CngHeaderCellDef_1 = class CngHeaderCellDef extends CdkHeaderCellDef {
};
CngHeaderCellDef.ɵfac = /*@__PURE__*/ function () { let ɵCngHeaderCellDef_BaseFactory; return function CngHeaderCellDef_Factory(t) { return (ɵCngHeaderCellDef_BaseFactory || (ɵCngHeaderCellDef_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngHeaderCellDef)))(t || CngHeaderCellDef); }; }();
CngHeaderCellDef.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngHeaderCellDef, selectors: [["", "cngHeaderCellDef", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkHeaderCellDef, useExisting: CngHeaderCellDef_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/**
 * Footer cell definition for the cng-table.
 * Captures the template of a column's footer cell and as well as cell-specific properties.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngFooterCellDef = CngFooterCellDef_1 = class CngFooterCellDef extends CdkFooterCellDef {
};
CngFooterCellDef.ɵfac = /*@__PURE__*/ function () { let ɵCngFooterCellDef_BaseFactory; return function CngFooterCellDef_Factory(t) { return (ɵCngFooterCellDef_BaseFactory || (ɵCngFooterCellDef_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngFooterCellDef)))(t || CngFooterCellDef); }; }();
CngFooterCellDef.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngFooterCellDef, selectors: [["", "cngFooterCellDef", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkFooterCellDef, useExisting: CngFooterCellDef_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/**
 * Column definition for the cng-table.
 * Defines a set of cells available for a table column.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngColumnDef = CngColumnDef_1 = class CngColumnDef extends CdkColumnDef {
};
CngColumnDef.ɵfac = /*@__PURE__*/ function () { let ɵCngColumnDef_BaseFactory; return function CngColumnDef_Factory(t) { return (ɵCngColumnDef_BaseFactory || (ɵCngColumnDef_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngColumnDef)))(t || CngColumnDef); }; }();
CngColumnDef.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngColumnDef, selectors: [["", "cngColumnDef", ""]], inputs: { sticky: "sticky", name: ["cngColumnDef", "name"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: CdkColumnDef, useExisting: CngColumnDef_1 },
            { provide: 'cng_SORT_HEADER_COLUMN_DEF', useExisting: CngColumnDef_1 },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('cngColumnDef')
], CngColumnDef.prototype, "name", void 0);
/**
 * Header cell template container that adds the right classes and role.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngHeaderCell = class CngHeaderCell extends CdkHeaderCell {
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        elementRef.nativeElement.classList.add(`cng-column-${columnDef.cssClassFriendlyName}`);
    }
};
CngHeaderCell.ɵfac = function CngHeaderCell_Factory(t) { return new (t || CngHeaderCell)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.CdkColumnDef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngHeaderCell.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngHeaderCell, selectors: [["cng-header-cell"], ["th", "cng-header-cell", ""]], hostAttrs: ["role", "columnheader", 1, "cng-header-cell"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
CngHeaderCell.ctorParameters = () => [
    { type: CdkColumnDef },
    { type: ElementRef }
];
/**
 * Footer cell template container that adds the right classes and role.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngFooterCell = class CngFooterCell extends CdkFooterCell {
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        elementRef.nativeElement.classList.add(`cng-column-${columnDef.cssClassFriendlyName}`);
    }
};
CngFooterCell.ɵfac = function CngFooterCell_Factory(t) { return new (t || CngFooterCell)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.CdkColumnDef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngFooterCell.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngFooterCell, selectors: [["cng-footer-cell"], ["td", "cng-footer-cell", ""]], hostAttrs: ["role", "gridcell", 1, "cng-footer-cell"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
CngFooterCell.ctorParameters = () => [
    { type: CdkColumnDef },
    { type: ElementRef }
];
/**
 * Cell template container that adds the right classes and role.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngCell = class CngCell extends CdkCell {
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        elementRef.nativeElement.classList.add(`cng-column-${columnDef.cssClassFriendlyName}`);
    }
};
CngCell.ɵfac = function CngCell_Factory(t) { return new (t || CngCell)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.CdkColumnDef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngCell.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngCell, selectors: [["cng-cell"], ["td", "cng-cell", ""]], hostAttrs: ["role", "gridcell", 1, "cng-cell"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
CngCell.ctorParameters = () => [
    { type: CdkColumnDef },
    { type: ElementRef }
];

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Column that simply shows text content for the header and row cells. Assumes that the table
 * is using the native table implementation (`<table>`).
 *
 * By default, the name of this column will be the header text and data property accessor.
 * The header text can be overridden with the `headerText` input. Cell values can be overridden with
 * the `dataAccessor` input. Change the text justification to the start or end using the `justify`
 * input.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngTableColumn = class CngTableColumn extends CdkTextColumn {
};
CngTableColumn.ɵfac = /*@__PURE__*/ function () { let ɵCngTableColumn_BaseFactory; return function CngTableColumn_Factory(t) { return (ɵCngTableColumn_BaseFactory || (ɵCngTableColumn_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngTableColumn)))(t || CngTableColumn); }; }();
CngTableColumn.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngTableColumn, selectors: [["cng-text-column"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["cngColumnDef", ""], ["cng-header-cell", "", 3, "text-align", 4, "cngHeaderCellDef"], ["cng-cell", "", 3, "text-align", 4, "cngCellDef"], ["cng-header-cell", ""], ["cng-cell", ""]], template: function CngTableColumn_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, CngTableColumn_th_1_Template, 2, 3, "th", 1);
        ɵngcc0.ɵɵtemplate(2, CngTableColumn_td_2_Template, 2, 3, "td", 2);
        ɵngcc0.ɵɵelementContainerEnd();
    } }, dependencies: [CngCell, CngCellDef, CngColumnDef, CngHeaderCell, CngHeaderCellDef], encapsulation: 2 });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CngHeaderRowDef_1, CngFooterRowDef_1, CngRowDef_1, CngHeaderRow_1, CngFooterRow_1, CngRow_1;
/**
 * Header row definition for the cng-table.
 * Captures the header row's template and other header properties such as the columns to display.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngHeaderRowDef = CngHeaderRowDef_1 = class CngHeaderRowDef extends CdkHeaderRowDef {
};
CngHeaderRowDef.ɵfac = /*@__PURE__*/ function () { let ɵCngHeaderRowDef_BaseFactory; return function CngHeaderRowDef_Factory(t) { return (ɵCngHeaderRowDef_BaseFactory || (ɵCngHeaderRowDef_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngHeaderRowDef)))(t || CngHeaderRowDef); }; }();
CngHeaderRowDef.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngHeaderRowDef, selectors: [["", "cngHeaderRowDef", ""]], inputs: { columns: ["cngHeaderRowDef", "columns"], sticky: ["cngHeaderRowDefSticky", "sticky"] }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkHeaderRowDef, useExisting: CngHeaderRowDef_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/**
 * Footer row definition for the cng-table.
 * Captures the footer row's template and other footer properties such as the columns to display.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngFooterRowDef = CngFooterRowDef_1 = class CngFooterRowDef extends CdkFooterRowDef {
};
CngFooterRowDef.ɵfac = /*@__PURE__*/ function () { let ɵCngFooterRowDef_BaseFactory; return function CngFooterRowDef_Factory(t) { return (ɵCngFooterRowDef_BaseFactory || (ɵCngFooterRowDef_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngFooterRowDef)))(t || CngFooterRowDef); }; }();
CngFooterRowDef.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngFooterRowDef, selectors: [["", "cngFooterRowDef", ""]], inputs: { columns: ["cngFooterRowDef", "columns"], sticky: ["cngFooterRowDefSticky", "sticky"] }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkFooterRowDef, useExisting: CngFooterRowDef_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/**
 * Data row definition for the cng-table.
 * Captures the data row's template and other properties such as the columns to display and
 * a when predicate that describes when this row should be used.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngRowDef = CngRowDef_1 = class CngRowDef extends CdkRowDef {
};
CngRowDef.ɵfac = /*@__PURE__*/ function () { let ɵCngRowDef_BaseFactory; return function CngRowDef_Factory(t) { return (ɵCngRowDef_BaseFactory || (ɵCngRowDef_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngRowDef)))(t || CngRowDef); }; }();
CngRowDef.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngRowDef, selectors: [["", "cngRowDef", ""]], inputs: { columns: ["cngRowDefColumns", "columns"], when: ["cngRowDefWhen", "when"] }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkRowDef, useExisting: CngRowDef_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/**
 * Footer template container that contains the cell outlet. Adds the right class and role.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngHeaderRow = CngHeaderRow_1 = class CngHeaderRow extends CdkHeaderRow {
};
CngHeaderRow.ɵfac = /*@__PURE__*/ function () { let ɵCngHeaderRow_BaseFactory; return function CngHeaderRow_Factory(t) { return (ɵCngHeaderRow_BaseFactory || (ɵCngHeaderRow_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngHeaderRow)))(t || CngHeaderRow); }; }();
CngHeaderRow.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngHeaderRow, selectors: [["cng-header-row"], ["tr", "cng-header-row", ""]], hostAttrs: ["role", "row", 1, "cng-header-row"], exportAs: ["cngHeaderRow"], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkHeaderRow, useExisting: CngHeaderRow_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 0, consts: [["cdkCellOutlet", ""]], template: function CngHeaderRow_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
    } }, dependencies: [ɵngcc6.CdkCellOutlet], encapsulation: 2 });
/**
 * Footer template container that contains the cell outlet. Adds the right class and role.
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngFooterRow = CngFooterRow_1 = class CngFooterRow extends CdkFooterRow {
};
CngFooterRow.ɵfac = /*@__PURE__*/ function () { let ɵCngFooterRow_BaseFactory; return function CngFooterRow_Factory(t) { return (ɵCngFooterRow_BaseFactory || (ɵCngFooterRow_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngFooterRow)))(t || CngFooterRow); }; }();
CngFooterRow.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngFooterRow, selectors: [["cng-footer-row"], ["tr", "cng-footer-row", ""]], hostAttrs: ["role", "row", 1, "cng-footer-row"], exportAs: ["cngFooterRow"], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkFooterRow, useExisting: CngFooterRow_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 0, consts: [["cdkCellOutlet", ""]], template: function CngFooterRow_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
    } }, dependencies: [ɵngcc6.CdkCellOutlet], encapsulation: 2 });
/** Data row template container that contains the cell outlet. Adds the right class and role. */
let CngRow = CngRow_1 = class CngRow extends CdkRow {
};
CngRow.ɵfac = /*@__PURE__*/ function () { let ɵCngRow_BaseFactory; return function CngRow_Factory(t) { return (ɵCngRow_BaseFactory || (ɵCngRow_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngRow)))(t || CngRow); }; }();
CngRow.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngRow, selectors: [["cng-row"], ["tr", "cng-row", ""]], hostAttrs: ["role", "row", 1, "cng-row"], exportAs: ["cngRow"], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkRow, useExisting: CngRow_1 }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 0, consts: [["cdkCellOutlet", ""]], template: function CngRow_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
    } }, dependencies: [ɵngcc6.CdkCellOutlet], encapsulation: 2 });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/table</example-url>
 */
let CngSelectColumnComponent = class CngSelectColumnComponent {
    constructor(_cdr, _table) {
        this._cdr = _cdr;
        this._table = _table;
        this.selection = new SelectionModel(true);
    }
    ngOnInit() {
        this.isMultiple = this.selection.isMultipleSelection();
        if (this._table && this._columnDef) {
            this._columnDef.cell = this._cell;
            this._columnDef.headerCell = this._headerCell;
            this._table.addColumnDef(this._columnDef);
        }
    }
    ngOnDestroy() {
        if (this._table) {
            this._table.removeColumnDef(this._columnDef);
        }
    }
    /**
     * Whether the number of selected elements matches the total number of rows.
     * @returns boolean
     */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this._table.data.length;
        return numSelected === numRows;
    }
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this._table.data.forEach(row => this.selection.select(row));
    }
    /**
     * Toggles selected for a single row
     * @param row - T
     * @param index - number
     * @param event - MouseEvent | KeyboardEvent
     */
    toggleOne(row, index, event) {
        if (event.defaultPrevented) {
            // check to make sure this method isn't called twice by the same click event
            return;
        }
        event.preventDefault();
        this.selection.toggle(row);
        if (event.shiftKey) {
            const selected = this.selection.isSelected(row);
            let endIndex;
            let startIndex;
            if (this._lastClickedIndex > index) {
                startIndex = index;
                endIndex = this._lastClickedIndex;
            }
            else {
                startIndex = this._lastClickedIndex;
                endIndex = index;
            }
            for (let i = startIndex + 1; i <= endIndex; i += 1) {
                if (selected) {
                    this.selection.select(this._table.data[i]);
                }
                else {
                    this.selection.deselect(this._table.data[i]);
                }
            }
        }
        this._lastClickedIndex = index;
        this._cdr.detectChanges();
    }
    handleKeydown(event, type, row, index) {
        if (event.keyCode === ENTER || event.keyCode === SPACE) {
            if (type === 'header') {
                event.preventDefault();
                this.masterToggle();
            }
            else {
                this.toggleOne(row, index, event);
            }
        }
    }
};
CngSelectColumnComponent.ɵfac = function CngSelectColumnComponent_Factory(t) { return new (t || CngSelectColumnComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CngTableComponent, 8)); };
CngSelectColumnComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngSelectColumnComponent, selectors: [["cng-select-column"]], viewQuery: function CngSelectColumnComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CngColumnDef, 7);
        ɵngcc0.ɵɵviewQuery(CngCellDef, 7);
        ɵngcc0.ɵɵviewQuery(CngHeaderCellDef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._columnDef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._cell = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._headerCell = _t.first);
    } }, inputs: { selection: "selection" }, decls: 3, vars: 0, consts: [["cngColumnDef", "select"], ["cng-header-cell", "", 4, "cngHeaderCellDef"], ["cng-cell", "", 4, "cngCellDef"], ["cng-header-cell", ""], ["class", "checkbox", 4, "ngIf"], [1, "checkbox"], ["type", "checkbox", 3, "checked", "change", "keydown"], [1, "checkbox__input"], ["cng-cell", ""], [1, "checkbox", 3, "click", "mousedown", "keydown"], ["type", "checkbox", 3, "checked"]], template: function CngSelectColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, CngSelectColumnComponent_th_1_Template, 2, 1, "th", 1);
        ɵngcc0.ɵɵtemplate(2, CngSelectColumnComponent_td_2_Template, 4, 1, "td", 2);
        ɵngcc0.ɵɵelementContainerEnd();
    } }, dependencies: [ɵngcc1.NgIf, CngCell, CngCellDef, CngColumnDef, CngHeaderCell, CngHeaderCellDef] });
CngSelectColumnComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: CngTableComponent, decorators: [{ type: Optional }] }
];
__decorate([
    Input()
], CngSelectColumnComponent.prototype, "selection", void 0);
__decorate([
    ViewChild(CngColumnDef, { static: true })
], CngSelectColumnComponent.prototype, "_columnDef", void 0);
__decorate([
    ViewChild(CngCellDef, { static: true })
], CngSelectColumnComponent.prototype, "_cell", void 0);
__decorate([
    ViewChild(CngHeaderCellDef, { static: true })
], CngSelectColumnComponent.prototype, "_headerCell", void 0);
CngSelectColumnComponent = __decorate([ __param(1, Optional())
], CngSelectColumnComponent);

let CngTableModule = class CngTableModule {
};
CngTableModule.ɵfac = function CngTableModule_Factory(t) { return new (t || CngTableModule)(); };
CngTableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngTableModule });
CngTableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CdkTableModule,
        CommonModule] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/sort</example-url>
 */
let CngSortDirective = class CngSortDirective {
    constructor() {
        /** Collection of all registered sortables that this directive manages. */
        this.sortables = new Map();
        /** Used to notify any child components listening to state changes. */
        this._stateChanges = new Subject();
        /**
         * The direction to set when an CngSortable is initially sorted.
         * May be overriden by the CngSortable's sort start.
         */
        this.start = 'asc';
        /** Event emitted when the user changes either the active sort or sort direction. */
        this.sortChange = new EventEmitter();
    }
    /** The sort direction of the currently active CngSortable. */
    set direction(direction) {
        if (direction && direction !== 'asc' && direction !== 'desc') {
            throw new Error('Invalid sort direction was supplied to CngSort');
        }
        this._direction = direction;
    }
    get direction() { return this._direction; }
    /**
     * Register function to be used by the contained CngSortables. Adds the CngSortable to the
     * collection of CngSortables.
     * @param sortable - CngSortable
     */
    register(sortable) {
        if (!sortable.id) {
            throw new Error('CngSortable item is missing id field');
        }
        if (this.sortables.has(sortable.id)) {
            throw new Error('Duplicate Sortable ids supplied to CngSort');
        }
        this.sortables.set(sortable.id, sortable);
    }
    /**
     * Unregister function to be used by the contained CngSortables. Removes the CngSortable
     * from the collection of contained CngSortables.
     * @param sortable - CngSortable
     */
    deregister(sortable) {
        this.sortables.delete(sortable.id);
    }
    /**
     * Sets the active sort id and determines the new sort direction.
     * @param sortable - CngSortable
     */
    sort(sortable) {
        if (this.active !== sortable.id) {
            this.active = sortable.id;
            this.direction = sortable.start ? sortable.start : this.start;
            sortable.start = this.direction;
        }
        else if (sortable.start) {
            this.direction = sortable.start === 'asc' ? 'desc' : 'asc';
            sortable.start = this.direction;
        }
        else {
            this.direction = this.start;
            sortable.start = this.start === 'asc' ? 'desc' : 'asc';
        }
        this.sortChange.emit({
            active: this.active,
            direction: this.direction,
        });
    }
    ngOnChanges() {
        this._stateChanges.next();
    }
    ngOnDestroy() {
        this._stateChanges.complete();
    }
    ngOnInit() {
        this.sortChange.emit({
            active: this.active,
            direction: this.direction,
        });
    }
};
CngSortDirective.ɵfac = function CngSortDirective_Factory(t) { return new (t || CngSortDirective)(); };
CngSortDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngSortDirective, selectors: [["", "cngSort", ""]], inputs: { start: ["cngSortStart", "start"], direction: ["cngSortDirection", "direction"], active: ["cngSortActive", "active"] }, outputs: { sortChange: "cngSortChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
__decorate([
    Input('cngSortActive')
], CngSortDirective.prototype, "active", void 0);
__decorate([
    Input('cngSortStart')
], CngSortDirective.prototype, "start", void 0);
__decorate([
    Input('cngSortDirection')
], CngSortDirective.prototype, "direction", null);
__decorate([
    Output('cngSortChange')
], CngSortDirective.prototype, "sortChange", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/sort</example-url>
 */
let CngSortHeaderComponent = class CngSortHeaderComponent {
    constructor(_cdr, rootSort, columnDef) {
        this._cdr = _cdr;
        this.rootSort = rootSort;
        this.columnDef = columnDef;
        this.showSortToggle = false;
        if (!this.rootSort) {
            throw new Error('No CngSortDirective found. CngSortHeaderComponent must be inserted' +
                ' within an element with the cngSort attribute.');
        }
        if (this.columnDef) {
            // Get id from CngColumnDef name
            this.id = this.columnDef.name;
        }
        this._rerenderSubscription = merge(rootSort.sortChange, rootSort._stateChanges)
            .subscribe(() => {
            if (this._isSorted()) {
                this.showSortToggle = true;
            }
            else {
                this.showSortToggle = false;
            }
            _cdr.markForCheck();
        });
    }
    ngOnDestroy() {
        this.rootSort.deregister(this);
    }
    ngOnInit() {
        this.rootSort.register(this);
    }
    handleClick() {
        this.rootSort.sort(this);
    }
    /**
     * Whether this CngSortHeader is currently sorted in either ascending or descending order.
     * @returns boolean
     */
    _isSorted() {
        return this.rootSort.active === this.id &&
            (this.rootSort.direction === 'asc' || this.rootSort.direction === 'desc');
    }
};
CngSortHeaderComponent.ɵfac = function CngSortHeaderComponent_Factory(t) { return new (t || CngSortHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CngSortDirective, 8), ɵngcc0.ɵɵdirectiveInject(CngColumnDef, 8)); };
CngSortHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngSortHeaderComponent, selectors: [["", "cng-sort-header", ""]], hostAttrs: [1, "sortable"], hostBindings: function CngSortHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CngSortHeaderComponent_click_HostBindingHandler() { return ctx.handleClick(); });
    } }, inputs: { id: "id" }, attrs: _c64, ngContentSelectors: _c11, decls: 2, vars: 1, consts: [["class", "qtr-margin-left sort-indicator icon-dropdown", 3, "ngClass", 4, "ngIf"], [1, "qtr-margin-left", "sort-indicator", "icon-dropdown", 3, "ngClass"]], template: function CngSortHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, CngSortHeaderComponent_span_1_Template, 1, 3, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSortToggle);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[_nghost-%COMP%]   .desc[_ngcontent-%COMP%]{transform:rotate(180deg);margin-bottom:3px}"], changeDetection: 0 });
CngSortHeaderComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: CngSortDirective, decorators: [{ type: Optional }] },
    { type: CngColumnDef, decorators: [{ type: Optional }] }
];
__decorate([
    Input()
], CngSortHeaderComponent.prototype, "id", void 0);
CngSortHeaderComponent = __decorate([ __param(1, Optional()),
    __param(2, Optional())
], CngSortHeaderComponent);

let CngSortModule = class CngSortModule {
};
CngSortModule.ɵfac = function CngSortModule_Factory(t) { return new (t || CngSortModule)(); };
CngSortModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngSortModule });
CngSortModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/filter</example-url>
 */
let CngFilterGroupComponent = class CngFilterGroupComponent {
    constructor() { }
    ngOnInit() {
        if (!this.id) {
            throw new Error('The "id" input was not provided to CngFilterGroupComponent!');
        }
    }
};
CngFilterGroupComponent.ɵfac = function CngFilterGroupComponent_Factory(t) { return new (t || CngFilterGroupComponent)(); };
CngFilterGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngFilterGroupComponent, selectors: [["cng-filter-group"]], inputs: { id: "id" }, ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngFilterGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
__decorate([
    Input()
], CngFilterGroupComponent.prototype, "id", void 0);

/**
 * Directive representing a generic filter item.
 * The main cng-filter component grabs any items with this directive and listens
 * to their valueChange$ observable to update the state
 * Note <cng-filter-item> extends this directive to create a simple checkbox item.
 */
let CngFilterItemDirective = class CngFilterItemDirective {
    constructor(_cdr, _group) {
        this._cdr = _cdr;
        this._group = _group;
        this._valueChange$ = new Subject();
        this._valueAccessor = {
            registerValueAdd: () => { },
            registerValueRemove: () => { },
            registerClearGroup: () => { },
            writeFilter: () => { },
        };
        this._notifyAdd = (value) => {
            this._valueChange$.next({
                value,
                field: this._group.id,
                selected: true,
            });
        };
        this._notifyRemove = (value) => {
            this._valueChange$.next({
                value,
                field: this._group.id,
                selected: false,
            });
        };
        this._notifyClear = () => {
            this._valueChange$.next({
                value: null,
                field: this._group.id,
                selected: false,
                overwrite: true,
            });
        };
        this._notifyOverwrite = (values) => {
            this._valueChange$.next({
                value: values,
                field: this._group.id,
                selected: true,
                overwrite: true,
            });
        };
    }
    /** Emits whenever the value of the filter control changes from a user */
    get valueChange$() {
        return this._valueChange$.asObservable();
    }
    get valueAccessor() {
        return this._valueAccessor;
    }
    /** Register your filter component as the valueAccessor to automatically
     * recieve state updates from the cng-filter and to send updates to it
     */
    set valueAccessor(v) {
        v.registerValueAdd(this._notifyAdd);
        v.registerValueRemove(this._notifyRemove);
        v.registerClearGroup(this._notifyClear);
        if (v.registerOverwriteGroup) {
            v.registerOverwriteGroup(this._notifyOverwrite);
        }
        this._valueAccessor = v;
    }
    ngOnInit() {
        if (!this._group) {
            throw new Error('No CngFilterGroupComponent found. ' +
                'cngFilterItem requires a parent group.');
        }
        this.groupId = this._group.id;
    }
    /**
     * Called whenever the cng-filter state is updated directly. Use this to update
     * your filter item's state based on the new filter state
     * (basically like writeValue() for an NG_VALUE_ACCESSOR)
     * @param state the new filter state
     */
    writeFilter(state) {
        this._valueAccessor.writeFilter(state);
        this._cdr.detectChanges();
    }
};
CngFilterItemDirective.ɵfac = function CngFilterItemDirective_Factory(t) { return new (t || CngFilterItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CngFilterGroupComponent)); };
CngFilterItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngFilterItemDirective, selectors: [["", "cngFilterItem", ""]] });
CngFilterItemDirective.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: CngFilterGroupComponent }
];

var CngFilterItemComponent_1;
class Accessor {
    constructor() {
        this._valueChange$ = new Subject();
        this.valueAdd = () => { };
        this.valueRemove = () => { };
    }
    get valueChange$() {
        return this._valueChange$.asObservable();
    }
    registerValueAdd(fn) {
        this.valueAdd = fn;
    }
    registerValueRemove(fn) {
        this.valueRemove = fn;
    }
    registerClearGroup() {
    }
    writeFilter(val) {
        this._valueChange$.next(val);
    }
}
/**
 * A simple checkbox filter control component
 * It is an extension of the cng-filter-item directive
 * <example-url>/pages/cx-ppd/cui-ng/examples/filter</example-url>
 */
let CngFilterItemComponent = CngFilterItemComponent_1 = class CngFilterItemComponent extends CngFilterItemDirective {
    constructor(_cdr, group) {
        super(_cdr, group);
        this._cdr = _cdr;
        this.group = group;
        this.selected = false;
        this.selectControl = new FormControl(false);
        this._accessor = new Accessor();
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.groupId = this._group.id;
        this.valueAccessor = this._accessor;
        // Listen for checkbox changes, notify filter
        this.selectControl.valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(val => {
            if (val) {
                this._accessor.valueAdd(this.value);
            }
            else {
                this._accessor.valueRemove(this.value);
            }
        });
        // Listen for filter changes, update checkbox
        this._accessor.valueChange$.pipe(takeUntil(this.destroy$))
            .subscribe(state => {
            if (state[this.group.id]
                && state[this.group.id].includes(this.value)) {
                // Set the selection based on the root filter model
                this.selectControl.setValue(true, { emitEvent: false });
            }
            else {
                this.selectControl.setValue(false, { emitEvent: false });
            }
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
};
CngFilterItemComponent.ɵfac = function CngFilterItemComponent_Factory(t) { return new (t || CngFilterItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CngFilterGroupComponent)); };
CngFilterItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngFilterItemComponent, selectors: [["cng-filter-item"]], inputs: { selected: "selected", value: "value" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: CngFilterItemDirective,
                useExisting: CngFilterItemComponent_1
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c11, decls: 6, vars: 1, consts: [[1, "form-group", "form-group--compressed"], [1, "checkbox"], ["type", "checkbox", 3, "formControl"], [1, "checkbox__input"], [1, "checkbox__label"]], template: function CngFilterItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
        ɵngcc0.ɵɵelement(2, "input", 2)(3, "span", 3);
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formControl", ctx.selectControl);
    } }, dependencies: [ɵngcc4.CheckboxControlValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlDirective], encapsulation: 2, changeDetection: 0 });
CngFilterItemComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: CngFilterGroupComponent }
];
__decorate([
    Input()
], CngFilterItemComponent.prototype, "selected", void 0);
__decorate([
    Input()
], CngFilterItemComponent.prototype, "value", void 0);

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/filter</example-url>
 */
let CngFilterComponent = class CngFilterComponent {
    constructor() {
        this.filterChange = new EventEmitter();
        this._destroyed$ = new Subject();
        this._filterState = {};
    }
    set filter(value) {
        this._filterState = value || {};
    }
    get filter() { return this._filterState; }
    ngOnChanges(changes) {
        // Whenever state input changes, update child items
        if (changes.filter && !changes.filter.isFirstChange()) {
            this.items.forEach(item => item.writeFilter(this._filterState));
        }
    }
    ngAfterViewInit() {
        this._subscribeToFilterItems();
        this.items.changes
            .pipe(takeUntil(this._destroyed$))
            .subscribe(() => {
            // If any FilterItems are added or removed, re-initialize the subscription
            this._filterSub.unsubscribe();
            this._subscribeToFilterItems();
        });
        this.filterChange.emit(this._filterState);
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
    _subscribeToFilterItems() {
        const changeSubjects = [];
        this.items.forEach(item => {
            item.writeFilter(this._filterState);
            changeSubjects.push(item.valueChange$);
        });
        this._filterSub = merge(...changeSubjects)
            .pipe(takeUntil(this._destroyed$))
            .subscribe((event) => {
            this.setFilterState(event);
            // Update all items in the group that just changed
            this.items.filter(item => item.groupId === event.field)
                .forEach(item => {
                item.writeFilter(this._filterState);
            });
            this.filterChange.emit(this._filterState);
        });
    }
    setFilterState(event) {
        if (event.overwrite) {
            this._filterState[event.field] = event.value;
            if (!event.value || !event.value.length) {
                delete this._filterState[event.field];
            }
            return;
        }
        if (event.selected) {
            if (typeof this._filterState[event.field] === 'undefined') {
                this._filterState[event.field] = [event.value];
            }
            else if (!this._filterState[event.field].includes(event.value)) {
                this._filterState[event.field].push(event.value);
            }
        }
        else if (this._filterState[event.field]) {
            const idx = this._filterState[event.field].findIndex(elem => elem === event.value);
            if (idx !== -1) {
                this._filterState[event.field].splice(idx, 1);
                if (!this._filterState[event.field].length) {
                    delete this._filterState[event.field];
                }
            }
        }
    }
};
CngFilterComponent.ɵfac = function CngFilterComponent_Factory(t) { return new (t || CngFilterComponent)(); };
CngFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngFilterComponent, selectors: [["cng-filter"]], contentQueries: function CngFilterComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngFilterItemDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, hostAttrs: [2, "display", "block"], inputs: { filter: "filter" }, outputs: { filterChange: "filterChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } } });
__decorate([
    Input()
], CngFilterComponent.prototype, "filter", null);
__decorate([
    ContentChildren(CngFilterItemDirective, { descendants: true })
], CngFilterComponent.prototype, "items", void 0);
__decorate([
    Output()
], CngFilterComponent.prototype, "filterChange", void 0);

var CngFilterClearComponent_1;
class Accessor$1 {
    constructor() {
        this.clearGroup = () => { };
    }
    registerValueAdd() {
    }
    registerValueRemove() {
    }
    registerClearGroup(fn) {
        this.clearGroup = fn;
    }
    writeFilter() {
    }
}
let CngFilterClearComponent = CngFilterClearComponent_1 = class CngFilterClearComponent extends CngFilterItemDirective {
    constructor(_cdr, group) {
        super(_cdr, group);
        this._cdr = _cdr;
        this.group = group;
        this._accessor = new Accessor$1();
    }
    ngOnInit() {
        this.groupId = this._group.id;
        this.valueAccessor = this._accessor;
    }
    clearGroup() {
        this._accessor.clearGroup();
    }
};
CngFilterClearComponent.ɵfac = function CngFilterClearComponent_Factory(t) { return new (t || CngFilterClearComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CngFilterGroupComponent)); };
CngFilterClearComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngFilterClearComponent, selectors: [["cng-filter-clear"]], features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: CngFilterItemDirective,
                useExisting: CngFilterClearComponent_1
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c11, decls: 2, vars: 0, consts: [[3, "click"]], template: function CngFilterClearComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵlistener("click", function CngFilterClearComponent_Template_a_click_0_listener() { return ctx.clearGroup(); });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } } });
CngFilterClearComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: CngFilterGroupComponent }
];

/**
 * Module for making generic filter menus and maintaining filter state.
 * For most cases (ie using checkbox filters) simply supply <cng-filter-item>
 * components to each group.
 * For more advanced cases you can create custom filters as well. Follow these steps:
 * - Create your custom filter control component (could be a select, text input, etc.)
 * - Make it implement the CngFilterAccessor interface
 * - Implement this interface much in the same way as when you create a custom ngControl
 *   for an angular form.
 * - Apply [cngFilterItem] directive to your custom component when you
 *   place it inside the filter group
 * - Inside your custom component, inject that directive and register yourself with
 *   this.<Injected CngFilterItemDirective>.valueAccessor = this;
 */
let CngFilterModule = class CngFilterModule {
};
CngFilterModule.ɵfac = function CngFilterModule_Factory(t) { return new (t || CngFilterModule)(); };
CngFilterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngFilterModule });
CngFilterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CngAccordionModule,
        CommonModule,
        ReactiveFormsModule] });

const CNG_BREADCRUMB_LABEL = 'cngBreadcrumbLabel';
/**
 * Router-based breadcrumb navigation element.
 * It will automatically subscribe to the Router and build breadcrumbs leading
 * back to the root. In order for your routes to show up, you must first register
 * a CNG_BREADCRUMB_LABEL wherever you define your routes (app-routing.module.ts
 * or whatever sub-module) e.g. in your route:
 *
 * data: {
 * 		[CNG_BREADCRUMB_LABEL]: 'Your label here',
 * },
 *
 * The label may either be a string or a CngContentConfig (see cng-content)
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/breadcrumbs</example-url>
 */
let CngBreadcrumbsComponent = class CngBreadcrumbsComponent {
    constructor(activatedRoute, cdr, router) {
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
        this.router = router;
        /** Optional, set max number of visible breadcrumbs (defaults to -1 for infinite)
         * If you go over that limit, any in the middle will be collapsed with ellipses
         */
        this.maxItems = -1;
        this.items = [];
        this._refresh$ = new Subject();
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        merge(this.router.events.pipe(filter(evt => evt instanceof NavigationEnd)), this._refresh$).pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this.items = this._buildBreadcrumbs(this.activatedRoute.root);
            this.items = this._collapseExtras(this.items);
            this.currentItem = this.items[this.items.length - 1];
            this.cdr.markForCheck();
        });
        this._refresh$.next(); // Trigger initial build on component init
    }
    _buildBreadcrumbs(route, url = '', breadcrumbs = []) {
        const routeUrl = route.snapshot.url.map(seg => seg.path).join('/');
        let newUrl = url;
        if (routeUrl) {
            newUrl = `${url}/${routeUrl}`;
        }
        const label = route.snapshot.data[CNG_BREADCRUMB_LABEL];
        let content;
        if (typeof label === 'string') {
            content = {
                type: CngContentConfigType.TEXT,
                content: label,
            };
        }
        else {
            content = label;
        }
        if (label) {
            breadcrumbs.push({
                content,
                url: newUrl,
            });
        }
        if (!route.firstChild) {
            return breadcrumbs;
        }
        return this._buildBreadcrumbs(route.firstChild, newUrl, breadcrumbs);
    }
    _collapseExtras(items) {
        let newItems = [...items];
        if (this.maxItems !== -1) {
            while (newItems.length > this.maxItems) {
                const middle = Math.floor(newItems.length / 2);
                newItems = newItems.slice(0, middle)
                    .concat(newItems.slice(middle + 1, newItems.length));
            }
            if (newItems.length < items.length) {
                newItems.splice(Math.ceil(newItems.length / 2), 0, {
                    content: {
                        type: CngContentConfigType.TEXT,
                        content: '...',
                    },
                    url: null,
                });
            }
        }
        return newItems;
    }
    ngOnChanges() {
        this._refresh$.next(); // Rebuild breadcrumbs if "maxItems" changes
    }
    ngOnDestroy() {
        this._destroy$.next();
    }
};
CngBreadcrumbsComponent.ɵfac = function CngBreadcrumbsComponent_Factory(t) { return new (t || CngBreadcrumbsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
CngBreadcrumbsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngBreadcrumbsComponent, selectors: [["cng-breadcrumbs"]], inputs: { maxItems: "maxItems" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[1, "breadcrumb"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["anchor", ""], [1, "content-inline", 3, "config"], [3, "routerLink"], [3, "config"]], template: function CngBreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "ul", 0);
        ɵngcc0.ɵɵtemplate(2, CngBreadcrumbsComponent_li_2_Template, 4, 2, "li", 1);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.RouterLinkWithHref, CngContentComponent], styles: ["[_nghost-%COMP%]     .content-inline>div{display:inline}"], changeDetection: 0 });
CngBreadcrumbsComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: ChangeDetectorRef },
    { type: Router }
];
__decorate([
    Input()
], CngBreadcrumbsComponent.prototype, "maxItems", void 0);

/**
 * Module for simple breadcrumbs application navigation
 * The main component of this module is the CngBreadcrumbsComponent.
 * Simply place one in your application where you wish the breadcrumbs to be visible.
 * By default no routes will appear in the breadcrumbs, you must first assign a label
 * Setting up Routes:
 * - Each route that you want to show up in the breadcrumbs must have a label assigned.
 * - This label is assigned in the route's "data" property. import CNG_BREADCRUMB_LABEL
 * 	 from @cisco/cui-ng and provide a data property with key CNG_BREADCRUMB_LABEL
 *   and value <your label>
 *
 * Potential gotchas:
 * Sometimes you'll notice (especially working with lazy modules and routes) a
 * duplicate breadcrumb for your final route. This is because you didn't assign
 * the label at a leaf of your router tree. Typically you'll want to apply it at
 * the leaf (ie for a lazy module, inside the lazy module's routing itself, not
 * when you route TO the lazy module). In the case where your route has children
 * and you WANT a label that's not at a leaf, you probably have a child route that
 * happens to match with that parent (typically empty string). In that case, simply
 * override the child's label with null or empty string to remove the duplicate entry
 */
let CngBreadcrumbsModule = class CngBreadcrumbsModule {
};
CngBreadcrumbsModule.ɵfac = function CngBreadcrumbsModule_Factory(t) { return new (t || CngBreadcrumbsModule)(); };
CngBreadcrumbsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngBreadcrumbsModule });
CngBreadcrumbsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        RouterModule,
        CngContentModule] });

/**
 * <example-url>/pages/cx-ppd/cui-ng/examples/search</example-url>
 */
let CngSearchDirective = class CngSearchDirective {
    constructor(_control, _elem) {
        this._control = _control;
        this._elem = _elem;
        this.debounce = 500;
        this.onSearch = new EventEmitter();
        this._onSearch$ = new Subject();
        this._destroyed$ = new Subject();
    }
    set useEnterKey(value) {
        this._useEnterKey = coerceBooleanProperty(value);
    }
    onInput() {
        if (!this._control) {
            this.currentValue = this._elem.nativeElement.value;
            this._onSearch$.next(this.currentValue);
        }
    }
    onKeyup(event) {
        if (this._useEnterKey && event.keyCode === ENTER) {
            this.onSearch.emit(this.currentValue);
        }
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
    ngOnChanges(changes) {
        if (changes.debounce) {
            this._resetChangeSubscription();
        }
    }
    ngOnInit() {
        this._resetChangeSubscription();
        if (this._control) {
            this._control.valueChanges
                .pipe(takeUntil(this._destroyed$))
                .subscribe(value => {
                if (this.currentValue !== value) {
                    this.currentValue = value;
                    this._onSearch$.next(value);
                }
            });
            this.onSearch.emit(this._control.value);
        }
        else {
            this.onSearch.emit('');
        }
    }
    /**
     * Programatically fire a search with current input value
     */
    triggerSearch() {
        this.onSearch.emit(this.currentValue);
    }
    _resetChangeSubscription() {
        if (this._changeSub) {
            this._changeSub.unsubscribe();
        }
        if (this._useEnterKey) {
            return;
        }
        this._changeSub = this._onSearch$
            .pipe(debounceTime(this.debounce), distinctUntilChanged(), takeUntil(this._destroyed$))
            .subscribe(() => {
            this.onSearch.emit(this.currentValue);
        });
    }
};
CngSearchDirective.ɵfac = function CngSearchDirective_Factory(t) { return new (t || CngSearchDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CngSearchDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngSearchDirective, selectors: [["input", "cngSearch", ""]], hostBindings: function CngSearchDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function CngSearchDirective_input_HostBindingHandler() { return ctx.onInput(); })("keyup", function CngSearchDirective_keyup_HostBindingHandler($event) { return ctx.onKeyup($event); });
    } }, inputs: { debounce: "debounce", useEnterKey: "useEnterKey" }, outputs: { onSearch: "onSearch" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
CngSearchDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }] },
    { type: ElementRef }
];
__decorate([
    Input()
], CngSearchDirective.prototype, "debounce", void 0);
__decorate([
    Input()
], CngSearchDirective.prototype, "useEnterKey", null);
__decorate([
    Output()
], CngSearchDirective.prototype, "onSearch", void 0);
__decorate([
    HostListener('input')
], CngSearchDirective.prototype, "onInput", null);
__decorate([
    HostListener('keyup', ['$event'])
], CngSearchDirective.prototype, "onKeyup", null);
CngSearchDirective = __decorate([ __param(0, Optional())
], CngSearchDirective);

let CngSearchModule = class CngSearchModule {
};
CngSearchModule.ɵfac = function CngSearchModule_Factory(t) { return new (t || CngSearchModule)(); };
CngSearchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngSearchModule });
CngSearchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let CngAutoGroupComponent = class CngAutoGroupComponent {
};
CngAutoGroupComponent.ɵfac = function CngAutoGroupComponent_Factory(t) { return new (t || CngAutoGroupComponent)(); };
CngAutoGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngAutoGroupComponent, selectors: [["cng-auto-group"]], inputs: { label: "label" }, ngContentSelectors: _c67, decls: 4, vars: 1, consts: [[1, "dropdown__group"], [1, "dropdown__group-header"]], template: function CngAutoGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c66);
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } } });
__decorate([
    Input()
], CngAutoGroupComponent.prototype, "label", void 0);

let _idCounter = 0;
let CngAutoOptionComponent = class CngAutoOptionComponent {
    constructor(group) {
        this.group = group;
        /** Emits whenever the selection is toggled for this option */
        this.onSelectionChanged = new EventEmitter();
        this._selected = false;
        this._active = false;
        this.id = `cng-option-${_idCounter += 1}`;
    }
    get selected() {
        return this._selected;
    }
    get active() {
        return this._active;
    }
    ngOnInit() {
    }
    _userSelect() {
        this._selected = !this._selected;
        this.onSelectionChanged.next(this);
    }
    onClick() {
        this._userSelect();
    }
    /**
     * Purposefully leave null for unselected options to reduce screen-reader noise
     * @returns true or null
     */
    getAriaSelected() {
        return this._selected || null;
    }
    onKeydown(event) {
        if ((event.keyCode === ENTER || event.keyCode === SPACE) && !hasModifierKey(event)) {
            this._userSelect();
        }
        event.preventDefault();
    }
    select() {
        this._selected = true;
    }
    deselect() {
        this._selected = false;
    }
    // Highlightable interface
    setActiveStyles() {
        this._active = true;
    }
    setInactiveStyles() {
        this._active = false;
    }
};
CngAutoOptionComponent.ɵfac = function CngAutoOptionComponent_Factory(t) { return new (t || CngAutoOptionComponent)(ɵngcc0.ɵɵdirectiveInject(CngAutoGroupComponent, 8)); };
CngAutoOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngAutoOptionComponent, selectors: [["cng-auto-option"]], hostVars: 1, hostBindings: function CngAutoOptionComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CngAutoOptionComponent_click_HostBindingHandler() { return ctx.onClick(); })("keydown", function CngAutoOptionComponent_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-selected", ctx.getAriaSelected());
    } }, inputs: { value: "value" }, outputs: { onSelectionChanged: "onSelectionChanged" }, ngContentSelectors: _c11, decls: 2, vars: 3, consts: [[3, "ngClass"]], template: function CngAutoOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c68, ctx.active));
    } }, dependencies: [ɵngcc1.NgClass], styles: ["a.hover[_ngcontent-%COMP%]{background-color:var(--cui-background-hover)!important}"] });
CngAutoOptionComponent.ctorParameters = () => [
    { type: CngAutoGroupComponent, decorators: [{ type: Optional }] }
];
__decorate([
    Input()
], CngAutoOptionComponent.prototype, "value", void 0);
__decorate([
    Output()
], CngAutoOptionComponent.prototype, "onSelectionChanged", void 0);
CngAutoOptionComponent = __decorate([ __param(0, Optional())
], CngAutoOptionComponent);
/**
 * Determines the position to which to scroll a panel in order for an option to be into view.
 * @param optionIndex Index of the option to be scrolled into the view.
 * @param optionHeight Height of the options.
 * @param currentScrollPosition Current scroll position of the panel.
 * @param panelHeight Height of the panel.
 * @docs-private
 *
 * Taken from @angular/material
 * https://github.com/angular/components/blob/master/src/material/core/option/option.ts
 * @returns new scrollTop
 */
function _getOptionScrollPosition(optionIndex, optionHeight, currentScrollPosition, panelHeight) {
    const optionOffset = optionIndex * optionHeight;
    if (optionOffset < currentScrollPosition) {
        return optionOffset;
    }
    if (optionOffset + optionHeight > currentScrollPosition + panelHeight) {
        return Math.max(0, optionOffset - panelHeight + optionHeight);
    }
    return currentScrollPosition;
}

let _idCounter$1 = 0;
/**
 * Component for defining cng-autocomplete options. Reference it with a template
 * variable and assign it to an input with the [cngAutocomplete] directive.
 * Supports options and groups of options.
 */
let CngAutocompleteComponent = class CngAutocompleteComponent {
    constructor(_cdr) {
        this._cdr = _cdr;
        /** Optional function to transform the displayed input value from the actual value */
        this.displayWith = null;
        this._hidden = false;
        this.id = `cng-autocomplete-${_idCounter$1 += 1}`;
    }
    get hidden() {
        return this._hidden;
    }
    ngAfterContentInit() {
        this.keyManager = new ActiveDescendantKeyManager(this.options)
            .withWrap();
    }
    updateVisibility() {
        if (this.options.length) {
            this._hidden = false;
        }
        else {
            this._hidden = true;
        }
        this._cdr.markForCheck();
    }
    /**
     * Manually adjust panel scrollTop, for displaying options as you scroll
     * up/down with the keyboard
     *
     * @param scrollTop desired numerical value
     */
    setScrollTop(scrollTop) {
        if (this.panel) {
            this.panel.nativeElement.scrollTop = scrollTop;
        }
    }
    getScrollTop() {
        if (this.panel) {
            return this.panel.nativeElement.scrollTop;
        }
        return 0;
    }
};
CngAutocompleteComponent.ɵfac = function CngAutocompleteComponent_Factory(t) { return new (t || CngAutocompleteComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CngAutocompleteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngAutocompleteComponent, selectors: [["cng-autocomplete"]], contentQueries: function CngAutocompleteComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngAutoOptionComponent, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngAutoGroupComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.groups = _t);
    } }, viewQuery: function CngAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
        ɵngcc0.ɵɵviewQuery(_c69, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panel = _t.first);
    } }, inputs: { displayWith: "displayWith" }, ngContentSelectors: _c11, decls: 1, vars: 0, consts: [[1, "dropdown", "active", 3, "ngClass"], ["role", "listbox", 1, "dropdown__menu"], ["panel", ""]], template: function CngAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngAutocompleteComponent_ng_template_0_Template, 4, 3, "ng-template");
    } }, dependencies: [ɵngcc1.NgClass], styles: [".dropdown[_ngcontent-%COMP%]{width:100%}.dropdown.active[_ngcontent-%COMP%]   .dropdown__menu[_ngcontent-%COMP%]{max-height:175px}.hidden[_ngcontent-%COMP%]{display:none!important}"], changeDetection: 0 });
CngAutocompleteComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    ContentChildren(CngAutoOptionComponent, { descendants: true })
], CngAutocompleteComponent.prototype, "options", void 0);
__decorate([
    ContentChildren(CngAutoGroupComponent, { descendants: true })
], CngAutocompleteComponent.prototype, "groups", void 0);
__decorate([
    ViewChild(TemplateRef, { static: true })
], CngAutocompleteComponent.prototype, "template", void 0);
__decorate([
    ViewChild('panel')
], CngAutocompleteComponent.prototype, "panel", void 0);
__decorate([
    Input()
], CngAutocompleteComponent.prototype, "displayWith", void 0);

const ITEM_HEIGHT = 35; // Height of a dropdown item in the CUI kit
const MAX_PANEL_SIZE = 175; // Max height of a dropdown
const CNG_AUTOCOMPLETE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CngAutocompleteTriggerDirective),
    multi: true,
};
/**
 * The trigger attribute directive applied to the input/textarea you want to
 * associate typeahead values with. Provide it a cng-autocomplete component with
 * the options you want displayed in the dropdown under your input
 *
 * Some code adapted from Angular Material
 * https://github.com/angular/components/blob/master/
 * src/material/autocomplete/autocomplete-trigger.ts
 *
 */
let CngAutocompleteTriggerDirective = class CngAutocompleteTriggerDirective {
    constructor(
    // must be typed 'any', ngc doesn't like Document
    _document, _element, _overlay, _viewContainerRef) {
        this._document = _document;
        this._element = _element;
        this._overlay = _overlay;
        this._viewContainerRef = _viewContainerRef;
        this._closed$ = new Subject();
        this._disabled = false;
        this._onChange = () => { };
        this._onTouched = () => { };
    }
    /** Use this input to temporarily disable/enable the dropdown functionality */
    set cngAutocompleteDisabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get cngAutocompleteDisabled() {
        return this._disabled;
    }
    get _canOpen() {
        return !this._element.nativeElement.disabled && !this._disabled;
    }
    get _activeOption() {
        if (this.cngAutocomplete && this.cngAutocomplete.keyManager) {
            return this.cngAutocomplete.keyManager.activeItem;
        }
        return null;
    }
    get panelOpen() {
        return this._overlayRef && this._overlayRef.hasAttached() && !this.cngAutocomplete.hidden;
    }
    handleFocus() {
        if (this._canOpen) {
            this._attachOverlay();
        }
    }
    handleInput(event) {
        const target = event.target;
        let value = target.value;
        // Based on `NumberValueAccessor` from forms.
        if (target.type === 'number') {
            value = value === '' ? null : parseFloat(value);
        }
        this._onChange(value);
        if (this._canOpen) {
            this._attachOverlay();
        }
    }
    handleKeydown(event) {
        const code = event.keyCode;
        if (this._activeOption && code === ENTER && this.panelOpen) {
            // Select as if a user clicked on it
            this._activeOption.onClick();
            this._resetActive();
            event.preventDefault();
            return;
        }
        if (code === ESCAPE) {
            // Escape should close the panel like a tab
            return this.cngAutocomplete.keyManager.tabOut.next();
        }
        if (this.cngAutocomplete) {
            if (this.panelOpen || code === TAB) {
                // Hand event off to keyManager
                this.cngAutocomplete.keyManager.onKeydown(event);
            }
            else if ((code === UP_ARROW || code === DOWN_ARROW) && this._canOpen) {
                // Open the panel if it's not open
                this._attachOverlay();
            }
            if (code === UP_ARROW || code === DOWN_ARROW) {
                this._scrollToActive();
            }
        }
    }
    _attachOverlay() {
        if (!this.cngAutocomplete) {
            throw new Error(`CngAutocompleteTriggerDirective attempted to attach
				an automplete list but none was provided.
				[cngAutocomplete] directive must be provided a cng-autcomplete
				component as input.`);
        }
        let ref = this._overlayRef;
        if (!ref) {
            this._portal =
                new TemplatePortal(this.cngAutocomplete.template, this._viewContainerRef);
            ref = this._overlay.create(this._getOverlayConfig());
            this._overlayRef = ref;
        }
        if (!ref.hasAttached()) {
            ref.attach(this._portal);
            this._subscribeToCloseEvents();
        }
    }
    _getOverlayConfig() {
        return new OverlayConfig({
            scrollStrategy: this._overlay.scrollStrategies.reposition({
                scrollThrottle: 20,
            }),
            positionStrategy: this._getOverlayPosition(),
            width: this._element.nativeElement.getBoundingClientRect().width,
        });
    }
    _getOverlayPosition() {
        const belowPosition = {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        };
        const strategy = this._overlay.position()
            .flexibleConnectedTo(this._element)
            .withFlexibleDimensions(false)
            .withPush(false);
        return strategy.withPositions([belowPosition]);
    }
    _closePanel() {
        if (this._overlayRef && this._overlayRef.hasAttached()) {
            this._overlayRef.detach();
        }
        this._closed$.next();
    }
    _getOptionSelectedStream() {
        if (this.cngAutocomplete && this.cngAutocomplete.options) {
            return merge(...this.cngAutocomplete.options.map(option => option.onSelectionChanged));
        }
        return of(null);
    }
    _getClickOutsideStream() {
        return merge(fromEvent(this._document, 'click'), fromEvent(this._document, 'touchend')).pipe(filter(evt => {
            const target = (evt.target);
            return this._overlayRef
                && this._overlayRef.hasAttached()
                && target !== this._element.nativeElement
                && !this._overlayRef.overlayElement.contains(target);
        }));
    }
    _subscribeToCloseEvents() {
        // Every time the list of options changes, reset our on select subscriptions
        const optionChanges = this.cngAutocomplete.options.changes.pipe(
        // Defer emitting to the stream until the next tick, because changing
        // bindings in here will cause "changed after checked" errors.
        delay(0));
        merge(of(null), optionChanges).pipe(switchMap(() => {
            this.cngAutocomplete.updateVisibility();
            this._resetActive();
            return merge(this.cngAutocomplete.keyManager.tabOut, this._getOptionSelectedStream(), this._getClickOutsideStream()).pipe(map(evt => evt instanceof CngAutoOptionComponent ? evt : null), take(1), takeUntil(this._closed$));
        }))
            .subscribe(opt => {
            this._setValueAndClose(opt);
        });
    }
    _setTriggerValue(value) {
        let display = value;
        if (this.cngAutocomplete && this.cngAutocomplete.displayWith) {
            display = this.cngAutocomplete.displayWith(value);
        }
        // Don't want to default it if display === 0
        display = display != null ? display : '';
        this._element.nativeElement.value = display;
    }
    _setValueAndClose(option) {
        if (option) {
            // Clear last value
            this.cngAutocomplete.options.forEach(o => {
                if (o !== option) {
                    o.deselect();
                }
            });
            this._setTriggerValue(option.value);
            this._onChange(option.value);
        }
        this._closePanel();
    }
    _resetActive() {
        this.cngAutocomplete.keyManager.setActiveItem(-1);
    }
    _scrollToActive() {
        const idx = this.cngAutocomplete.keyManager.activeItemIndex || 0;
        const groupNum = this._countGroupsBeforeOption(idx, this.cngAutocomplete.groups, this.cngAutocomplete.options);
        // If there's groups and we're on the first option,
        // scroll all the way to the top so we can see the first group name
        if (idx === 0 && groupNum === 1) {
            this.cngAutocomplete.setScrollTop(0);
            return;
        }
        const newPos = _getOptionScrollPosition(idx + groupNum, ITEM_HEIGHT, this.cngAutocomplete.getScrollTop(), MAX_PANEL_SIZE);
        this.cngAutocomplete.setScrollTop(newPos);
    }
    // ControlValueAccessor implementation
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    writeValue(value) {
        this._setTriggerValue(value);
    }
    setDisabledState(disabled) {
        this._element.nativeElement.disabled = disabled;
    }
    _countGroupsBeforeOption(optIndex, groups, items) {
        if (!groups.length) {
            return 0;
        }
        const optionGroups = groups.toArray();
        const options = items.toArray();
        let counter = 0;
        for (let i = 0; i <= optIndex; i += 1) {
            if (options[i].group && options[i].group === optionGroups[counter]) {
                counter += 1;
            }
        }
        return counter;
    }
};
CngAutocompleteTriggerDirective.ɵfac = function CngAutocompleteTriggerDirective_Factory(t) { return new (t || CngAutocompleteTriggerDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
CngAutocompleteTriggerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngAutocompleteTriggerDirective, selectors: [["input", "cngAutocomplete", ""], ["textarea", "cngAutocomplete", ""]], hostVars: 6, hostBindings: function CngAutocompleteTriggerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function CngAutocompleteTriggerDirective_focusin_HostBindingHandler() { return ctx.handleFocus(); })("input", function CngAutocompleteTriggerDirective_input_HostBindingHandler($event) { return ctx.handleInput($event); })("keydown", function CngAutocompleteTriggerDirective_keydown_HostBindingHandler($event) { return ctx.handleKeydown($event); })("blur", function CngAutocompleteTriggerDirective_blur_HostBindingHandler() { return ctx._onTouched(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.cngAutocompleteDisabled ? null : "combobox")("aria-autocomplete", ctx.cngAutocompleteDisabled ? null : "list")("aria-activedescendant", ctx.panelOpen && ctx._activeOption ? ctx._activeOption.id : null)("aria-expanded", ctx.cngAutocompleteDisabled ? null : ctx.panelOpen == null ? null : ctx.panelOpen.toString())("aria-owns", ctx.cngAutocompleteDisabled || !ctx.panelOpen ? null : ctx.cngAutocomplete == null ? null : ctx.cngAutocomplete.id)("aria-haspopup", !ctx.cngAutocompleteDisabled);
    } }, inputs: { cngAutocompleteDisabled: "cngAutocompleteDisabled", cngAutocomplete: "cngAutocomplete" }, features: [ɵngcc0.ɵɵProvidersFeature([CNG_AUTOCOMPLETE_VALUE_ACCESSOR])] });
CngAutocompleteTriggerDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef },
    { type: Overlay },
    { type: ViewContainerRef }
];
__decorate([
    Input()
], CngAutocompleteTriggerDirective.prototype, "cngAutocomplete", void 0);
__decorate([
    Input()
], CngAutocompleteTriggerDirective.prototype, "cngAutocompleteDisabled", null);
CngAutocompleteTriggerDirective = __decorate([ __param(0, Optional()), __param(0, Inject(DOCUMENT))
], CngAutocompleteTriggerDirective);

/**
 * Module for displaying any generic autocomplete/typeahead underneath a text input
 * Since it attaches to a regular HTML input you can make use of angular's reactive forms to
 * monitor control value changes and update/filter the typeahead options however you see fit.
 * Appropriate for fetching options from an API or just filtering a set of data as the user types.
 *
 * Use this over the cng-select if you want to still allow free-form inputs, or
 * otherwise need a more generic auto completion that's not like a native HTML select
 *
 * Much inspiration for the API comes from the Angular Material autocomplete
 * See: https://material.angular.io/components/autocomplete/overview
 *
 * Also makes use of @angular/cdk overlays to display the option content.
 */
let CngAutocompleteModule = class CngAutocompleteModule {
};
CngAutocompleteModule.ɵfac = function CngAutocompleteModule_Factory(t) { return new (t || CngAutocompleteModule)(); };
CngAutocompleteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngAutocompleteModule });
CngAutocompleteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        OverlayModule] });

var CNG_TOOLTIP_POSITION;
(function (CNG_TOOLTIP_POSITION) {
    CNG_TOOLTIP_POSITION["left"] = "left";
    CNG_TOOLTIP_POSITION["right"] = "right";
    CNG_TOOLTIP_POSITION["top"] = "top";
    CNG_TOOLTIP_POSITION["bottom"] = "bottom";
})(CNG_TOOLTIP_POSITION || (CNG_TOOLTIP_POSITION = {}));
/**
 * Use this component to define the tooltip's content.
 * Anything placed inside will be projected.
 * Attach a template variable and reference it with the [cngTooltip] directive
 */
let CngTooltipComponent = class CngTooltipComponent {
    constructor(_cdr) {
        this._cdr = _cdr;
        /** Max height of tooltip content as a string, pass any valid css value */
        this.maxHeight = '500px';
        /** Max width of tooltip content as a string, pass any valid css value */
        this.maxWidth = '500px';
    }
    get position() {
        return this._position;
    }
    set position(newPos) {
        this._position = newPos;
        this._cdr.markForCheck();
    }
};
CngTooltipComponent.ɵfac = function CngTooltipComponent_Factory(t) { return new (t || CngTooltipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CngTooltipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngTooltipComponent, selectors: [["cng-tooltip"]], viewQuery: function CngTooltipComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { maxHeight: "maxHeight", maxWidth: "maxWidth" }, ngContentSelectors: _c11, decls: 1, vars: 0, consts: [[3, "ngStyle"]], template: function CngTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngTooltipComponent_ng_template_0_Template, 2, 7, "ng-template");
    } }, dependencies: [ɵngcc1.NgStyle], styles: [".tooltip-container[_ngcontent-%COMP%]{z-index:10000;background:var(--cui-color-gray-700);box-shadow:0 2px 5px 0 rgba(0,0,0,.3);padding:var(--cui-spacing-half);overflow:auto;border-radius:var(--cui-border-radius)}.tooltip-top.tooltip-container[_ngcontent-%COMP%]::after{content:\" \";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:var(--cui-color-gray-700) transparent transparent transparent}.tooltip-bottom.tooltip-container[_ngcontent-%COMP%]::after{content:\" \";position:absolute;top:-10px;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent var(--cui-color-gray-700) transparent}.tooltip-left.tooltip-container[_ngcontent-%COMP%]::after{content:\" \";position:absolute;top:50%;right:-10px;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent transparent var(--cui-color-gray-700)}.tooltip-right.tooltip-container[_ngcontent-%COMP%]::after{content:\" \";position:absolute;top:50%;left:-5px;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent var(--cui-color-gray-700) transparent transparent}"], changeDetection: 0 });
CngTooltipComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    ViewChild(TemplateRef, { static: true })
], CngTooltipComponent.prototype, "template", void 0);
__decorate([
    Input()
], CngTooltipComponent.prototype, "maxHeight", void 0);
__decorate([
    Input()
], CngTooltipComponent.prototype, "maxWidth", void 0);

/**
 * Apply this directive to the element you want to show a tooltip.
 * Make sure you supply a <cng-tooltip> component as input
 */
let CngTooltipTriggerDirective = class CngTooltipTriggerDirective {
    constructor(_element, _overlay, _viewContainerRef) {
        this._element = _element;
        this._overlay = _overlay;
        this._viewContainerRef = _viewContainerRef;
        this._disabled = false;
        this._destroy$ = new Subject();
        this._resetSub$ = new Subject(); // Emits each time we reset the mouse event sub
        this._openChange$ = new Subject(); // Emit true to open, false to close
        /** Delay on hover before opening tooltip in ms */
        this.cngTooltipDelay = 1000;
        /** Delay before closing the tooltip after your mouse leaves in ms */
        this.cngTooltipRemovalDelay = 500;
        /** Position of the tooltip relative to trigger element */
        this.cngTooltipPosition = CNG_TOOLTIP_POSITION.right;
    }
    get _canOpen() {
        return !this._element.nativeElement.disabled && !this._disabled;
    }
    /** Use this to temporarily disable tooltip popup */
    set cngTooltipDisabled(disabled) {
        this._disabled = coerceBooleanProperty(disabled);
    }
    onMouseEnter() {
        this._openChange$.next(true);
    }
    onMouseLeave() {
        this._openChange$.next(false);
    }
    // For keyboard focusing
    onFocus() {
        this._openChange$.next(true);
    }
    onBlur() {
        this._openChange$.next(false);
    }
    ngOnInit() {
        if (!this.cngTooltip) {
            throw new Error(`CngTooltipTriggerDirective attempted to attach
				a tooltip but none was provided.
				[cngTooltip] directive must be provided a cng-tooltip
				component as input.`);
        }
    }
    ngOnChanges() {
        // Pick up tooltip/position, etc. changes, reinit overlay
        if (this._overlayRef) {
            this._overlayRef.detach();
            this._overlayRef = null;
        }
        this.subToMouseover();
    }
    openTooltip() {
        let ref = this._overlayRef;
        if (!ref) {
            this.cngTooltip.position = this.cngTooltipPosition;
            this._portal =
                new TemplatePortal(this.cngTooltip.template, this._viewContainerRef);
            ref = this._overlay.create(this._getOverlayConfig());
            this._overlayRef = ref;
            this.subToMouseover();
        }
        if (!ref.hasAttached()) {
            ref.attach(this._portal);
        }
    }
    _getOverlayConfig() {
        return new OverlayConfig({
            scrollStrategy: this._overlay.scrollStrategies.close(),
            positionStrategy: this._getOverlayPosition(),
        });
    }
    _getOverlayPosition() {
        const strategy = this._overlay.position()
            .flexibleConnectedTo(this._element)
            .withFlexibleDimensions(false)
            .withPush(false);
        return strategy.withPositions([this._getConnectedPosition(this.cngTooltipPosition)]);
    }
    _getConnectedPosition(position) {
        switch (position) {
            case CNG_TOOLTIP_POSITION.bottom:
                return {
                    originX: 'center',
                    originY: 'bottom',
                    overlayX: 'center',
                    overlayY: 'top',
                    offsetY: 5,
                };
            case CNG_TOOLTIP_POSITION.top:
                return {
                    originX: 'center',
                    originY: 'top',
                    overlayX: 'center',
                    overlayY: 'bottom',
                    offsetY: -5,
                };
            case CNG_TOOLTIP_POSITION.left:
                return {
                    originX: 'start',
                    originY: 'center',
                    overlayX: 'end',
                    overlayY: 'center',
                    offsetX: -5,
                };
            case CNG_TOOLTIP_POSITION.right:
                return {
                    originX: 'end',
                    originY: 'center',
                    overlayX: 'start',
                    overlayY: 'center',
                    offsetX: 5,
                };
        }
    }
    removeTooltip() {
        if (this._overlayRef) {
            this._overlayRef.detach();
        }
    }
    subToMouseover() {
        this._resetSub$.next();
        // Subscribe to mouse enter/leave events
        let overlaySubs = [];
        if (this._overlayRef) {
            overlaySubs = [
                fromEvent(this._overlayRef.overlayElement, 'mouseenter')
                    .pipe(map(() => true)),
                fromEvent(this._overlayRef.overlayElement, 'mouseleave')
                    .pipe(map(() => false)),
            ];
        }
        merge(...overlaySubs, this._openChange$).pipe(switchMap(mouseIn => {
            if (mouseIn) {
                return of(mouseIn).pipe(delay(this.cngTooltipDelay));
            }
            return of(mouseIn).pipe(delay(this.cngTooltipRemovalDelay));
        }), takeUntil(this._resetSub$), takeUntil(this._destroy$))
            .subscribe(mouseIn => {
            if (mouseIn && this._canOpen) {
                this.openTooltip();
            }
            else {
                this.removeTooltip();
            }
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
        this.removeTooltip();
    }
};
CngTooltipTriggerDirective.ɵfac = function CngTooltipTriggerDirective_Factory(t) { return new (t || CngTooltipTriggerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
CngTooltipTriggerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngTooltipTriggerDirective, selectors: [["", "cngTooltip", ""]], hostBindings: function CngTooltipTriggerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function CngTooltipTriggerDirective_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseleave", function CngTooltipTriggerDirective_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); })("focus", function CngTooltipTriggerDirective_focus_HostBindingHandler() { return ctx.onFocus(); })("blur", function CngTooltipTriggerDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { cngTooltipDelay: "cngTooltipDelay", cngTooltipRemovalDelay: "cngTooltipRemovalDelay", cngTooltipPosition: "cngTooltipPosition", cngTooltipDisabled: "cngTooltipDisabled", cngTooltip: "cngTooltip" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
CngTooltipTriggerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Overlay },
    { type: ViewContainerRef }
];
__decorate([
    Input()
], CngTooltipTriggerDirective.prototype, "cngTooltip", void 0);
__decorate([
    Input()
], CngTooltipTriggerDirective.prototype, "cngTooltipDelay", void 0);
__decorate([
    Input()
], CngTooltipTriggerDirective.prototype, "cngTooltipRemovalDelay", void 0);
__decorate([
    Input()
], CngTooltipTriggerDirective.prototype, "cngTooltipDisabled", null);
__decorate([
    Input()
], CngTooltipTriggerDirective.prototype, "cngTooltipPosition", void 0);
__decorate([
    HostListener('mouseenter')
], CngTooltipTriggerDirective.prototype, "onMouseEnter", null);
__decorate([
    HostListener('mouseleave')
], CngTooltipTriggerDirective.prototype, "onMouseLeave", null);
__decorate([
    HostListener('focus')
], CngTooltipTriggerDirective.prototype, "onFocus", null);
__decorate([
    HostListener('blur')
], CngTooltipTriggerDirective.prototype, "onBlur", null);

/**
 * Module for adding tooltips with arbitrary projected content
 *
 * Use this for more advanced tooltips, where you want templated content. Also
 * suitable for attaching to inputs when they are focused and other scenarios that
 * the plain css-based toolkit tooltips can't handle
 * These are more accessibility-friendly as well, since they show upon
 * keyboard focus, not just mouse hover
 */
let CngTooltipModule = class CngTooltipModule {
};
CngTooltipModule.ɵfac = function CngTooltipModule_Factory(t) { return new (t || CngTooltipModule)(); };
CngTooltipModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngTooltipModule });
CngTooltipModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        OverlayModule] });

const FileTypes = [
    {
        name: 'archive',
        icon: 'icon-file-archive-o',
        extensions: [
            'tar', 'jar', 'cpio', 'zip', 'zipx', 'iso', 'ar', 'gz', 'gzip',
            'bz2', 'apk', 'car', 'cab', 'dmg', 'rar', 'z', 'Z',
        ],
    },
    {
        name: 'audio',
        icon: 'icon-file-audio-o',
        extensions: [
            'au', 'aac', 'm4p', 'm4a', 'mp1', 'mp2', 'mp3',
            'mpg', 'mpeg', 'oga', 'ogg', 'wav', 'webm', 'wma',
        ],
    },
    {
        name: 'code',
        icon: 'icon-file-code-o',
        extensions: [
            'js', 'css', 'asp', 'aspx', 'jsp', 'htm', 'html', 'php', 'pl',
            'asm', 'java', 'lib', 'o', 'scpt', 'vbs', 'cc', 'sql',
        ],
    },
    {
        name: 'image',
        icon: 'icon-file-image-o',
        extensions: [
            'jpg', 'jpeg', 'tif', 'tiff', 'png', 'gif', 'bmp', 'ico', 'icon', 'pic',
        ],
    },
    {
        name: 'ms-word',
        icon: 'icon-file-word-o',
        extensions: ['doc', 'dot', 'docx', 'docm', 'dotm'],
    },
    {
        name: 'ms-excel',
        icon: 'icon-file-excel-o',
        extensions: ['xls', 'xlt', 'xla', 'xlsx', 'xltx', 'xlsm', 'xltm', 'xlam', 'xlsb'],
    },
    {
        name: 'ms-powerpoint',
        icon: 'icon-file-powerpoint-o',
        extensions: [
            'ppt', 'pot', 'pps', 'ppa', 'pptx',
            'potx', 'ppsx', 'ppam', 'pptm', 'potm', 'ppsm',
        ],
    },
    {
        name: 'pdf',
        icon: 'icon-file-pdf-o',
        extensions: ['pdf'],
    },
    {
        name: 'text',
        icon: 'icon-file-text-o',
        extensions: ['txt', 'text', 'tex', 'log', 'cfg', 'csv'],
    },
    {
        name: 'video',
        icon: 'icon-file-video-o',
        extensions: ['mp4', 'm4v', 'mov', 'flv', 'm3u8', 'ts', '3gp', 'avi', 'wmv'],
    },
];

var CngDropzoneComponent_1;
/**
 * Component for file upload and dropzone
 *
 * @example
 * <cui-dropzone [formControl]="myFilesControl">
 * </cui-dropzone>
 *
 * <example-url>/pages/cx-ppd/cui-ng/examples/dropzone</example-url>
 */
let CngDropzoneComponent = CngDropzoneComponent_1 = class CngDropzoneComponent {
    constructor() {
        this._destroy$ = new Subject();
        this._modelChanged$ = new Subject();
        /**
         * Allowed extensions, others will be blocked by native file input
         */
        this.allowExtensions = [];
        this._multi = false;
        this._disabled = false;
        /**
         * Total file size in bytes
         */
        this.totalSize = 0;
        this._onChange = () => { };
    }
    /**
     * The files array to share with the parent
     */
    get files() {
        return this._fileSelection.selected;
    }
    get multi() {
        return this._multi;
    }
    /**
     * Allow single or multi-file upload
     */
    set multi(multi) {
        this._multi = coerceBooleanProperty(multi);
    }
    get disabled() {
        return this._disabled;
    }
    openFileDialog(evt) {
        if (!evt.defaultPrevented) {
            const event = new MouseEvent('click', { bubbles: false });
            this.fileInput.nativeElement.dispatchEvent(event);
        }
    }
    // ControlValueAccessor functions
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched() { }
    writeValue(val) {
        this._fileSelection.clear();
        let selected = [];
        if (val && !Array.isArray(val)) {
            selected = [val];
        }
        else if (val) {
            selected = val;
        }
        this._fileSelection.select(...selected);
    }
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
    }
    ngOnInit() {
        this._fileSelection = new SelectionModel(this._multi);
        this._subToSelectionModel();
    }
    ngOnChanges(changes) {
        // If "multi" option changes, just reset the selection entirely to empty
        if (changes.multi && !changes.multi.isFirstChange()) {
            this._fileSelection.clear();
            this._fileSelection = new SelectionModel(this._multi);
            this._subToSelectionModel();
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
    }
    _subToSelectionModel() {
        this._modelChanged$.next();
        this._fileSelection.changed.pipe(takeUntil(this._destroy$), takeUntil(this._modelChanged$)).subscribe(selectionChange => {
            this._onChange(selectionChange.source.selected);
            this.updateSizes();
        });
    }
    /**
     * Returns the extension of a file from its name
     * @param  filename
     * @return          extension
     */
    getExtension(filename) {
        return filename.substr(filename.lastIndexOf('.') + 1);
    }
    /**
     * Gets the title for a file
     * @param file
     * @returns file name
     */
    getTitle(file) {
        return file.name;
    }
    /**
     * Gets the icon for a file
     * @param  file
     * @return icon
     */
    getIcon(file) {
        const filename = file.name;
        let icon = 'icon-file-o text-muted';
        if (filename.length > 0) {
            FileTypes.forEach((value) => {
                if (value.extensions.indexOf(this.getExtension(filename)) > -1) {
                    return icon = `${value.icon} text-muted`;
                }
            });
        }
        return icon;
    }
    /**
     * Splices a file out of the files array
     * @param event event that fired this
     * @param file File to remove
     */
    removeFile(event, file) {
        // Only do action on ENTER key
        if (event instanceof KeyboardEvent && event.keyCode !== ENTER) {
            return;
        }
        event.preventDefault();
        this._fileSelection.deselect(file);
    }
    /**
     * Updates the total size value
     */
    updateSizes() {
        this.totalSize = [...this.files]
            .reduce((sum, file) => (sum + file.size), 0);
    }
    /**
     * Handler for file input
     * @param filesToSelect
     */
    selectFiles(filesToSelect) {
        this._fileSelection.select(...filesToSelect);
    }
    /**
     * Handler for fileInput onChange
     * @param event
     */
    onChange(event) {
        const files = Array.from(event.target.files);
        if (files.length) {
            this.selectFiles(files);
            this.fileInput.nativeElement.value = null;
        }
    }
    /**
     * Handler for entering drag location
     * @param event
     */
    onDragEnter(event) {
        event.preventDefault();
    }
    /**
     * Handler for hovering over drag location
     * @param event
     */
    onDragOver(event) {
        event.preventDefault();
    }
    /**
     * Handler for dropping files on a location
     * @param event
     */
    onDrop(event) {
        event.preventDefault();
        this.selectFiles(Array.from(event.dataTransfer.files));
    }
    /**
     * Open dialog when ENTER is pressed
     * @param event keyboard event
     */
    onKeydown(event) {
        if (event.keyCode === ENTER) {
            this.openFileDialog(event);
        }
    }
};
CngDropzoneComponent.ɵfac = function CngDropzoneComponent_Factory(t) { return new (t || CngDropzoneComponent)(); };
CngDropzoneComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngDropzoneComponent, selectors: [["cng-dropzone"]], viewQuery: function CngDropzoneComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c72, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { allowExtensions: "allowExtensions", multi: "multi" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CngDropzoneComponent_1),
                multi: true
            },
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c80, decls: 12, vars: 9, consts: function () { let i18n_73; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_1463518407627518359$$FESM2015_CISCO_CUI_NG_JS___74 = goog.getMsg("Selected: {$interpolation}", { "interpolation": "\uFFFD0\uFFFD" }, { original_code: { "interpolation": "{{ files.length }}" } });
        i18n_73 = MSG_EXTERNAL_1463518407627518359$$FESM2015_CISCO_CUI_NG_JS___74;
    }
    else {
        i18n_73 = $localize `:␟c7215fd3b2f62bbf608400ff959d781813ccba52␟1463518407627518359:Selected: ${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } let i18n_75; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_3771790480224731637$$FESM2015_CISCO_CUI_NG_JS___76 = goog.getMsg("Total: {$interpolation}", { "interpolation": "\uFFFD0\uFFFD" }, { original_code: { "interpolation": "{{ totalSize | fileSize }}" } });
        i18n_75 = MSG_EXTERNAL_3771790480224731637$$FESM2015_CISCO_CUI_NG_JS___76;
    }
    else {
        i18n_75 = $localize `:␟eb08750af6a51abab95a38f2c4edfe2703435a4c␟3771790480224731637:Total: ${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [["type", "file", 1, "noDisplay", 3, "accept", "multiple", "disabled", "change"], ["fileInput", ""], ["tabindex", "0", 1, "file-drop", "panel", "text-center", 3, "ngClass", "dragenter", "dragover", "click", "keydown", "drop"], [1, "overlay"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["filesSelected", ""], ["noFilesSelected", ""], ["fileCards", ""], [1, "file-drop__container", "container--fluid"], [1, "row"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "file-drop__filecnt", 4, "ngIf"], [1, "file-drop__filecnt"], [1, "flex", "flex-center"], i18n_73, [1, "base-margin-left"], i18n_75, [1, "half-margin-bottom", "half-margin-top"], [1, "file-drop__icon", "icon-upload", "icon--medium"], ["class", "file-drop__card", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "file-drop__card", 3, "ngClass"], [1, "panel", "panel--ltgray", "panel--skinny", 3, "title"], ["class", "icon-close pull-right", "tabindex", "0", 3, "click", "keydown", 4, "ngIf"], [1, "file-icon", 3, "ngClass", "title"], [1, "text-ellipsis", 3, "innerHTML"], [3, "innerHTML"], ["tabindex", "0", 1, "icon-close", "pull-right", 3, "click", "keydown"]]; }, template: function CngDropzoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c79);
        ɵngcc0.ɵɵelementStart(0, "div")(1, "input", 0, 1);
        ɵngcc0.ɵɵlistener("change", function CngDropzoneComponent_Template_input_change_1_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵlistener("dragenter", function CngDropzoneComponent_Template_div_dragenter_3_listener($event) { return ctx.onDragEnter($event); })("dragover", function CngDropzoneComponent_Template_div_dragover_3_listener($event) { return ctx.onDragOver($event); })("click", function CngDropzoneComponent_Template_div_click_3_listener($event) { return ctx.openFileDialog($event); })("keydown", function CngDropzoneComponent_Template_div_keydown_3_listener($event) { return ctx.onKeydown($event); })("drop", function CngDropzoneComponent_Template_div_drop_3_listener($event) { return ctx.onDrop($event); });
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, CngDropzoneComponent_ng_container_5_Template, 1, 0, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(6, CngDropzoneComponent_ng_template_6_Template, 4, 5, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, CngDropzoneComponent_ng_template_8_Template, 4, 0, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(10, CngDropzoneComponent_ng_template_10_Template, 1, 1, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(7);
        const _r4 = ɵngcc0.ɵɵreference(9);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("accept", ctx.allowExtensions ? ctx.allowExtensions.join(",") : "");
        ɵngcc0.ɵɵproperty("multiple", ctx.multi)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c31, ctx.disabled));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.files.length)("ngIfThen", _r2)("ngIfElse", _r4);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc3.FileSizePipe], styles: [".noDisplay[_ngcontent-%COMP%]{display:none}.file-drop[_ngcontent-%COMP%]{border:1px dashed!important;cursor:pointer}.file-drop.disabled[_ngcontent-%COMP%]{cursor:default}.file-drop[_ngcontent-%COMP%]:hover > .overlay[_ngcontent-%COMP%]{width:100%;height:100%;position:absolute;left:0;top:0;background-color:#000;opacity:.025}"] });
__decorate([
    Input()
], CngDropzoneComponent.prototype, "allowExtensions", void 0);
__decorate([
    Input()
], CngDropzoneComponent.prototype, "multi", null);
__decorate([
    ViewChild('fileInput')
], CngDropzoneComponent.prototype, "fileInput", void 0);

let CngDropzoneModule = class CngDropzoneModule {
};
CngDropzoneModule.ɵfac = function CngDropzoneModule_Factory(t) { return new (t || CngDropzoneModule)(); };
CngDropzoneModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngDropzoneModule });
CngDropzoneModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FileSizeModule] });

let CngStepLabel = class CngStepLabel extends CdkStepLabel {
};
CngStepLabel.ɵfac = /*@__PURE__*/ function () { let ɵCngStepLabel_BaseFactory; return function CngStepLabel_Factory(t) { return (ɵCngStepLabel_BaseFactory || (ɵCngStepLabel_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngStepLabel)))(t || CngStepLabel); }; }();
CngStepLabel.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngStepLabel, selectors: [["", "cngStepLabel", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });

var CngStep_1, CngStepper_1;
/**
 * List of valid colors for the cng-stepper
 */
var CngStepperColor;
(function (CngStepperColor) {
    CngStepperColor["PRIMARY"] = "primary";
    CngStepperColor["SECONDARY"] = "secondary";
    CngStepperColor["SUCCESS"] = "success";
    CngStepperColor["DARK"] = "dark";
})(CngStepperColor || (CngStepperColor = {}));
/**
 * List of valid sizes for cng-stepper
 */
var CngStepperSize;
(function (CngStepperSize) {
    CngStepperSize["DEFAULT"] = "default";
    CngStepperSize["SMALL"] = "small";
    CngStepperSize["LARGE"] = "large";
    CngStepperSize["DOT"] = "dot";
})(CngStepperSize || (CngStepperSize = {}));
/**
 * An individual step, to be provided as ContentChildren to the cng-stepper component.
 * Note that a label can be provided either as a plain [label] Input, or via
 * an ng-template with the cngStepLabel directive for cases where simple text won't suffice.
 */
let CngStep = CngStep_1 = class CngStep extends CdkStep {
    constructor(stepper, stepperOptions) {
        super(stepper, stepperOptions);
        this._cdkStepper = stepper;
    }
    select() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stepAfter) {
                const doStep = yield this.stepAfter();
                if (doStep) {
                    this._cdkStepper.selected = this;
                }
            }
            else {
                this._cdkStepper.selected = this;
            }
        });
    }
};
CngStep.ɵfac = function CngStep_Factory(t) { return new (t || CngStep)(ɵngcc0.ɵɵdirectiveInject(forwardRef(() => CngStepper)), ɵngcc0.ɵɵdirectiveInject(STEPPER_GLOBAL_OPTIONS, 8)); };
CngStep.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngStep, selectors: [["cng-step"]], contentQueries: function CngStep_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngStepLabel, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stepLabel = _t.first);
    } }, inputs: { stepAfter: "stepAfter" }, exportAs: ["cngStep"], features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: CdkStep, useExisting: CngStep_1 },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c11, decls: 1, vars: 0, template: function CngStep_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CngStep_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2, changeDetection: 0 });
CngStep.ctorParameters = () => [
    { type: CngStepper, decorators: [{ type: Inject, args: [forwardRef(() => CngStepper),] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [STEPPER_GLOBAL_OPTIONS,] }] }
];
__decorate([
    ContentChild(CngStepLabel)
], CngStep.prototype, "stepLabel", void 0);
__decorate([
    Input()
], CngStep.prototype, "stepAfter", void 0);
CngStep = CngStep_1 = __decorate([ __param(0, Inject(forwardRef(() => CngStepper))),
    __param(1, Optional()), __param(1, Inject(STEPPER_GLOBAL_OPTIONS))
], CngStep);
/**
 * Base directive which the cng-horizontal-stepper extends into a concrete component
 * TODO: Add a cng-vertical-stepper as well
 */
let CngStepper = CngStepper_1 = class CngStepper extends CdkStepper {
    constructor() {
        super(...arguments);
        /** Size of step icons */
        this.size = CngStepperSize.DEFAULT;
        /** Color of step icons */
        this.color = CngStepperColor.PRIMARY;
    }
    ngAfterContentInit() {
    }
};
CngStepper.ɵfac = /*@__PURE__*/ function () { let ɵCngStepper_BaseFactory; return function CngStepper_Factory(t) { return (ɵCngStepper_BaseFactory || (ɵCngStepper_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngStepper)))(t || CngStepper); }; }();
CngStepper.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngStepper, selectors: [["", "cngStepper", ""]], contentQueries: function CngStepper_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CngStep, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._steps = _t);
    } }, inputs: { size: "size", color: "color" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: CdkStepper,
                useExisting: CngStepper_1
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    ContentChildren(CngStep, { descendants: true })
], CngStepper.prototype, "_steps", void 0);
__decorate([
    Input()
], CngStepper.prototype, "size", void 0);
__decorate([
    Input()
], CngStepper.prototype, "color", void 0);

/**
 * A single header containing clickable icon for each step
 */
let CngStepHeaderComponent = class CngStepHeaderComponent extends CdkStepHeader {
    constructor(_focusMonitor, _element, changeDetectorRef) {
        super(_element);
        this._focusMonitor = _focusMonitor;
        this._element = _element;
        this.changeDetectorRef = changeDetectorRef;
        /** Whether to show the step number inside icon (true for all sizes besides dot) */
        this.showNumber = true;
        /** Output to emit when the header icon is clicked */
        this.headerClicked = new EventEmitter();
    }
    ngAfterViewInit() {
        this._focusMonitor.monitor(this._element, true);
    }
    ngOnDestroy() {
        this._focusMonitor.stopMonitoring(this._element);
    }
    focus() {
        this._focusMonitor.focusVia(this._element, 'program');
    }
    _getDefaultTextForState(state) {
        if (state === 'number') {
            return `${this.index + 1}`;
        }
        if (state === 'edit') {
            return 'create';
        }
        if (state === 'error') {
            return 'warning';
        }
        return state;
    }
    onClick(event) {
        this.headerClicked.emit(event);
    }
    get templateLabel() {
        return this.label instanceof CngStepLabel ? this.label : null;
    }
    get stringLabel() {
        return this.label instanceof CngStepLabel ? null : this.label;
    }
};
CngStepHeaderComponent.ɵfac = function CngStepHeaderComponent_Factory(t) { return new (t || CngStepHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.FocusMonitor), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CngStepHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngStepHeaderComponent, selectors: [["cng-step-header"]], hostAttrs: ["role", "tab", 1, "step", "cng-step-header"], hostVars: 4, hostBindings: function CngStepHeaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.active)("visited", ctx.completed && !ctx.active);
    } }, inputs: { showNumber: "showNumber", state: "state", label: "label", errorMessage: "errorMessage", index: "index", selected: "selected", active: "active", completed: "completed", optional: "optional" }, outputs: { headerClicked: "headerClicked" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 4, consts: [["class", "step__icon", 3, "click", 4, "ngIf"], [1, "step__label"], [4, "ngIf"], [1, "step__icon", 3, "click"], [1, "icon-check"], [4, "ngTemplateOutlet"]], template: function CngStepHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, CngStepHeaderComponent_div_1_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(2, CngStepHeaderComponent_div_2_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtemplate(4, CngStepHeaderComponent_ng_container_4_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(5, CngStepHeaderComponent_ng_container_5_Template, 3, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.completed && !ctx.active);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.completed && !ctx.active));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.templateLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.stringLabel);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: [".cng-step-header{outline:0;position:relative;box-sizing:content-box;-webkit-tap-highlight-color:transparent}.step__icon{cursor:pointer}"], encapsulation: 2, changeDetection: 0 });
CngStepHeaderComponent.ctorParameters = () => [
    { type: FocusMonitor },
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "state", void 0);
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "label", void 0);
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "index", void 0);
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "selected", void 0);
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "active", void 0);
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "completed", void 0);
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "optional", void 0);
__decorate([
    Input()
], CngStepHeaderComponent.prototype, "showNumber", void 0);
__decorate([
    Output()
], CngStepHeaderComponent.prototype, "headerClicked", void 0);

var CngHorizontalStepper_1;
/**
 * This is the actual component you will likely use in your template.
 * Provide it with children <cng-step> components for each step you want
 * to be available.
 */
let CngHorizontalStepper = CngHorizontalStepper_1 = class CngHorizontalStepper extends CngStepper {
};
CngHorizontalStepper.ɵfac = /*@__PURE__*/ function () { let ɵCngHorizontalStepper_BaseFactory; return function CngHorizontalStepper_Factory(t) { return (ɵCngHorizontalStepper_BaseFactory || (ɵCngHorizontalStepper_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngHorizontalStepper)))(t || CngHorizontalStepper); }; }();
CngHorizontalStepper.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CngHorizontalStepper, selectors: [["cng-horizontal-stepper"]], hostAttrs: ["aria-orientation", "horizontal", "role", "tablist", 1, "cng-stepper-horizontal"], inputs: { selectedIndex: "selectedIndex" }, exportAs: ["cngHorizontalStepper"], features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: CngStepper, useExisting: CngHorizontalStepper_1 },
            { provide: CdkStepper, useExisting: CngHorizontalStepper_1 },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 6, consts: [[4, "ngFor", "ngForOf"], [1, "cng-horizontal-content-container"], ["class", "cng-horizontal-stepper-content", "role", "tabpanel", 3, "id", 4, "ngFor", "ngForOf"], [1, "cng-horizontal-stepper-header", 3, "tabIndex", "id", "index", "state", "label", "selected", "active", "completed", "optional", "errorMessage", "showNumber", "keydown", "headerClicked"], ["role", "tabpanel", 1, "cng-horizontal-stepper-content", 3, "id"], [3, "ngTemplateOutlet"]], template: function CngHorizontalStepper_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, CngHorizontalStepper_ng_container_1_Template, 2, 17, "ng-container", 0);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, CngHorizontalStepper_div_3_Template, 2, 5, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate2("steps steps--", ctx.color, " steps--", ctx.size, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet, CngStepHeaderComponent], styles: [".cng-horizontal-stepper-content{outline:0;transition:opacity .5s}.cng-horizontal-stepper-content[aria-expanded=false]{height:0;opacity:0;overflow:hidden}"], encapsulation: 2, changeDetection: 0 });

/** Button that moves to the next step in a stepper workflow. */
let CngStepperNext = class CngStepperNext extends CdkStepperNext {
    _handleClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stepAfter) {
                const doStep = yield this.stepAfter();
                if (doStep) {
                    this._stepper.next();
                }
            }
            else {
                this._stepper.next();
            }
        });
    }
};
CngStepperNext.ɵfac = /*@__PURE__*/ function () { let ɵCngStepperNext_BaseFactory; return function CngStepperNext_Factory(t) { return (ɵCngStepperNext_BaseFactory || (ɵCngStepperNext_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngStepperNext)))(t || CngStepperNext); }; }();
CngStepperNext.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngStepperNext, selectors: [["button", "cngStepperNext", ""]], hostVars: 1, hostBindings: function CngStepperNext_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("type", ctx.type);
    } }, inputs: { type: "type", stepAfter: "stepAfter" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input()
], CngStepperNext.prototype, "stepAfter", void 0);
/** Button that moves to the previous step in a stepper workflow. */
let CngStepperPrevious = class CngStepperPrevious extends CdkStepperPrevious {
    _handleClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stepAfter) {
                const doStep = yield this.stepAfter();
                if (doStep) {
                    this._stepper.previous();
                }
            }
            else {
                this._stepper.previous();
            }
        });
    }
};
CngStepperPrevious.ɵfac = /*@__PURE__*/ function () { let ɵCngStepperPrevious_BaseFactory; return function CngStepperPrevious_Factory(t) { return (ɵCngStepperPrevious_BaseFactory || (ɵCngStepperPrevious_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CngStepperPrevious)))(t || CngStepperPrevious); }; }();
CngStepperPrevious.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CngStepperPrevious, selectors: [["button", "cngStepperPrevious", ""]], hostVars: 1, hostBindings: function CngStepperPrevious_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("type", ctx.type);
    } }, inputs: { type: "type", stepAfter: "stepAfter" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input()
], CngStepperPrevious.prototype, "stepAfter", void 0);

/**
 * Module container the cng-stepper component and related directives
 *
 * This cng-stepper is built on top of angular CDK's stepper.
 * Most of the components/directives extend a class from this library.
 *
 * Consult the documentation here
 * https://material.angular.io/cdk/stepper/overview
 */
let CngStepperModule = class CngStepperModule {
};
CngStepperModule.ɵfac = function CngStepperModule_Factory(t) { return new (t || CngStepperModule)(); };
CngStepperModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngStepperModule });
CngStepperModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAccordionDrawerComponent, [{
        type: Component,
        args: [{ selector: 'cng-accordion-drawer', template: "<ng-template #drawerTitle>\n\t<ng-content select=\"[drawer-title]\"></ng-content>\n</ng-template>\n<ng-template #drawerContent>\n\t<ng-content select=\"[drawer-content]\"></ng-content>\n</ng-template>\n" }]
    }], function () { return []; }, { active: [{
            type: Input
        }], title: [{
            type: ViewChild,
            args: ['drawerTitle', { static: true }]
        }], content: [{
            type: ViewChild,
            args: ['drawerContent', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAccordionComponent, [{
        type: Component,
        args: [{ selector: 'cng-accordion', template: "<ul\n\tclass=\"accordion\"\n\t[ngClass]=\"{ 'accordion--bordered': bordered }\"\n>\n\t<li\n\t\t*ngFor=\"let drawer of drawers\"\n\t\t[ngClass]=\"{ 'active': drawer.active }\"\n\t>\n\t\t<a\n\t\t\tclass=\"accordion__title\"\n\t\t\t(click)=\"toggle(drawer)\"\n\t\t\ttabindex=\"0\"\n\t\t\t(keydown)=\"onKeydown($event, drawer)\"\n\t\t>\n\t\t\t<ng-container *ngTemplateOutlet=\"drawer.title\"></ng-container>\n\t\t\t<span\n\t\t\t\t*ngIf=\"showToggle\"\n\t\t\t\tclass=\"accordion__toggle icon-chevron-down\"\n\t\t\t></span>\n\t\t</a>\n\t\t<div class=\"accordion__content\">\n\t\t\t<ng-container *ngTemplateOutlet=\"drawer.content\"></ng-container>\n\t\t</div>\n\t</li>\n</ul>\n", styles: ["a.accordion__title:focus{color:var(--cui-color-info)!important}"] }]
    }], function () { return []; }, { showToggle: [{
            type: Input
        }], bordered: [{
            type: Input
        }], singular: [{
            type: Input
        }], drawers: [{
            type: ContentChildren,
            args: [CngAccordionDrawerComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngContentComponent, [{
        type: Component,
        args: [{ selector: 'cng-content', template: "<ng-container [ngSwitch]=\"config.type\">\n\t<ng-container *ngSwitchCase=\"'text'\">\n\t\t<div [innerText]=\"config.content\"></div>\n\t</ng-container>\n\t<ng-container *ngSwitchCase=\"'html'\">\n\t\t<div [innerHTML]=\"config.content\"></div>\n\t</ng-container>\n\t<ng-container *ngSwitchCase=\"'template'\">\n\t\t<ng-container\n\t\t\t*ngTemplateOutlet=\"config.content; context: config.context\"\n\t\t></ng-container>\n\t</ng-container>\n\t<ng-container *ngSwitchCase=\"'component'\">\n\t\t<cng-dcl\n\t\t\t[component]=\"config.content\"\n\t\t\t[setInputFunction]=\"config.setComponentInputs\"\n\t\t\t[data]=\"config.componentData\"\n\t\t></cng-dcl>\n\t</ng-container>\n</ng-container>\n" }]
    }], function () { return []; }, { config: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDclHostDirective, [{
        type: Directive,
        args: [{
                selector: '[cngDCLHost]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDclComponent, [{
        type: Component,
        args: [{ selector: 'cng-dcl', template: "<ng-template cngDCLHost></ng-template>\n" }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }]; }, { component: [{
            type: Input
        }], setInputFunction: [{
            type: Input
        }], data: [{
            type: Input
        }], host: [{
            type: ViewChild,
            args: [CngDclHostDirective, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDclModule, [{
        type: NgModule,
        args: [{
                declarations: [CngDclHostDirective, CngDclComponent],
                exports: [CngDclComponent, CngDclHostDirective],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngDclModule, { declarations: function () { return [CngDclHostDirective, CngDclComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngDclComponent, CngDclHostDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngContentModule, [{
        type: NgModule,
        args: [{
                declarations: [CngContentComponent],
                exports: [CngContentComponent],
                imports: [
                    CngDclModule,
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngContentModule, { declarations: function () { return [CngContentComponent]; }, imports: function () { return [CngDclModule, CommonModule]; }, exports: function () { return [CngContentComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAccordionModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngAccordionComponent,
                    CngAccordionDrawerComponent,
                ],
                exports: [
                    CngAccordionDrawerComponent,
                    CngAccordionComponent,
                ],
                imports: [
                    CngContentModule,
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngAccordionModule, { declarations: function () { return [CngAccordionComponent, CngAccordionDrawerComponent]; }, imports: function () { return [CngContentModule, CommonModule]; }, exports: function () { return [CngAccordionDrawerComponent, CngAccordionComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFooterComponent, [{
        type: Component,
        args: [{
                selector: 'cng-footer',
                template: "<footer class=\"footer\">\n    <div class=\"footer__links\">\n        <ul class=\"list list--inline\">\n            <li *ngFor=\"let item of config.items\">\n                <a [href]=\"item.link\" [innerText]=\"item.text\" target=\"_blank\" rel=\"noopener noreferrer\"></a>\n            </li>\n        </ul>\n    </div>\n</footer>\n"
            }]
    }], function () { return []; }, { config: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFooterModule, [{
        type: NgModule,
        args: [{
                declarations: [CngFooterComponent],
                exports: [CngFooterComponent],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngFooterModule, { declarations: function () { return [CngFooterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngFooterComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[cngTitle]'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngHeaderComponent, [{
        type: Component,
        args: [{ host: {
                    class: 'header'
                }, selector: 'cng-header', template: "<div class=\"container\">\n\t<div class=\"header-panels\">\n\t\t<div class=\"header-panel\">\n\t\t\t<a \n\t\t\t\t*ngIf=\"config.showSidebarToggle\"\n\t\t\t\tclass=\"header-item half-margin-left dbl-margin-right\"\n\t\t\t\t(click)=\"sidebarToggle.emit()\"\n\t\t\t>\n\t\t\t\t<div class=\"icon-list-menu\"></div>\n\t\t\t</a>\n\t\t\t<a\n\t\t\t\t*ngIf=\"config.showCiscoLogo && !config.ciscoLogoRouterLink\"\n\t\t\t\tclass=\"header__logo\"\n\t\t\t\t[href]=\"config.ciscoLogoHREF\"\n\t\t\t\ttarget=\"_blank\"\n\t\t\t>\n\t\t\t\t<span class=\"icon-cisco\"></span>\n\t\t\t</a>\n\t\t\t<a\n\t\t\t\t*ngIf=\"config.showCiscoLogo && config.ciscoLogoRouterLink\"\n\t\t\t\tclass=\"header__logo\"\n\t\t\t\t[routerLink]=\"config.ciscoLogoRouterLink\"\n\t\t\t>\n\t\t\t\t<span class=\"icon-cisco\"></span>\n\t\t\t</a>\n\t\t\t<!-- Simple text title -->\n\t\t\t<div *ngIf=\"config.title\" class=\"header__title\" [innerText]=\"config.title\"></div>\n\t\t\t<!-- Projected content title slot for more advanced use-cases -->\n\t\t\t<ng-container *ngIf=\"titleTemplate\"><ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container></ng-container>\n\t\t</div>\n\t\t<div\n\t\t\t*ngIf=\"config.centerHeaderPanelItems?.length\"\n\t\t\tclass=\"header-panel header-panel--center\"\n\t\t\t[ngClass]=\"config.centerHeaderPanelClasses\"\n\t\t>\n\t\t\t<ng-container\n\t\t\t\t*ngTemplateOutlet=\"headerItem; context: {\n\t\t\t\t\titems: config.centerHeaderPanelItems\n\t\t\t\t}\"\n\t\t\t></ng-container>\n\t\t</div>\n\t\t<div\n\t\t\t*ngIf=\"config.rightHeaderPanelItems?.length\"\n\t\t\tclass=\"header-panel header-panel--right\"\n\t\t\t[ngClass]=\"config.rightHeaderPanelClasses\"\n\t\t>\n\t\t\t<ng-container\n\t\t\t\t*ngTemplateOutlet=\"headerItem; context: {\n\t\t\t\t\titems: config.rightHeaderPanelItems\n\t\t\t\t}\"\n\t\t\t></ng-container>\n\t\t</div>\n\t</div>\n</div>\n\n<ng-template #headerItem let-items=\"items\">\n\t<ng-container *ngFor=\"let item of items\">\n\t\t<a\n\t\t\t*ngIf=\"item.routerLink\"\n\t\t\tclass=\"header-item\"\n\t\t\t[routerLink]=\"item.routerLink\"\n\t\t>\n\t\t\t<cng-content [config]=\"item\"></cng-content>\n\t\t</a>\n\t\t<a\n\t\t\t*ngIf=\"!item.routerLink\"\n\t\t\tclass=\"header-item\"\n\t\t>\n\t\t\t<cng-content [config]=\"item\"></cng-content>\n\t\t</a>\n\t</ng-container>\n</ng-template>\n" }]
    }], function () { return []; }, { sidebarToggle: [{
            type: Output
        }], config: [{
            type: Input
        }], titleTemplate: [{
            type: ContentChild,
            args: [CngTitleDirective, { read: TemplateRef }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngHeaderComponent,
                    CngTitleDirective,
                ],
                exports: [
                    CngHeaderComponent,
                    CngTitleDirective,
                ],
                imports: [
                    CngContentModule,
                    CommonModule,
                    RouterModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngHeaderModule, { declarations: function () { return [CngHeaderComponent, CngTitleDirective]; }, imports: function () { return [CngContentModule, CommonModule,
        RouterModule]; }, exports: function () { return [CngHeaderComponent, CngTitleDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLayoutHeader, [{
        type: Directive,
        args: [{ selector: '[cngLayoutHeader]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLayoutSidebar, [{
        type: Directive,
        args: [{ selector: '[cngLayoutSidebar]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLayoutComponent, [{
        type: Component,
        args: [{ selector: 'cng-layout', template: "<skip-nav mainId=\"main\">Skip to Main Content</skip-nav>\n<ng-content select=\"[cngLayoutHeader]\"></ng-content>\n<div class=\"content\">\n\t<div class=\"container-fluid\">\n\t\t<div class=\"row\">\n\t\t\t<ng-content select=\"[cngLayoutSidebar]\"></ng-content>\n\t\t\t<div\n\t\t\t\t#main\n\t\t\t\t[ngStyle]=\"{\n\t\t\t\t\t'width': sidebarXPosition | contentWidth: sidebarWidth : lockContentWidth\n\t\t\t\t}\"\n\t\t\t\tclass=\"base-padding\"\n\t\t\t\t(click)=\"handleContentClick()\"\n\t\t\t\trole=\"main\"\n\t\t\t\tid=\"main\"\n\t\t\t\ttabindex=\"-1\"\n\t\t\t>\n\t\t\t\t<ng-content select=\"router-outlet\"></ng-content>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n", styles: ["#main:focus{outline:0}"] }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { 
    /**
     * @param event - Event
     * When window is resized, check the window width
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], sidebarElem: [{
            type: ContentChild,
            args: [CngLayoutSidebar, { static: false }]
        }], headerElem: [{
            type: ContentChild,
            args: [CngLayoutHeader, { static: false }]
        }], header: [{
            type: ContentChild,
            args: [CngHeaderComponent, { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLayoutContentWidthPipe, [{
        type: Pipe,
        args: [{
                name: 'contentWidth'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngLayoutComponent,
                    CngLayoutHeader,
                    CngLayoutSidebar,
                    CngLayoutContentWidthPipe,
                ],
                exports: [
                    CngLayoutComponent,
                    CngLayoutHeader,
                    CngLayoutSidebar,
                ],
                imports: [
                    CommonModule,
                    SkipNavModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngLayoutModule, { declarations: function () { return [CngLayoutComponent, CngLayoutHeader, CngLayoutSidebar, CngLayoutContentWidthPipe]; }, imports: function () { return [CommonModule,
        SkipNavModule]; }, exports: function () { return [CngLayoutComponent, CngLayoutHeader, CngLayoutSidebar]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngModalComponent, [{
        type: Component,
        args: [{ selector: 'cng-modal', template: "<div\n\tclass=\"modal\"\n\t[ngClass]=\"size\"\n>\n    <div class=\"modal__dialog\">\n        <div class=\"modal__content\">\n            <a class=\"modal__close\" (click)=\"handleClose()\">\n\t\t\t\t<span class=\"icon-close\"></span>\n\t\t\t</a>\n\t\t\t<cng-content [config]=\"content\"></cng-content>\n        </div>\n    </div>\n</div>\n" }]
    }], function () { return []; }, { close: [{
            type: Output
        }], content: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngModalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngModalModule, [{
        type: NgModule,
        args: [{
                declarations: [CngModalComponent],
                exports: [
                    CngModalComponent,
                ],
                imports: [
                    CngContentModule,
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngModalModule, { declarations: function () { return [CngModalComponent]; }, imports: function () { return [CngContentModule, CommonModule]; }, exports: function () { return [CngModalComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAlertComponent, [{
        type: Component,
        args: [{ selector: 'cng-alert', template: "<div class=\"alert alert--{{ color }}\">\n  <ng-container *ngIf=\"icon\">\n    <div class=\"alert__icon\"\n      [ngClass]=\"{\n        'icon-info-outline': color === 'info',\n        'icon-warning-outline': color === 'warning' || color === 'warning-alt',\n        'icon-check-outline': color === 'success',\n        'icon-help-outline': color === 'dark' || color === 'light'\n      }\">\n    </div>\n  </ng-container>\n  <div class=\"alert__message flex-fluid\">\n    <ng-content></ng-content>\n  </div>\n  <a *ngIf=\"dismissable\"\n    href=\"javascript:;\"\n    class=\"alert__close icon-close\"\n    (click)=\"onClose.emit()\">\n  </a>\n</div>\n" }]
    }], function () { return []; }, { dismissable: [{
            type: Input
        }], icon: [{
            type: Input
        }], onClose: [{
            type: Output
        }], color: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAlertModule, [{
        type: NgModule,
        args: [{
                declarations: [CngAlertComponent],
                exports: [CngAlertComponent],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngAlertModule, { declarations: function () { return [CngAlertComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngAlertComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAlertService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAlertOutletComponent, [{
        type: Component,
        args: [{ selector: 'cng-alert-outlet', template: "<div>\n  <ng-container *ngFor=\"let alert of items\">\n    <cng-alert [color]=\"alert.color\"\n      [dismissable]=\"alert.dismissable\"\n      [icon]=\"alert.icon\"\n      (onClose)=\"onClose(alert)\">\n      <cng-content [config]=\"alert.content\"></cng-content>\n    </cng-alert>\n  </ng-container>\n</div>\n" }]
    }], function () { return [{ type: CngAlertService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAlertOutletModule, [{
        type: NgModule,
        args: [{
                declarations: [CngAlertOutletComponent],
                exports: [CngAlertOutletComponent],
                imports: [
                    CommonModule,
                    CngAlertModule,
                    CngContentModule,
                ],
                providers: [
                    CngAlertService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngAlertOutletModule, { declarations: function () { return [CngAlertOutletComponent]; }, imports: function () { return [CommonModule, CngAlertModule, CngContentModule]; }, exports: function () { return [CngAlertOutletComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabContentDirective, [{
        type: Directive,
        args: [{
                selector: '[cngTabContent]'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabLabelDirective, [{
        type: Directive,
        args: [{
                selector: '[cngTabLabel]'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabComponent, [{
        type: Component,
        args: [{
                selector: 'cng-tab',
                template: '<ng-template><ng-content></ng-content></ng-template>'
            }]
    }], function () { return []; }, { pullRight: [{
            type: Input
        }], disabled: [{
            type: Input
        }], autoId: [{
            type: Input
        }], label: [{
            type: Input
        }], _labelTemplate: [{
            type: ContentChild,
            args: [CngTabLabelDirective, { read: TemplateRef }]
        }], _implicitContent: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }], _explicitContent: [{
            type: ContentChild,
            args: [CngTabContentDirective, { read: TemplateRef }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabPreDirective, [{
        type: Directive,
        args: [{
                selector: '[cngTabPre]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabPostDirective, [{
        type: Directive,
        args: [{
                selector: '[cngTabPost]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabAnchorDirective, [{
        type: Directive,
        args: [{
                selector: '[cngTabAnchor]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabsComponent, [{
        type: Component,
        args: [{
                selector: 'cng-tabs',
                template: "<!-- Horizontal tabs with content underneath. The default view. -->\n<ng-container *ngIf=\"!vertical; else verticalTemplate\">\n\t<div class=\"flex-center-vertical overflow-auto\">\n\t\t<ng-container *ngIf=\"inline && preContent\">\n\t\t\t<ng-container *ngTemplateOutlet=\"preContent.template\"></ng-container>\n\t\t</ng-container>\n\t\t<div class=\"flex-fluid\"\n\t\t\t[ngClass]=\"{\n\t\t\t\t'text-left': inline && alignment === 'left',\n\t\t\t\t'text-right': inline && alignment === 'right',\n\t\t\t\t'text-center': inline && alignment === 'center'\n\t\t\t}\">\n\t\t\t<ul class=\"tabs\"\n\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t'tabs--inline': inline,\n\t\t\t\t\t'tabs--bordered': bordered,\n\t\t\t\t\t'tabs--embossed': embossed,\n\t\t\t\t\t'tabs--centered': alignment === 'center',\n\t\t\t\t\t'tabs--right': alignment === 'right',\n\t\t\t\t\t'tabs--justified': alignment === 'justified'\n\t\t\t\t}\">\n\t\t\t\t<ng-container *ngFor=\"let tab of tabs; index as i;\">\n\t\t\t\t\t<li class=\"tab\"\n\t\t\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t\t\t'active': i === activeTabIndex,\n\t\t\t\t\t\t\t'pull-right': tab.pullRight,\n\t\t\t\t\t\t\t'disabled': tab.disabled\n\t\t\t\t\t\t}\"\n\t\t\t\t\t\t(click)=\"selectTab(i)\"\n\t\t\t\t\t\t(keydown)=\"onKeydown($event)\">\n\t\t\t\t\t\t<a [attr.tabindex]=\"i === 0 ? '0' : '-1'\" [attr.data-auto-id]=\"tab.autoId ? tab.autoId : tab.label + 'Tab'\"\n\t\t\t\t\t\t\tcngTabAnchor>\n\t\t\t\t\t\t\t<div class=\"tab__heading\">\n\t\t\t\t\t\t\t\t<ng-container *ngIf=\"!tab.labelTemplate; else tab.labelTemplate;\">\n\t\t\t\t\t\t\t\t\t<span [innerText]=\"tab.label\"></span>\n\t\t\t\t\t\t\t\t</ng-container>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ng-container>\n\t\t\t</ul>\n\t\t</div>\n\t\t<ng-container *ngIf=\"inline && postContent\">\n\t\t\t<ng-container *ngTemplateOutlet=\"postContent.template\"></ng-container>\n\t\t</ng-container>\n\t</div>\n\t<div class=\"tab-content\">\n\t\t<ng-container *ngFor=\"let tab of tabs; index as i;\">\n\t\t\t<div class=\"tab-pane active\"\n\t\t\t\t*ngIf=\"i === activeTabIndex\">\n\t\t\t\t<ng-container *ngTemplateOutlet=\"tab.content\"></ng-container>\n\t\t\t</div>\n\t\t</ng-container>\n\t</div>\n</ng-container>\n\n<!-- Vertical tab layout, content in the same row and on the right -->\n<ng-template #verticalTemplate>\n\t<div class=\"row\">\n\t\t<div class=\"col-md-3\">\n\t\t\t<ul class=\"tabs tabs--vertical\"\n\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t'tabs--bordered': bordered\n\t\t\t\t}\">\n\t\t\t\t<ng-container *ngFor=\"let tab of tabs; index as i;\">\n\t\t\t\t\t<li class=\"tab\"\n\t\t\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t\t\t'active': i === activeTabIndex,\n\t\t\t\t\t\t\t'disabled': tab.disabled\n\t\t\t\t\t\t}\"\n\t\t\t\t\t\t(click)=\"selectTab(i)\"\n\t\t\t\t\t\t(keydown)=\"onKeydown($event)\">\n\t\t\t\t\t\t<a [attr.tabindex]=\"i === 0 ? '0' : '-1'\" cngTabAnchor>\n\t\t\t\t\t\t\t<div class=\"tab__heading\">\n\t\t\t\t\t\t\t\t<ng-container *ngIf=\"!tab.labelTemplate; else tab.labelTemplate;\">\n\t\t\t\t\t\t\t\t\t<span [innerText]=\"tab.label\"></span>\n\t\t\t\t\t\t\t\t</ng-container>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ng-container>\n\t\t\t</ul>\n\t\t</div>\n\t\t<div class=\"col-md-9\">\n\t\t\t<div class=\"tab-content\">\n\t\t\t\t<ng-container *ngFor=\"let tab of tabs; index as i;\">\n\t\t\t\t\t<div class=\"tab-pane active\"\n\t\t\t\t\t\t*ngIf=\"i === activeTabIndex\">\n\t\t\t\t\t\t<ng-container *ngTemplateOutlet=\"tab.content\"></ng-container>\n\t\t\t\t\t</div>\n\t\t\t\t</ng-container>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</ng-template>\n"
            }]
    }], function () { return []; }, { alignment: [{
            type: Input
        }], activeTabIndex: [{
            type: Input
        }], activeTabIndexChange: [{
            type: Output
        }], inline: [{
            type: Input
        }], bordered: [{
            type: Input
        }], embossed: [{
            type: Input
        }], vertical: [{
            type: Input
        }], tabs: [{
            type: ContentChildren,
            args: [CngTabComponent]
        }], tabAnchors: [{
            type: ViewChildren,
            args: [CngTabAnchorDirective]
        }], preContent: [{
            type: ContentChild,
            args: [CngTabPreDirective]
        }], postContent: [{
            type: ContentChild,
            args: [CngTabPostDirective]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabLinkComponent, [{
        type: Component,
        args: [{
                selector: 'cng-tab-link',
                template: '<ng-template><ng-content></ng-content></ng-template>'
            }]
    }], function () { return []; }, { pullRight: [{
            type: Input
        }], disabled: [{
            type: Input
        }], routerLinkActiveOptions: [{
            type: Input
        }], label: [{
            type: Input
        }], url: [{
            type: Input
        }], urlParams: [{
            type: Input
        }], labelTemplate: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabsNavComponent, [{
        type: Component,
        args: [{ selector: 'cng-tabs-nav', template: "<!-- Horizontal tabs. The default view. -->\n<ng-container *ngIf=\"!vertical; else verticalTemplate\">\n\t<div class=\"flex-center-vertical overflow-auto\">\n\t\t<ng-container *ngIf=\"inline && preContent\">\n\t\t\t<ng-container *ngTemplateOutlet=\"preContent.template\"></ng-container>\n\t\t</ng-container>\n\t\t<div class=\"flex-fluid\"\n\t\t\t[ngClass]=\"{\n\t\t\t\t'text-left': inline && alignment === 'left',\n\t\t\t\t'text-right': inline && alignment === 'right',\n\t\t\t\t'text-center': inline && alignment === 'center'\n\t\t\t}\">\n\t\t\t<ul class=\"tabs\"\n\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t'tabs--inline': inline,\n\t\t\t\t\t'tabs--bordered': bordered,\n\t\t\t\t\t'tabs--embossed': embossed,\n\t\t\t\t\t'tabs--centered': alignment === 'center',\n\t\t\t\t\t'tabs--right': alignment === 'right',\n\t\t\t\t\t'tabs--justified': alignment === 'justified'\n\t\t\t\t}\">\n\t\t\t\t<ng-container *ngFor=\"let tab of tabs; index as i;\">\n\t\t\t\t\t<li class=\"tab\"\n\t\t\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t\t\t'active': rla.isActive,\n\t\t\t\t\t\t\t'pull-right': tab.pullRight,\n\t\t\t\t\t\t\t'disabled': tab.disabled\n\t\t\t\t\t\t}\"\n\t\t\t\t\t\t(keydown)=\"onKeydown($event)\">\n\t\t\t\t\t\t<a [attr.tabindex]=\"i === 0 ? '0' : '-1'\"\n              [attr.data-auto-id]=\"tab.autoId ? tab.autoId : tab.label + 'Tab'\"\n              [routerLink]=\"tab.url\"\n\t\t\t\t\t\t\t[queryParams]=\"tab.urlParams\"\n\t\t\t\t\t\t\trouterLinkActive #rla=\"routerLinkActive\"\n\t\t\t\t\t\t\t[routerLinkActiveOptions]=\"tab.routerLinkActiveOptions\"\n\t\t\t\t\t\t\tcngTabAnchor>\n\t\t\t\t\t\t\t<div class=\"tab__heading\">\n\t\t\t\t\t\t\t\t<ng-container *ngIf=\"tab.label; else tab.labelTemplate;\">\n\t\t\t\t\t\t\t\t\t<span [innerText]=\"tab.label\"></span>\n\t\t\t\t\t\t\t\t</ng-container>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ng-container>\n\t\t\t</ul>\n\t\t</div>\n\t\t<ng-container *ngIf=\"inline && postContent\">\n\t\t\t<ng-container *ngTemplateOutlet=\"postContent.template\"></ng-container>\n\t\t</ng-container>\n\t</div>\n</ng-container>\n\n<!-- Vertical tab layout -->\n<ng-template #verticalTemplate>\n\t<div class=\"row\">\n\t\t<div class=\"col-md-3\">\n\t\t\t<ul class=\"tabs tabs--vertical\"\n\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t'tabs--bordered': bordered\n\t\t\t\t}\">\n\t\t\t\t<ng-container *ngFor=\"let tab of tabs; index as i;\">\n\t\t\t\t\t<li class=\"tab\"\n\t\t\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t\t\t'active': rla.isActive,\n\t\t\t\t\t\t\t'disabled': tab.disabled\n\t\t\t\t\t\t}\"\n\t\t\t\t\t\t(keydown)=\"onKeydown($event)\">\n\t\t\t\t\t\t<a [attr.tabindex]=\"i === 0 ? '0' : '-1'\"\n              [routerLink]=\"tab.url\"\n              [queryParams]=\"tab.urlParams\"\n              routerLinkActive #rla=\"routerLinkActive\"\n\t\t\t  [routerLinkActiveOptions]=\"tab.routerLinkActiveOptions\"\n              cngTabAnchor>\n\t\t\t\t\t\t\t<div class=\"tab__heading\">\n\t\t\t\t\t\t\t\t<ng-container *ngIf=\"tab.label; else tab.labelTemplate;\">\n\t\t\t\t\t\t\t\t\t<span [innerText]=\"tab.label\"></span>\n\t\t\t\t\t\t\t\t</ng-container>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ng-container>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</ng-template>\n" }]
    }], function () { return []; }, { alignment: [{
            type: Input
        }], activeTabIndex: [{
            type: Input
        }], inline: [{
            type: Input
        }], bordered: [{
            type: Input
        }], embossed: [{
            type: Input
        }], vertical: [{
            type: Input
        }], tabs: [{
            type: ContentChildren,
            args: [CngTabLinkComponent]
        }], tabAnchors: [{
            type: ViewChildren,
            args: [CngTabAnchorDirective]
        }], preContent: [{
            type: ContentChild,
            args: [CngTabPreDirective]
        }], postContent: [{
            type: ContentChild,
            args: [CngTabPostDirective]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTabsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                ],
                declarations: [
                    CngTabComponent,
                    CngTabsComponent,
                    CngTabContentDirective,
                    CngTabLabelDirective,
                    CngTabPreDirective,
                    CngTabPostDirective,
                    CngTabAnchorDirective,
                    CngTabsNavComponent,
                    CngTabLinkComponent,
                ],
                exports: [
                    CngTabComponent,
                    CngTabsComponent,
                    CngTabContentDirective,
                    CngTabLabelDirective,
                    CngTabPreDirective,
                    CngTabPostDirective,
                    CngTabsNavComponent,
                    CngTabLinkComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngTabsModule, { declarations: function () { return [CngTabComponent, CngTabsComponent, CngTabContentDirective, CngTabLabelDirective, CngTabPreDirective, CngTabPostDirective, CngTabAnchorDirective, CngTabsNavComponent, CngTabLinkComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [CngTabComponent, CngTabsComponent, CngTabContentDirective, CngTabLabelDirective, CngTabPreDirective, CngTabPostDirective, CngTabsNavComponent, CngTabLinkComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSidebarComponent, [{
        type: Component,
        args: [{ host: {
                    class: 'sidebar'
                }, selector: 'cng-sidebar', template: "<div class=\"sidebar__header\" *ngIf=\"config.title\">\n\t<div class=\"sidebar__header-title\" [innerText]=\"config.title\"></div>\n</div>\n<ul role=\"navigation\" aria-label=\"Main\">\n\t<ng-container *ngFor=\"let item of config.items\">\n\t\t<ng-container\n\t\t\t*ngTemplateOutlet=\"sidebarItem; context: { item: item }\"\n\t\t></ng-container>\n\t</ng-container>\n</ul>\n\n<ng-template #sidebarItem let-item=\"item\" let-parent=\"parent\">\n\t<li\n\t\t*ngIf=\"!item.routerLink\"\n\t\t[ngClass]=\"{\n\t\t\t'sidebar__item': item.type === 'item',\n\t\t\t'sidebar__drawer': item.type === 'drawer',\n\t\t\t'sidebar__drawer--opened': item.opened,\n\t\t\t'sidebar__drawer--selected': item.active && item.type === 'drawer'\n\t\t}\"\n\t\ttabindex=\"-1\"\n\t>\n\t\t<ng-container\n\t\t\t*ngTemplateOutlet=\"sidebarItemContents; context: { item: item, parent: parent }\"\n\t\t></ng-container>\n\t</li>\n\t<li\n\t\t*ngIf=\"item.routerLink\"\n\t\t[ngClass]=\"{\n\t\t\t'sidebar__item': item.type === 'item',\n\t\t\t'sidebar__drawer': item.type === 'drawer',\n\t\t\t'sidebar__drawer--opened': item.opened,\n\t\t\t'sidebar__drawer--selected': item.active && item.type === 'drawer'\n\t\t}\"\n\t\t[routerLink]=\"item.routerLink ? item.routerLink : null\"\n\t\t[routerLinkActive]=\"['sidebar__item--selected']\"\n\t\t[routerLinkActiveOptions]=\"{ exact: true }\"\n\t\ttabindex=\"-1\"\n\t>\n\t\t<ng-container\n\t\t\t*ngTemplateOutlet=\"sidebarItemContents; context: { item: item, parent: parent }\"\n\t\t></ng-container>\n\t</li>\n</ng-template>\n\n<ng-template #sidebarItemContents let-item=\"item\" let-parent=\"parent\">\n\t<a\n\t\t(click)=\"onSidebarItemClick(item, parent)\"\n\t\t(keydown)=\"onSidebarItemKeydown($event, item, parent)\"\n\t\ttabindex=\"0\"\n\t>\n\t\t<cng-content [config]=\"item.data\"></cng-content>\n\t</a>\n\t<ul *ngIf=\"item.type === 'drawer'\" role=\"navigation\" aria-label=\"Sub-Nav\">\n\t\t<ng-container *ngFor=\"let subItem of item.items\">\n\t\t\t<ng-container\n\t\t\t\t*ngTemplateOutlet=\"sidebarItem; context: { item: subItem, parent: item }\"\n\t\t\t></ng-container>\n\t\t</ng-container>\n\t</ul>\n</ng-template>\n", styles: [":host li:focus{outline:0}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc2.Router }]; }, { sidebarWidth: [{
            type: HostBinding,
            args: ['style.width']
        }], sidebarTopOffset: [{
            type: HostBinding,
            args: ['style.top']
        }], colorPrimary: [{
            type: HostBinding,
            args: ['class.sidebar--primary']
        }], colorSecondary: [{
            type: HostBinding,
            args: ['class.sidebar--secondary']
        }], colorTertiary: [{
            type: HostBinding,
            args: ['class.sidebar--tertiary']
        }], colorLight: [{
            type: HostBinding,
            args: ['class.sidebar--light']
        }], isMini: [{
            type: HostBinding,
            args: ['class.sidebar--mini']
        }], onDocumentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], config: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSidebarModule, [{
        type: NgModule,
        args: [{
                declarations: [CngSidebarComponent],
                exports: [CngSidebarComponent],
                imports: [
                    CngContentModule,
                    CommonModule,
                    RouterModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngSidebarModule, { declarations: function () { return [CngSidebarComponent]; }, imports: function () { return [CngContentModule, CommonModule,
        RouterModule]; }, exports: function () { return [CngSidebarComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngClickedOutsideDirective, [{
        type: Directive,
        args: [{
                selector: '[cngClickedOutside]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { cngClickedOutside: [{
            type: Output
        }], 
    /** Host listener for global document:click. Will compare the target element
     * to the element this directive is applied to
     * @param event the MouseEvent
     */
    onClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngClickedOutsideModule, [{
        type: NgModule,
        args: [{
                declarations: [CngClickedOutsideDirective],
                exports: [CngClickedOutsideDirective],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngClickedOutsideModule, { declarations: function () { return [CngClickedOutsideDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngClickedOutsideDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngOptionComponent, [{
        type: Component,
        args: [{ selector: 'cng-option', template: '<div #wrapper><ng-content></ng-content></div>' }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { value: [{
            type: Input
        }], wrappedElem: [{
            type: ViewChild,
            args: ['wrapper', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngGroupComponent, [{
        type: Component,
        args: [{ selector: 'cng-group', template: '' }]
    }], function () { return []; }, { groupName: [{
            type: Input
        }], _items: [{
            type: ContentChildren,
            args: [CngOptionComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLabelComponent, [{
        type: Component,
        args: [{
                selector: 'cng-label',
                template: '<ng-template><ng-content></ng-content></ng-template>'
            }]
    }], null, { content: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSelectComponent, [{
        type: Component,
        args: [{ selector: 'cng-select', template: "<div class=\"form-group dropdown\"\n  [ngClass]=\"{\n    'active': active,\n    'form-group--error': control.invalid\n  }\"\n  (cngClickedOutside)=\"active = false\">\n  <div class=\"form-group__text select\"\n    (click)=\"toggleActive()\">\n    <input #searchInput [formControl]=\"inputControl\"\n      (keydown)=\"onKeydown($event)\">\n    <label for=\"searchInput\" *ngIf=\"label\">\n      <span *ngTemplateOutlet=\"label.content\"></span>\n    </label>\n  </div>\n  <cdk-virtual-scroll-viewport [itemSize]=\"rowSize\"\n    class=\"dropdown__menu\"\n    [ngStyle]=\"{ 'height': calcDropdownHeight(filteredItems$ | async, filteredGroups$ | async) + 'px' }\">\n    <ng-container *ngIf=\"groups.length\">\n      <div *cdkVirtualFor=\"let group of filteredGroups$ | async as groups\">\n        <div class=\"dropdown__group\">\n          <div class=\"dropdown__group-header\">\n            {{ group.groupName }}\n          </div>\n          <ng-container *ngFor=\"let item of group.filteredItems\">\n            <ng-container *ngTemplateOutlet=\"itemTemplate; context: { 'item': item }\"></ng-container>\n          </ng-container>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *ngIf=\"!groups.length\">\n      <div *cdkVirtualFor=\"let item of filteredItems$ | async as items\">\n        <ng-container *ngTemplateOutlet=\"itemTemplate; context: { 'item': item }\"></ng-container>\n      </div>\n    </ng-container>\n  </cdk-virtual-scroll-viewport>\n</div>\n\n<ng-template #itemTemplate let-item=\"item\">\n  <ng-container *ngIf=\"!multi\">\n    <a [ngClass]=\"{ 'selected': item.selected, 'hover': item.active }\"\n      (click)=\"onClick(item)\">\n      <div class=\"form-group form-group--inline\" [innerHTML]=\"item.wrappedElem.nativeElement.innerHTML\"></div>\n    </a>\n  </ng-container>\n  <ng-container *ngIf=\"multi\">\n    <a [ngClass]=\"{ 'hover': item.active }\" (click)=\"onClick(item)\">\n      <div class=\"form-group form-group--inline\">\n        <label class=\"checkbox\" (click)=\"$event.preventDefault()\">\n          <input type=\"checkbox\" [checked]=\"item.selected\">\n          <span class=\"checkbox__input\"></span>\n          <span class=\"checkbox__label\" [innerHTML]=\"item.wrappedElem.nativeElement.innerHTML\"></span>\n        </label>\n      </div>\n    </a>\n  </ng-container>\n</ng-template>\n", styles: [":host .select{--cui-form-icon-yoffset:calc(calc(var(--cui-form-size) * 0.5) - (calc(var(--cui-form-icon-dropdown-font-size) * 0.5)))}:host a.hover{background-color:var(--cui-background-hover)!important}:host input{text-overflow:ellipsis}"] }]
    }], function () { return [{ type: ɵngcc4.NgControl }]; }, { dropdownMaxHeight: [{
            type: Input
        }], rowSize: [{
            type: Input
        }], searchable: [{
            type: Input
        }], multi: [{
            type: Input
        }], customTrigger: [{
            type: Input
        }], _items: [{
            type: ContentChildren,
            args: [CngOptionComponent, { descendants: true }]
        }], _groups: [{
            type: ContentChildren,
            args: [CngGroupComponent]
        }], searchInput: [{
            type: ViewChild,
            args: ['searchInput']
        }], virtualScroll: [{
            type: ViewChild,
            args: [CdkVirtualScrollViewport]
        }], label: [{
            type: ContentChild,
            args: [CngLabelComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLabelModule, [{
        type: NgModule,
        args: [{
                declarations: [CngLabelComponent],
                exports: [CngLabelComponent],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngLabelModule, { declarations: function () { return [CngLabelComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngLabelComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSelectAllComponent, [{
        type: Component,
        args: [{
                selector: 'cng-select-all',
                template: '<div #wrapper><ng-content></ng-content></div>',
                providers: [
                    {
                        provide: CngOptionComponent,
                        useExisting: forwardRef(() => CngSelectAllComponent_1)
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: CngSelectComponent }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngSelectComponent,
                    CngOptionComponent,
                    CngGroupComponent,
                    CngSelectAllComponent,
                ],
                exports: [
                    CngSelectComponent,
                    CngOptionComponent,
                    CngGroupComponent,
                    CngLabelComponent,
                    CngSelectAllComponent,
                ],
                imports: [
                    CommonModule,
                    CngClickedOutsideModule,
                    CngLabelModule,
                    ReactiveFormsModule,
                    ScrollingModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngSelectModule, { declarations: function () { return [CngSelectComponent, CngOptionComponent, CngGroupComponent, CngSelectAllComponent]; }, imports: function () { return [CommonModule, CngClickedOutsideModule, CngLabelModule, ReactiveFormsModule,
        ScrollingModule]; }, exports: function () { return [CngSelectComponent, CngOptionComponent, CngGroupComponent, CngLabelComponent, CngSelectAllComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngPagerComponent, [{
        type: Component,
        args: [{
                selector: 'cng-pager',
                template: "<div>\n\t<div class=\"flex flex-middle\">\n\t\t<div *ngIf=\"showPageDetails\" class=\"base-margin-right\">\n\t\t\t<span class=\"text-muted\"\n        data-auto-id=\"CNGPager-PageDetails\"\n        i18n>\n        {{pageLimit}}-{{max}} of {{totalItems}}\n      </span>\n\t\t</div>\n    <div>\n  \t\t<ul\n  \t\t\tclass=\"pagination\"\n  \t\t\t[ngClass]=\"{\n  \t\t\t\t'pagination--large': size === 'large',\n  \t\t\t\t'pagination--small': size === 'small',\n  \t\t\t\t'pagination--rounded': rounded\n  \t\t\t}\"\n        style=\"margin: 0;\">\n  \t\t\t<li *ngIf=\"useIcons\">\n  \t\t\t\t<a\n  \t\t\t\thref=\"javascript:;\"\n  \t\t\t\t[ngClass]=\"{'disabled': page === 0}\"\n\t\t\t\t\t[attr.tabindex]=\"page === 0 ? '-1' : '0'\"\n  \t\t\t\t(click)=\"onClick(0, page === 0)\"\n  \t\t\t\tdata-auto-id=\"CNGPager-FirstPage\">\n  \t\t\t\t\t<span class=\"icon-chevron-left-double\"></span>\n  \t\t\t\t</a>\n  \t\t\t</li>\n  \t\t\t<li>\n  \t\t\t\t<a\n  \t\t\t\t\thref=\"javascript:;\"\n  \t\t\t\t\t[ngClass]=\"{'disabled': page === 0}\"\n  \t\t\t\t\t(click)=\"onClick(page - 1, page === 0)\"\n\t\t\t\t\t\t[attr.tabindex]=\"page === 0 ? '-1' : '0'\"\n  \t\t\t\t\tdata-auto-id=\"CNGPager-PrevPage\">\n  \t\t\t\t\t\t<ng-container [ngSwitch]=\"useIcons\">\n  \t\t\t\t\t\t\t<span *ngSwitchCase=\"true\" class=\"icon-chevron-left\"></span>\n  \t\t\t\t\t\t\t<span *ngSwitchDefault i18n=\"cng-pager 'Prev' button\">Prev</span>\n  \t\t\t\t\t\t</ng-container>\n  \t\t\t\t</a>\n  \t\t\t</li>\n  \t\t\t<li\n  \t\t\t\t*ngFor=\"let p of pages; let i = index;\"\n  \t\t\t\t[ngClass]=\"{'active': p === page}\">\n  \t\t\t\t<ng-container [ngSwitch]=\"p\">\n  \t\t\t\t\t<span\n  \t\t\t\t\t\t*ngSwitchCase=\"'ellipses'\"\n  \t\t\t\t\t\tclass=\"icon-more\"></span>\n  \t\t\t\t\t<a\n  \t\t\t\t\t\t*ngSwitchDefault\n  \t\t\t\t\t\tclass=\"cng-pager-page\"\n  \t\t\t\t\t\thref=\"javascript:;\"\n  \t\t\t\t\t\t(click)=\"onClick(p)\"\n  \t\t\t\t\t\tattr.data-auto-id=\"CNGPager-Page{{p + 1 }}\">\n  \t\t\t\t\t\t\t<span [innerText]=\"p + 1\"></span>\n  \t\t\t\t\t</a>\n  \t\t\t\t</ng-container>\n  \t\t\t</li>\n  \t\t\t<li>\n  \t\t\t\t<a\n  \t\t\t\t\thref=\"javascript:;\"\n\t\t\t\t\t\t[attr.tabindex]=\"page === lastPage ? '-1' : '0'\"\n  \t\t\t\t\t[ngClass]=\"{'disabled': page === lastPage}\"\n  \t\t\t\t\t(click)=\"onClick(page + 1, page === lastPage)\"\n  \t\t\t\t\tdata-auto-id=\"CNGPager-NextPage\">\n  \t\t\t\t\t\t<ng-container [ngSwitch]=\"useIcons\">\n  \t\t\t\t\t\t\t<span *ngSwitchCase=\"true\" class=\"icon-chevron-right\"></span>\n  \t\t\t\t\t\t\t<span *ngSwitchDefault i18n=\"cng-pager 'Next' button\">Next</span>\n  \t\t\t\t\t\t</ng-container>\n  \t\t\t\t</a>\n  \t\t\t</li>\n  \t\t\t<li *ngIf=\"useIcons\">\n  \t\t\t\t<a\n  \t\t\t\thref=\"javascript:;\"\n\t\t\t\t\t[attr.tabindex]=\"page === lastPage ? '-1' : '0'\"\n  \t\t\t\t[ngClass]=\"{'disabled': page === lastPage}\"\n  \t\t\t\t(click)=\"onClick(lastPage, page === lastPage)\"\n  \t\t\t\tdata-auto-id=\"CNGPager-LastPage\">\n  \t\t\t\t\t<span class=\"icon-chevron-right-double\"></span>\n  \t\t\t\t</a>\n  \t\t\t</li>\n  \t\t</ul>\n    </div>\n\t\t<span *ngIf=\"changeLimit\" class=\"half-margin-left\" i18n=\"cng-pager limit select\">Showing</span>\n\t\t<cng-select\n\t\t\t*ngIf=\"changeLimit\"\n\t\t\tclass=\"qtr-margin-left limit-select\"\n\t\t\t[ngModel]=\"limit\"\n\t\t\t(ngModelChange)=\"onLimitChange($event)\">\n\t\t\t<cng-option *ngFor=\"let item of limits\"\n\t\t\t\t[value]=\"item.value\">\n\t\t\t\t{{ item.name }}\n\t\t\t</cng-option>\n\t\t</cng-select>\n\t</div>\n</div>\n"
            }]
    }], function () { return []; }, { page: [{
            type: Input
        }], limit: [{
            type: Input
        }], changeLimit: [{
            type: Input
        }], availableLimits: [{
            type: Input
        }], displayedPages: [{
            type: Input
        }], showPageDetails: [{
            type: Input
        }], useIcons: [{
            type: Input
        }], rounded: [{
            type: Input
        }], size: [{
            type: Input
        }], onPageChanged: [{
            type: Output
        }], onInit: [{
            type: Output
        }], totalItems: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngPagerModule, [{
        type: NgModule,
        args: [{
                declarations: [CngPagerComponent],
                exports: [CngPagerComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    CngSelectModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngPagerModule, { declarations: function () { return [CngPagerComponent]; }, imports: function () { return [CommonModule,
        FormsModule, CngSelectModule]; }, exports: function () { return [CngPagerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLoaderComponent, [{
        type: Component,
        args: [{ selector: 'cng-loader', template: "<div class=\"modal\" *ngIf=\"fullscreen\">\n  <div class=\"absolute max-width max-height\">\n    <div class=\"absolute-center\">\n      <ng-container *ngTemplateOutlet=\"loader\"></ng-container>\n    </div>\n  </div>\n</div>\n\n<ng-container *ngIf=\"!fullscreen\">\n  <ng-container *ngTemplateOutlet=\"loader\"></ng-container>\n</ng-container>\n\n<ng-template #loader>\n  <div class=\"text-center\" *ngIf=\"!dots\">\n    <div *ngIf=\"label\">\n      <ng-container *ngTemplateOutlet=\"label.content\"></ng-container>\n    </div>\n    <div class=\"qtr-margin-top loader loader--{{ size }}\" i18n-aria-label aria-label=\"Loading, please wait...\">\n      <div class=\"wrapper flex flex-center\">\n          <div class=\"wheel\"></div>\n      </div>\n    </div>\n  </div>\n  <div class=\"text-center\" *ngIf=\"dots\">\n    <div *ngIf=\"label\">\n      <ng-container *ngTemplateOutlet=\"label.content\"></ng-container>\n    </div>\n    <div class=\"qtr-margin-top loading-dots loading-dots--{{ color }}\" i18n-aria-label aria-label=\"Loading, please wait...\">\n      <span></span>\n      <span></span>\n      <span></span>\n    </div>\n  </div>\n</ng-template>\n" }]
    }], function () { return []; }, { size: [{
            type: Input
        }], color: [{
            type: Input
        }], dots: [{
            type: Input
        }], fullscreen: [{
            type: Input
        }], label: [{
            type: ContentChild,
            args: [CngLabelComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngLoaderModule, [{
        type: NgModule,
        args: [{
                declarations: [CngLoaderComponent],
                exports: [
                    CngLoaderComponent,
                    CngLabelComponent,
                ],
                imports: [
                    CommonModule,
                    CngLabelModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngLoaderModule, { declarations: function () { return [CngLoaderComponent]; }, imports: function () { return [CommonModule, CngLabelModule]; }, exports: function () { return [CngLoaderComponent, CngLabelComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngProgressbarComponent, [{
        type: Component,
        args: [{ selector: 'cng-progressbar', template: "<div class=\"progressbar progressbar--{{ size }} progressbar--{{ color }}\"\n  [attr.data-percentage]=\"value * 100 | number:'1.0-0'\">\n  <div class=\"progressbar__fill\"></div>\n  <div class=\"progressbar__label\" *ngIf=\"label\" i18n=\"cng-progressbar loading label\">\n    <ng-container *ngIf=\"!customLabel\">\n      {{ (value | percent:'1.0-0') }} Complete\n    </ng-container>\n    <ng-container *ngIf=\"customLabel\">\n      <ng-container *ngTemplateOutlet=\"customLabel.content\"></ng-container>\n    </ng-container>\n  </div>\n</div>\n" }]
    }], function () { return []; }, { size: [{
            type: Input
        }], color: [{
            type: Input
        }], value: [{
            type: Input
        }], label: [{
            type: Input
        }], customLabel: [{
            type: ContentChild,
            args: [CngLabelComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngProgressbarModule, [{
        type: NgModule,
        args: [{
                declarations: [CngProgressbarComponent],
                exports: [
                    CngProgressbarComponent,
                    CngLabelComponent,
                ],
                imports: [
                    CommonModule,
                    CngLabelModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngProgressbarModule, { declarations: function () { return [CngProgressbarComponent]; }, imports: function () { return [CommonModule, CngLabelModule]; }, exports: function () { return [CngProgressbarComponent, CngLabelComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngRatingComponent, [{
        type: Component,
        args: [{ selector: 'cng-rating', template: "<div class=\"rating\" [ngClass]=\"{'rating--alt': color === 'alt', 'rating--small': size === 'small', 'rating--large': size === 'large'}\">\n    <div class=\"rating__stars\" [ngClass]=\"{ 'inactive': !clickable }\">\n        <ng-container *ngFor=\"let star of stars\">\n            <div [attr.data-auto-id]=\"'CNGRating-Star-' + star\"\n                class=\"rating__star\"\n                tabindex=\"0\"\n                [ngClass]=\"{'active': star | isActive:rating:showHalf:halfThreshold}\"\n                [title]=\"star | getTitle\"\n                (click)=\"onRatingChange(star)\"\n                (keydown)=\"onKeydown($event, star)\"\n            >\n                <span [ngClass]=\"{ 'icon-star-half': showHalf && star | isHalf:rating:halfThreshold, 'icon-star': (!showHalf || !(star | isHalf:rating:halfThreshold)) && starStyle === 'filled', 'icon-star-empty': starStyle === 'empty'}\"></span>\n            </div>\n        </ng-container>\n    </div>\n</div>\n", providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CngRatingComponent_1),
                        multi: true
                    },
                ], styles: [".inactive{pointer-events:none}"] }]
    }], function () { return []; }, { onRatingChanged: [{
            type: Output
        }], color: [{
            type: Input
        }], size: [{
            type: Input
        }], starStyle: [{
            type: Input
        }], clickable: [{
            type: Input
        }], totalStars: [{
            type: Input
        }], showHalf: [{
            type: Input
        }], halfThreshold: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GetStarTitlePipe, [{
        type: Pipe,
        args: [{
                name: 'getTitle'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IsHalfPipe, [{
        type: Pipe,
        args: [{
                name: 'isHalf'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IsActivePipe, [{
        type: Pipe,
        args: [{
                name: 'isActive'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngRatingModule, [{
        type: NgModule,
        args: [{
                declarations: [CngRatingComponent, GetStarTitlePipe, IsHalfPipe, IsActivePipe],
                exports: [CngRatingComponent],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngRatingModule, { declarations: function () { return [CngRatingComponent, GetStarTitlePipe, IsHalfPipe, IsActivePipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngRatingComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngToastIconComponent, [{
        type: Component,
        args: [{
                selector: 'cng-toast-icon',
                template: '<ng-template><ng-content></ng-content></ng-template>'
            }]
    }], null, { content: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngToastComponent, [{
        type: Component,
        args: [{ selector: 'cng-toast', template: "<div class=\"toast toast--{{ opts.padding }}\">\n  <ng-container *ngIf=\"showIcon\">\n    <ng-container *ngIf=\"customIcon; else defaultIconTmpl\">\n      <div class=\"toast__icon\">\n        <ng-container *ngTemplateOutlet=\"customIcon.content\"></ng-container>\n      </div>\n    </ng-container>\n  </ng-container>\n  <div class=\"toast__body\">\n    <div class=\"toast__title\">\n      <ng-content select=\"[toast-title]\"></ng-content>\n    </div>\n    <div class=\"toast__body\">\n      <ng-content select=\"[toast-body]\"></ng-content>\n    </div>\n  </div>\n  <a href=\"javascript:;\"\n    class=\"toast__close icon-close\"\n    *ngIf=\"showClose\"\n    (click)=\"onClose()\">\n  </a>\n</div>\n\n<ng-template #defaultIconTmpl>\n  <div class=\"toast__icon text-{{opts.severity}}\"\n    [ngClass]=\"{\n      'icon-error-outline': opts.severity === 'danger',\n      'icon-warning-outline': opts.severity === 'warning',\n      'icon-check-outline': opts.severity === 'success',\n      'icon-info-outline': opts.severity === 'info'\n    }\">\n  </div>\n</ng-template>\n", styles: [".toast__close{position:absolute;top:.25rem;right:.375rem}"] }]
    }], function () { return []; }, { opts: [{
            type: Input
        }], showClose: [{
            type: Input
        }], showIcon: [{
            type: Input
        }], close: [{
            type: Output
        }], customIcon: [{
            type: ContentChild,
            args: [CngToastIconComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngToastConfiguration, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngToasterWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'cng-toaster-wrapper',
                template: '<cng-toaster [position]="config.position" [maxToasts]="config.maxToasts"></cng-toaster>'
            }]
    }], function () { return [{ type: CngToastConfiguration }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: CngToastConfiguration }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngToasterComponent, [{
        type: Component,
        args: [{ animations: [
                    trigger('toastAnimation', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate('500ms', style({ opacity: 1 })),
                        ]),
                        transition(':leave', [
                            style({ opacity: 1 }),
                            animate('500ms', style({ opacity: 0 })),
                        ]),
                    ]),
                ], selector: 'cng-toaster', template: "<div class=\"cui-toasts {{position}}\">\n  <div *ngFor=\"let toast of toasts\" class=\"base-margin-top\" [@toastAnimation]>\n    <cng-toast [opts]=\"toast.options\"\n      (close)=\"onClose(toast)\"\n      role=\"alert\"\n      aria-live=\"polite\">\n      <span toast-title>\n        <cng-content [config]=\"toast.title\"></cng-content>\n      </span>\n      <span toast-body>\n        <cng-content [config]=\"toast.body\"></cng-content>\n      </span>\n    </cng-toast>\n  </div>\n</div>\n", styles: [".cui-toasts{position:fixed!important;right:var(--cui-spacing);bottom:var(--cui-spacing);width:300px;z-index:2000}.cui-toasts.bottom{bottom:var(--cui-spacing)}.cui-toasts.top{top:var(--cui-spacing);bottom:unset}"] }]
    }], function () { return [{ type: CngToastService }]; }, { position: [{
            type: Input
        }], maxToasts: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngToastModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngToastComponent,
                    CngToasterComponent,
                    CngToastIconComponent,
                    CngToasterWrapperComponent,
                ],
                exports: [
                    CngToastComponent,
                    CngToasterComponent,
                    CngToastIconComponent,
                ],
                imports: [
                    CommonModule,
                    CngContentModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngToastModule, { declarations: function () { return [CngToastComponent, CngToasterComponent, CngToastIconComponent, CngToasterWrapperComponent]; }, imports: function () { return [CommonModule, CngContentModule]; }, exports: function () { return [CngToastComponent, CngToasterComponent, CngToastIconComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDropdownItemComponent, [{
        type: Component,
        args: [{ selector: 'cng-dropdown-item', template: "<ng-template><ng-content></ng-content></ng-template>\n" }]
    }], function () { return []; }, { selected: [{
            type: Input
        }], click: [{
            type: Output
        }], overrideHeight: [{
            type: Input
        }], template: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDropdownGroupComponent, [{
        type: Component,
        args: [{ selector: 'cng-dropdown-group', template: "<ng-template><ng-content></ng-content></ng-template>\n" }]
    }], function () { return []; }, { items: [{
            type: ContentChildren,
            args: [CngDropdownItemComponent]
        }], header: [{
            type: Input
        }], template: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDropdownWrapperComponent, [{
        type: Component,
        args: [{ selector: 'cng-dropdown-wrapper', template: "<div\n\tclass=\"dropdown ignore\"\n\t[ngClass]=\"{\n\t\t'active': active,\n\t\t'dropdown--center': direction === 'center',\n\t\t'dropdown--left': direction === 'left'\n\t}\"\n>\n\t<ng-template #triggerContainer></ng-template>\n\t<div\n\t\tclass=\"dropdown__menu\"\n\t\t(cngClickedOutside)=\"onClickOutside($event)\"\n\t>\n\t\t<ng-container *ngTemplateOutlet=\"dropdownComp?.dropdownTmpl\"></ng-container>\n\t</div>\n</div>\n\n", styles: [":host .dropdown__menu{z-index:10000}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { direction: [{
            type: Input
        }], activeChange: [{
            type: Output
        }], trigger: [{
            type: Input
        }], dropdownComp: [{
            type: Input
        }], triggerVcr: [{
            type: ViewChild,
            args: ['triggerContainer', { read: ViewContainerRef }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDropdownTriggerForDirective, [{
        type: Directive,
        args: [{
                selector: '[cngDropdownTriggerFor]'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { cngDropdownTriggerForActiveSubject: [{
            type: Input
        }], cngDropdownTriggerForDirection: [{
            type: Input
        }], cngDropdownTriggerFor: [{
            type: Input,
            args: ['cngDropdownTriggerFor']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDropdownComponent, [{
        type: Component,
        args: [{ selector: 'cng-dropdown', template: "<ng-template #dropdown>\n\t<ng-container *ngFor=\"let item of items\">\n\t\t<a\n\t\t\t[ngClass]=\"{ 'selected': item.selected, 'focused': item.active }\"\n\t\t\t[ngStyle]=\"{ 'height.px': item.overrideHeight }\"\n\t\t\t(click)=\"onItemClick(item)\"\n\t\t>\n\t\t\t<ng-container *ngTemplateOutlet=\"item.template\"></ng-container>\n\t\t</a>\n\t</ng-container>\n\t<ng-container *ngFor=\"let group of groups; let i = index\">\n\t\t<div\n\t\t\t*ngIf=\"group.header\"\n\t\t\tclass=\"dropdown__group-header\"\n\t\t\t[innerText]=\"group.header\"\n\t\t></div>\n\t\t<ng-container *ngFor=\"let item of group.items\">\n\t\t\t<a\n\t\t\t\t[ngClass]=\"{ 'selected': item.selected, 'focused': item.active }\"\n\t\t\t\t[ngStyle]=\"{ 'height.px': item.overrideHeight }\"\n\t\t\t\t(click)=\"onItemClick(item)\"\n\t\t\t>\n\t\t\t\t<ng-container *ngTemplateOutlet=\"item.template\"></ng-container>\n\t\t\t</a>\n\t\t</ng-container>\n\t\t<div *ngIf=\"i < (groups?.length - 1)\" class=\"divider\"></div>\n\t</ng-container>\n</ng-template>\n", styles: ["a.focused{color:var(--cui-active-color)!important;background:var(--cui-background-hover)!important;text-decoration:none!important}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { itemSelected: [{
            type: Output
        }], escaped: [{
            type: Output
        }], viewInit: [{
            type: Output
        }], items: [{
            type: ContentChildren,
            args: [CngDropdownItemComponent]
        }], groups: [{
            type: ContentChildren,
            args: [CngDropdownGroupComponent]
        }], dropdownTmpl: [{
            type: ViewChild,
            args: ['dropdown']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngDropdownComponent,
                    CngDropdownGroupComponent,
                    CngDropdownItemComponent,
                    CngDropdownTriggerForDirective,
                    CngDropdownWrapperComponent,
                ],
                exports: [
                    CngDropdownComponent,
                    CngDropdownGroupComponent,
                    CngDropdownItemComponent,
                    CngDropdownTriggerForDirective,
                ],
                imports: [
                    CngClickedOutsideModule,
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngDropdownModule, { declarations: function () { return [CngDropdownComponent, CngDropdownGroupComponent, CngDropdownItemComponent, CngDropdownTriggerForDirective, CngDropdownWrapperComponent]; }, imports: function () { return [CngClickedOutsideModule, CommonModule]; }, exports: function () { return [CngDropdownComponent, CngDropdownGroupComponent, CngDropdownItemComponent, CngDropdownTriggerForDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngThemePickerDirective, [{
        type: Directive,
        args: [{
                selector: '[cngThemePicker]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { currentTheme: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngThemePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [CngThemePickerDirective],
                exports: [CngThemePickerDirective],
                imports: [
                    CngDropdownModule,
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngThemePickerModule, { declarations: function () { return [CngThemePickerDirective]; }, imports: function () { return [CngDropdownModule, CommonModule]; }, exports: function () { return [CngThemePickerDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngInputDirective, [{
        type: Directive,
        args: [{
                host: {
                    '(focus)': 'onFocus()',
                    '(input)': 'onInput()'
                },
                selector: '[cngInput]'
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { maxHeight: [{
            type: Input
        }], resizeClass: [{
            type: HostBinding,
            args: ['style.flex']
        }], onInput: [{
            type: HostListener,
            args: ['input']
        }], autoresize: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFormFieldComponent, [{
        type: Component,
        args: [{ host: {
                    class: 'form-group'
                }, selector: 'cng-form-field', template: "<div class=\"form-group__text\">\n\t<ng-content select=\"[cngInput]\"></ng-content>\n\t<ng-content select=\"label\"></ng-content>\n\t<button\n\t\t*ngIf=\"icon\"\n\t\ttype=\"button\"\n\t\tclass=\"link\"\n\t\ttabindex=\"-1\"\n\t>\n\t\t<span [class]=\"icon\"></span>\n\t</button>\n</div>\n<div class=\"form-group__help\">\n\t<ng-content select=\"[cngInputHint]\"></ng-content>\n</div>\n", styles: [":host{display:block}"] }]
    }], function () { return []; }, { hasIcon: [{
            type: HostBinding,
            args: ['class.input--icon']
        }], hasErrorClass: [{
            type: HostBinding,
            args: ['class.form-group--error']
        }], hasError: [{
            type: Input
        }], inline: [{
            type: Input
        }], _inline: [{
            type: HostBinding,
            args: ['class.form-group--inline']
        }], horizontal: [{
            type: Input
        }], _horizontal: [{
            type: HostBinding,
            args: ['class.form-group--horizontal']
        }], input: [{
            type: ContentChild,
            args: [CngInputDirective]
        }], icon: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFormFieldModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngFormFieldComponent,
                    CngInputDirective,
                ],
                exports: [
                    CngFormFieldComponent,
                    CngInputDirective,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngFormFieldModule, { declarations: function () { return [CngFormFieldComponent, CngInputDirective]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule]; }, exports: function () { return [CngFormFieldComponent, CngInputDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngGridItemComponent, [{
        type: Component,
        args: [{
                selector: 'cng-grid-item',
                template: '<ng-template><ng-content></ng-content></ng-template>'
            }]
    }], function () { return []; }, { card: [{
            type: Input
        }], classes: [{
            type: HostBinding,
            args: ['class']
        }], value: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: [TemplateRef]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngGridComponent, [{
        type: Component,
        args: [{ selector: 'cng-grid', template: "<div\n\tclass=\"grid grid--{{columns}}up\" [ngClass]=\"{'grid--selectable': selection}\"\n\t[ngStyle]=\"{ 'grid-template-rows': 'repeat(auto-fill, minmax(' + minHeight + 'px, 1fr))' }\"\n\t[cngShiftclick]=\"selection\"\n\t[selectEnabled]=\"selection\">\n\t<div *ngFor=\"let item of items\"\n\t\tclass=\"grid-item\"\n\t\t[ngStyle]=\"{ 'min-height.px': minHeight }\"\n\t\t[ngClass]=\"{\n\t\t\t'panel panel--bordered panel--raised panel--loose': item.card,\n\t\t\t'selected': isSelected(item.value)\n\t\t}\"\n\t\t[cngClickItem]=\"item.value\">\n    <ng-container *ngTemplateOutlet=\"item.content\"></ng-container>\n\t</div>\n\t<ng-container *ngIf=\"dataItems$\">\n\t\t<div *ngFor=\"let item of dataItems$ | async\"\n\t\t\tclass=\"grid-item\"\n\t\t\t[ngStyle]=\"{ 'min-height.px': minHeight }\"\n\t\t\t[ngClass]=\"{\n\t\t\t\t'panel panel--bordered panel--raised panel--loose': dataCards,\n\t\t\t\t'selected': isSelected(item)\n\t\t\t}\"\n\t\t\t[cngClickItem]=\"item\">\n\t\t\t<ng-container *ngTemplateOutlet=\"dataTemplate; context: item\"></ng-container>\n\t\t</div>\n\t</ng-container>\n</div>\n", styles: [".grid{grid-gap:var(--cui-spacing-qtr)}.grid-item.selected::before{background:var(--cui-theme-primary);opacity:.2;content:'';position:absolute;top:0;right:0;bottom:0;left:0;z-index:10}.panel.panel--bordered.grid-item.selected{border:1px solid var(--cui-link-color)}.grid.grid--selectable>:hover{border:1px solid var(--cui-link-color);cursor:pointer}"] }]
    }], function () { return []; }, { columns: [{
            type: Input
        }], minHeight: [{
            type: Input
        }], dataCards: [{
            type: Input
        }], dataSource: [{
            type: Input
        }], selection: [{
            type: Input
        }], dataTemplate: [{
            type: ContentChild,
            args: [TemplateRef, { static: true }]
        }], items: [{
            type: ContentChildren,
            args: [CngGridItemComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngClickItemDirective, [{
        type: Directive,
        args: [{
                selector: '[cngClickItem]'
            }]
    }], function () { return []; }, { preventDefault: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], 
    /** We preventDefault() on the mousedown event so when the user shift-clicks
     * on some DOM elements they don't select all of the text and crap in between
     * You can turn it off with [preventDefault]="false"
     * @param event the mousedown event
     *
     */
    onMousedown: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }], cngClickItem: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngShiftclickDirective, [{
        type: Directive,
        args: [{
                selector: '[cngShiftclick]'
            }]
    }], function () { return []; }, { selectEnabled: [{
            type: Input
        }], cngShiftclick: [{
            type: Input
        }], items: [{
            type: ContentChildren,
            args: [CngClickItemDirective, { descendants: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngShiftclickModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngShiftclickDirective,
                    CngClickItemDirective,
                ],
                exports: [
                    CngShiftclickDirective,
                    CngClickItemDirective,
                ],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngShiftclickModule, { declarations: function () { return [CngShiftclickDirective, CngClickItemDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngShiftclickDirective, CngClickItemDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngGridModule, [{
        type: NgModule,
        args: [{
                declarations: [CngGridComponent, CngGridItemComponent],
                exports: [CngGridComponent, CngGridItemComponent],
                imports: [
                    CommonModule,
                    CngShiftclickModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngGridModule, { declarations: function () { return [CngGridComponent, CngGridItemComponent]; }, imports: function () { return [CommonModule, CngShiftclickModule]; }, exports: function () { return [CngGridComponent, CngGridItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTableComponent, [{
        type: Component,
        args: [{ host: {
                    class: 'table'
                }, selector: 'cng-table, table[cng-table]', template: CDK_TABLE_TEMPLATE, providers: [{ provide: CdkTable, useExisting: CngTableComponent_1 }], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default }]
    }], null, { lined: [{
            type: Input
        }], _lined: [{
            type: HostBinding,
            args: ['class.table--lined']
        }], bordered: [{
            type: Input
        }], _bordered: [{
            type: HostBinding,
            args: ['class.table--bordered']
        }], striped: [{
            type: Input
        }], _striped: [{
            type: HostBinding,
            args: ['class.table--striped']
        }], selectable: [{
            type: Input
        }], _selectable: [{
            type: HostBinding,
            args: ['class.table--selectable']
        }], fixed: [{
            type: Input
        }], _fixed: [{
            type: HostBinding,
            args: ['class.table--fixed']
        }], wrapped: [{
            type: Input
        }], _wrapped: [{
            type: HostBinding,
            args: ['class.table--wrapped']
        }], compressed: [{
            type: Input
        }], _compressed: [{
            type: HostBinding,
            args: ['class.table--compressed']
        }], loose: [{
            type: Input
        }], _loose: [{
            type: HostBinding,
            args: ['class.table--loose']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngCellDef, [{
        type: Directive,
        args: [{
                selector: '[cngCellDef]',
                providers: [{ provide: CdkCellDef, useExisting: CngCellDef_1 }]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngHeaderCellDef, [{
        type: Directive,
        args: [{
                selector: '[cngHeaderCellDef]',
                providers: [{ provide: CdkHeaderCellDef, useExisting: CngHeaderCellDef_1 }]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFooterCellDef, [{
        type: Directive,
        args: [{
                selector: '[cngFooterCellDef]',
                providers: [{ provide: CdkFooterCellDef, useExisting: CngFooterCellDef_1 }]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngColumnDef, [{
        type: Directive,
        args: [{
                selector: '[cngColumnDef]',
                inputs: ['sticky'],
                providers: [
                    { provide: CdkColumnDef, useExisting: CngColumnDef_1 },
                    { provide: 'cng_SORT_HEADER_COLUMN_DEF', useExisting: CngColumnDef_1 },
                ]
            }]
    }], null, { name: [{
            type: Input,
            args: ['cngColumnDef']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngHeaderCell, [{
        type: Directive,
        args: [{
                selector: 'cng-header-cell, th[cng-header-cell]',
                host: {
                    class: 'cng-header-cell',
                    role: 'columnheader'
                }
            }]
    }], function () { return [{ type: ɵngcc6.CdkColumnDef }, { type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFooterCell, [{
        type: Directive,
        args: [{
                selector: 'cng-footer-cell, td[cng-footer-cell]',
                host: {
                    class: 'cng-footer-cell',
                    role: 'gridcell'
                }
            }]
    }], function () { return [{ type: ɵngcc6.CdkColumnDef }, { type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngCell, [{
        type: Directive,
        args: [{
                selector: 'cng-cell, td[cng-cell]',
                host: {
                    class: 'cng-cell',
                    role: 'gridcell'
                }
            }]
    }], function () { return [{ type: ɵngcc6.CdkColumnDef }, { type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTableColumn, [{
        type: Component,
        args: [{
                selector: 'cng-text-column',
                template: "<ng-container cngColumnDef>\n\t<th cng-header-cell *cngHeaderCellDef [style.text-align]=\"justify\">\n\t\t{{headerText}}\n\t</th>\n\t<td cng-cell *cngCellDef=\"let data\" [style.text-align]=\"justify\">\n\t\t{{dataAccessor(data, name)}}\n\t</td>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None,
                // Change detection is intentionally not set to OnPush. This component's template
                // will be provided to the table to be inserted into its view. This is problematic
                // when change detection runs since
                // the bindings in this template will be evaluated _after_ the table's view is evaluated,
                // which mean's the template in the table's view will not have the updated value (and in
                // fact will cause an ExpressionChangedAfterItHasBeenCheckedError).
                changeDetection: ChangeDetectionStrategy.Default
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngHeaderRowDef, [{
        type: Directive,
        args: [{
                selector: '[cngHeaderRowDef]',
                providers: [{ provide: CdkHeaderRowDef, useExisting: CngHeaderRowDef_1 }],
                inputs: ['columns: cngHeaderRowDef', 'sticky: cngHeaderRowDefSticky']
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFooterRowDef, [{
        type: Directive,
        args: [{
                selector: '[cngFooterRowDef]',
                providers: [{ provide: CdkFooterRowDef, useExisting: CngFooterRowDef_1 }],
                inputs: ['columns: cngFooterRowDef', 'sticky: cngFooterRowDefSticky']
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngRowDef, [{
        type: Directive,
        args: [{
                selector: '[cngRowDef]',
                providers: [{ provide: CdkRowDef, useExisting: CngRowDef_1 }],
                inputs: ['columns: cngRowDefColumns', 'when: cngRowDefWhen']
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngHeaderRow, [{
        type: Component,
        args: [{
                selector: 'cng-header-row, tr[cng-header-row]',
                template: CDK_ROW_TEMPLATE,
                host: {
                    class: 'cng-header-row',
                    role: 'row'
                },
                // See note on CdkTable for explanation on why this uses the default change detection strategy.
                // tslint:disable-next-line:validate-decorators
                changeDetection: ChangeDetectionStrategy.Default,
                encapsulation: ViewEncapsulation.None,
                exportAs: 'cngHeaderRow',
                providers: [{ provide: CdkHeaderRow, useExisting: CngHeaderRow_1 }]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFooterRow, [{
        type: Component,
        args: [{
                selector: 'cng-footer-row, tr[cng-footer-row]',
                template: CDK_ROW_TEMPLATE,
                host: {
                    class: 'cng-footer-row',
                    role: 'row'
                },
                // See note on CdkTable for explanation on why this uses the default change detection strategy.
                // tslint:disable-next-line:validate-decorators
                changeDetection: ChangeDetectionStrategy.Default,
                encapsulation: ViewEncapsulation.None,
                exportAs: 'cngFooterRow',
                providers: [{ provide: CdkFooterRow, useExisting: CngFooterRow_1 }]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngRow, [{
        type: Component,
        args: [{
                selector: 'cng-row, tr[cng-row]',
                template: CDK_ROW_TEMPLATE,
                host: {
                    class: 'cng-row',
                    role: 'row'
                },
                // See note on CdkTable for explanation on why this uses the default change detection strategy.
                // tslint:disable-next-line:validate-decorators
                changeDetection: ChangeDetectionStrategy.Default,
                encapsulation: ViewEncapsulation.None,
                exportAs: 'cngRow',
                providers: [{ provide: CdkRow, useExisting: CngRow_1 }]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSelectColumnComponent, [{
        type: Component,
        args: [{ selector: 'cng-select-column', template: "<ng-container cngColumnDef=\"select\">\n\t<th cng-header-cell *cngHeaderCellDef>\n\t\t<label class=\"checkbox\" *ngIf=\"isMultiple\">\n\t\t\t<input type=\"checkbox\"\n\t\t\t\t(change)=\"masterToggle()\"\n\t\t\t\t[checked]=\"isAllSelected()\"\n\t\t\t\t(keydown)=\"handleKeydown($event, 'header')\"\n\t\t\t/>\n\t\t\t<span class=\"checkbox__input\"></span>\n\t\t</label>\n\t</th>\n\t<td cng-cell *cngCellDef=\"let element; let i = index\">\n\t\t<label class=\"checkbox\"\n\t\t\t(click)=\"$event.preventDefault()\"\n\t\t\t(mousedown)=\"toggleOne(element, i, $event)\"\n\t\t    (keydown)=\"handleKeydown($event, 'row', element, i)\"\n\t\t>\n\t\t\t<input type=\"checkbox\"\n\t\t\t\t[checked]=\"selection.isSelected(element)\"\n\t\t\t/>\n\t\t\t<span class=\"checkbox__input\"></span>\n\t\t</label>\n\t</td>\n</ng-container>\n" }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: CngTableComponent, decorators: [{
                type: Optional
            }] }]; }, { selection: [{
            type: Input
        }], _columnDef: [{
            type: ViewChild,
            args: [CngColumnDef, { static: true }]
        }], _cell: [{
            type: ViewChild,
            args: [CngCellDef, { static: true }]
        }], _headerCell: [{
            type: ViewChild,
            args: [CngHeaderCellDef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTableModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngCell,
                    CngCellDef,
                    CngColumnDef,
                    CngFooterCell,
                    CngFooterCellDef,
                    CngFooterRow,
                    CngFooterRowDef,
                    CngHeaderCell,
                    CngHeaderCellDef,
                    CngHeaderRow,
                    CngHeaderRowDef,
                    CngRow,
                    CngRowDef,
                    CngSelectColumnComponent,
                    CngTableColumn,
                    CngTableComponent,
                ],
                exports: [
                    CngCell,
                    CngCellDef,
                    CngColumnDef,
                    CngFooterCell,
                    CngFooterCellDef,
                    CngFooterRow,
                    CngFooterRowDef,
                    CngHeaderCell,
                    CngHeaderCellDef,
                    CngHeaderRow,
                    CngHeaderRowDef,
                    CngRow,
                    CngRowDef,
                    CngSelectColumnComponent,
                    CngTableColumn,
                    CngTableComponent,
                ],
                imports: [
                    CdkTableModule,
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngTableModule, { declarations: function () { return [CngCell, CngCellDef, CngColumnDef, CngFooterCell, CngFooterCellDef, CngFooterRow, CngFooterRowDef, CngHeaderCell, CngHeaderCellDef, CngHeaderRow, CngHeaderRowDef, CngRow, CngRowDef, CngSelectColumnComponent, CngTableColumn, CngTableComponent]; }, imports: function () { return [CdkTableModule,
        CommonModule]; }, exports: function () { return [CngCell, CngCellDef, CngColumnDef, CngFooterCell, CngFooterCellDef, CngFooterRow, CngFooterRowDef, CngHeaderCell, CngHeaderCellDef, CngHeaderRow, CngHeaderRowDef, CngRow, CngRowDef, CngSelectColumnComponent, CngTableColumn, CngTableComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSortDirective, [{
        type: Directive,
        args: [{
                selector: '[cngSort]'
            }]
    }], function () { return []; }, { start: [{
            type: Input,
            args: ['cngSortStart']
        }], sortChange: [{
            type: Output,
            args: ['cngSortChange']
        }], direction: [{
            type: Input,
            args: ['cngSortDirection']
        }], active: [{
            type: Input,
            args: ['cngSortActive']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSortHeaderComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, host: {
                    class: 'sortable',
                    '(click)': 'handleClick()'
                }, selector: '[cng-sort-header]', template: "<ng-content></ng-content>\n<span *ngIf=\"showSortToggle\"\n\tclass=\"qtr-margin-left sort-indicator icon-dropdown\"\n\t[ngClass]=\"{ 'desc': rootSort?.direction === 'desc' }\"\n></span>\n", styles: [":host{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host .desc{transform:rotate(180deg);margin-bottom:3px}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: CngSortDirective, decorators: [{
                type: Optional
            }] }, { type: CngColumnDef, decorators: [{
                type: Optional
            }] }]; }, { id: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSortModule, [{
        type: NgModule,
        args: [{
                declarations: [CngSortDirective, CngSortHeaderComponent],
                exports: [CngSortDirective, CngSortHeaderComponent],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngSortModule, { declarations: function () { return [CngSortDirective, CngSortHeaderComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngSortDirective, CngSortHeaderComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFilterGroupComponent, [{
        type: Component,
        args: [{
                selector: 'cng-filter-group',
                template: "<ng-content></ng-content>\n"
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFilterItemDirective, [{
        type: Directive,
        args: [{
                selector: '[cngFilterItem]'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: CngFilterGroupComponent }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFilterItemComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'cng-filter-item',
                template: "<div class=\"form-group form-group--compressed\">\n\t<label class=\"checkbox\">\n\t\t<input\n\t\t\ttype=\"checkbox\"\n\t\t\t[formControl]=\"selectControl\"\n\t\t\t>\n\t\t\t<span class=\"checkbox__input\"></span>\n\t\t\t<span class=\"checkbox__label\">\n\t\t\t\t<ng-content></ng-content>\n\t\t\t</span>\n\t</label>\n</div>\n",
                // Since this IS a CngFilterItemDirective, we provide that as the token
                providers: [{
                        provide: CngFilterItemDirective,
                        useExisting: CngFilterItemComponent_1
                    }]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: CngFilterGroupComponent }]; }, { selected: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFilterComponent, [{
        type: Component,
        args: [{ host: {
                    style: 'display: block'
                }, selector: 'cng-filter', template: "<ng-content></ng-content>\n" }]
    }], function () { return []; }, { filterChange: [{
            type: Output
        }], filter: [{
            type: Input
        }], items: [{
            type: ContentChildren,
            args: [CngFilterItemDirective, { descendants: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFilterClearComponent, [{
        type: Component,
        args: [{ selector: 'cng-filter-clear', template: "<a (click)=\"clearGroup()\"><ng-content></ng-content></a>\n", providers: [{
                        provide: CngFilterItemDirective,
                        useExisting: CngFilterClearComponent_1
                    }] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: CngFilterGroupComponent }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngFilterModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngFilterComponent,
                    CngFilterGroupComponent,
                    CngFilterItemComponent,
                    CngFilterItemDirective,
                    CngFilterClearComponent,
                ],
                exports: [
                    CngFilterComponent,
                    CngFilterGroupComponent,
                    CngFilterItemComponent,
                    CngFilterItemDirective,
                    CngFilterClearComponent,
                ],
                imports: [
                    CngAccordionModule,
                    CommonModule,
                    ReactiveFormsModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngFilterModule, { declarations: function () { return [CngFilterComponent, CngFilterGroupComponent, CngFilterItemComponent, CngFilterItemDirective, CngFilterClearComponent]; }, imports: function () { return [CngAccordionModule, CommonModule,
        ReactiveFormsModule]; }, exports: function () { return [CngFilterComponent, CngFilterGroupComponent, CngFilterItemComponent, CngFilterItemDirective, CngFilterClearComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngBreadcrumbsComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cng-breadcrumbs', template: "<div>\n  <ul class=\"breadcrumb\">\n    <li *ngFor=\"let crumb of items\">\n      <span *ngIf=\"currentItem === crumb || crumb.url === null; else anchor\">\n        <cng-content class=\"content-inline\" [config]=\"crumb.content\"></cng-content>\n      </span>\n      <ng-template #anchor>\n        <a [routerLink]=\"crumb.url\">\n          <cng-content [config]=\"crumb.content\"></cng-content>\n        </a>\n      </ng-template>\n    </li>\n  </ul>\n</div>\n", styles: [":host ::ng-deep .content-inline>div{display:inline}"] }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc2.Router }]; }, { maxItems: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngBreadcrumbsModule, [{
        type: NgModule,
        args: [{
                declarations: [CngBreadcrumbsComponent],
                exports: [
                    CngBreadcrumbsComponent,
                ],
                imports: [
                    CommonModule,
                    RouterModule,
                    CngContentModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngBreadcrumbsModule, { declarations: function () { return [CngBreadcrumbsComponent]; }, imports: function () { return [CommonModule,
        RouterModule, CngContentModule]; }, exports: function () { return [CngBreadcrumbsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSearchDirective, [{
        type: Directive,
        args: [{
                selector: 'input [cngSearch]'
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { debounce: [{
            type: Input
        }], onSearch: [{
            type: Output
        }], useEnterKey: [{
            type: Input
        }], onInput: [{
            type: HostListener,
            args: ['input']
        }], onKeyup: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngSearchModule, [{
        type: NgModule,
        args: [{
                declarations: [CngSearchDirective],
                exports: [CngSearchDirective],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngSearchModule, { declarations: function () { return [CngSearchDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngSearchDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAutoGroupComponent, [{
        type: Component,
        args: [{ selector: 'cng-auto-group', template: `
	<div class="dropdown__group">
		<div class="dropdown__group-header">{{ label }}</div>
		<ng-content select="cng-auto-option, .divider"></ng-content>
	</div>
	` }]
    }], null, { label: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAutoOptionComponent, [{
        type: Component,
        args: [{ selector: 'cng-auto-option', template: '<a [ngClass]="{ hover: active }"><ng-content></ng-content></a>', host: {
                    '[attr.aria-selected]': 'getAriaSelected()',
                    '(click)': 'onClick()',
                    '(keydown)': 'onKeydown($event)'
                }, styles: ["a.hover{background-color:var(--cui-background-hover)!important}"] }]
    }], function () { return [{ type: CngAutoGroupComponent, decorators: [{
                type: Optional
            }] }]; }, { onSelectionChanged: [{
            type: Output
        }], value: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAutocompleteComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cng-autocomplete', template: "<ng-template>\n  <div class=\"dropdown active\" [ngClass]=\"{ hidden: hidden }\">\n    <div #panel role=\"listbox\" class=\"dropdown__menu\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</ng-template>\n", styles: [".dropdown{width:100%}.dropdown.active .dropdown__menu{max-height:175px}.hidden{display:none!important}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { displayWith: [{
            type: Input
        }], options: [{
            type: ContentChildren,
            args: [CngAutoOptionComponent, { descendants: true }]
        }], groups: [{
            type: ContentChildren,
            args: [CngAutoGroupComponent, { descendants: true }]
        }], template: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }], panel: [{
            type: ViewChild,
            args: ['panel']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAutocompleteTriggerDirective, [{
        type: Directive,
        args: [{
                selector: 'input[cngAutocomplete], textarea[cngAutocomplete]',
                host: {
                    // Accessibility bindings
                    '[attr.role]': 'cngAutocompleteDisabled ? null : "combobox"',
                    '[attr.aria-autocomplete]': 'cngAutocompleteDisabled ? null : "list"',
                    '[attr.aria-activedescendant]': '(panelOpen && _activeOption) ? _activeOption.id : null',
                    '[attr.aria-expanded]': 'cngAutocompleteDisabled ? null : panelOpen?.toString()',
                    '[attr.aria-owns]': '(cngAutocompleteDisabled || !panelOpen) ? null : cngAutocomplete?.id',
                    '[attr.aria-haspopup]': '!cngAutocompleteDisabled',
                    // Event listeners
                    '(focusin)': 'handleFocus()',
                    '(input)': 'handleInput($event)',
                    '(keydown)': 'handleKeydown($event)',
                    '(blur)': '_onTouched()'
                },
                providers: [CNG_AUTOCOMPLETE_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc7.Overlay }, { type: ɵngcc0.ViewContainerRef }]; }, { cngAutocompleteDisabled: [{
            type: Input
        }], cngAutocomplete: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngAutocompleteModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngAutocompleteComponent,
                    CngAutoOptionComponent,
                    CngAutocompleteTriggerDirective,
                    CngAutoGroupComponent,
                ],
                exports: [
                    CngAutocompleteComponent,
                    CngAutoOptionComponent,
                    CngAutoGroupComponent,
                    CngAutocompleteTriggerDirective,
                ],
                imports: [
                    CommonModule,
                    OverlayModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngAutocompleteModule, { declarations: function () { return [CngAutocompleteComponent, CngAutoOptionComponent, CngAutocompleteTriggerDirective, CngAutoGroupComponent]; }, imports: function () { return [CommonModule,
        OverlayModule]; }, exports: function () { return [CngAutocompleteComponent, CngAutoOptionComponent, CngAutoGroupComponent, CngAutocompleteTriggerDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTooltipComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cng-tooltip', template: "<ng-template>\n\t<div class=\"tooltip-container tooltip-{{ position }}\" [ngStyle]=\"{ 'max-height': maxHeight, 'max-width': maxWidth }\">\n\t\t<ng-content></ng-content>\n\t</div>\n</ng-template>\n", styles: [".tooltip-container{z-index:10000;background:var(--cui-color-gray-700);box-shadow:0 2px 5px 0 rgba(0,0,0,.3);padding:var(--cui-spacing-half);overflow:auto;border-radius:var(--cui-border-radius)}.tooltip-top.tooltip-container::after{content:\" \";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:var(--cui-color-gray-700) transparent transparent transparent}.tooltip-bottom.tooltip-container::after{content:\" \";position:absolute;top:-10px;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent var(--cui-color-gray-700) transparent}.tooltip-left.tooltip-container::after{content:\" \";position:absolute;top:50%;right:-10px;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent transparent var(--cui-color-gray-700)}.tooltip-right.tooltip-container::after{content:\" \";position:absolute;top:50%;left:-5px;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent var(--cui-color-gray-700) transparent transparent}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { maxHeight: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], template: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTooltipTriggerDirective, [{
        type: Directive,
        args: [{
                selector: '[cngTooltip]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc7.Overlay }, { type: ɵngcc0.ViewContainerRef }]; }, { cngTooltipDelay: [{
            type: Input
        }], cngTooltipRemovalDelay: [{
            type: Input
        }], cngTooltipPosition: [{
            type: Input
        }], cngTooltipDisabled: [{
            type: Input
        }], onMouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }], 
    // For keyboard focusing
    onFocus: [{
            type: HostListener,
            args: ['focus']
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], cngTooltip: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngTooltipModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngTooltipComponent,
                    CngTooltipTriggerDirective,
                ],
                exports: [
                    CngTooltipComponent,
                    CngTooltipTriggerDirective,
                ],
                imports: [
                    CommonModule,
                    OverlayModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngTooltipModule, { declarations: function () { return [CngTooltipComponent, CngTooltipTriggerDirective]; }, imports: function () { return [CommonModule,
        OverlayModule]; }, exports: function () { return [CngTooltipComponent, CngTooltipTriggerDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDropzoneComponent, [{
        type: Component,
        args: [{ selector: 'cng-dropzone', template: "<div>\n\t<input #fileInput\n\t\ttype=\"file\"\n\t\tclass=\"noDisplay\"\n\t\t(change)=\"onChange($event)\"\n\t\taccept=\"{{ allowExtensions ? allowExtensions.join(',') : '' }}\"\n\t\t[multiple]=\"multi\"\n\t\t[disabled]=\"disabled\" />\n\n\t<div class=\"file-drop panel text-center\"\n\t\t[ngClass]=\"{ 'disabled': disabled }\"\n\t\t(dragenter)=\"onDragEnter($event)\"\n\t\t(dragover)=\"onDragOver($event)\"\n\t\t(click)=\"openFileDialog($event)\"\n\t\t(keydown)=\"onKeydown($event)\"\n\t\t(drop)=\"onDrop($event)\"\n\t\ttabindex=\"0\">\n\t\t<div class=\"overlay\"></div>\n\n\t\t<ng-container *ngIf=\"files.length; then filesSelected; else noFilesSelected\"></ng-container>\n\n\t\t<ng-template #filesSelected>\n\t\t\t<div class=\"file-drop__container container--fluid\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<ng-template [ngTemplateOutlet]=\"fileCards\" [ngTemplateOutletContext]=\"{ files: files }\"></ng-template>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div *ngIf=\"multi\"\n\t\t\t\tclass=\"file-drop__filecnt\">\n\t\t\t\t<div class=\"flex flex-center\">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<span i18n>Selected: {{ files.length }}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"base-margin-left\">\n\t\t\t\t\t\t<ng-content select=\"[total-text]\"></ng-content>\n\t\t\t\t\t\t<span i18n>Total: {{ totalSize | fileSize }}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</ng-template>\n\n\t\t<ng-template #noFilesSelected>\n\t\t\t<div class=\"half-margin-bottom half-margin-top\">\n\t\t\t\t<span class=\"file-drop__icon icon-upload icon--medium\"></span>\n\t\t\t</div>\n\t\t\t<h4>\n\t\t\t\t<ng-content select=\"[drop-text]\"></ng-content>\n\t\t\t</h4>\n\t\t</ng-template>\n\t</div>\n</div>\n\n<ng-template #fileCards let-files=\"files\">\n\t<div class=\"file-drop__card\"\n\t*ngFor=\"let file of files; let i = index\"\n\t[ngClass]=\"{\n\t\t'flex-fill': !multi,\n\t\t'col-lg-3 col-md-6 col-sm-6 half-margin-bottom': multi\n\t}\">\n\t\t<div class=\"panel panel--ltgray panel--skinny\" [title]=\"file.name\">\n\t\t\t<span *ngIf=\"multi\"\n\t\t\t\tclass=\"icon-close pull-right\"\n\t\t\t\t(click)=\"removeFile($event, file)\"\n\t\t\t\t(keydown)=\"removeFile($event, file)\"\n\t\t\t\ttabindex=\"0\">\n\t\t\t</span>\n\t\t\t<span class=\"file-icon\"\n\t\t\t\t[ngClass]=\"getIcon(file)\"\n\t\t\t\t[title]=\"getTitle(file)\">\n\t\t\t</span>\n\t\t\t<div class=\"text-ellipsis\" [innerHTML]=\"file.name\"></div>\n\t\t\t<small [innerHTML]=\"file.size | fileSize\"></small>\n\t\t</div>\n\t</div>\n</ng-template>\n", providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CngDropzoneComponent_1),
                        multi: true
                    },
                ], styles: [".noDisplay{display:none}.file-drop{border:1px dashed!important;cursor:pointer}.file-drop.disabled{cursor:default}.file-drop:hover>.overlay{width:100%;height:100%;position:absolute;left:0;top:0;background-color:#000;opacity:.025}"] }]
    }], function () { return []; }, { allowExtensions: [{
            type: Input
        }], multi: [{
            type: Input
        }], fileInput: [{
            type: ViewChild,
            args: ['fileInput']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDropzoneModule, [{
        type: NgModule,
        args: [{
                declarations: [CngDropzoneComponent],
                exports: [
                    CngDropzoneComponent,
                ],
                imports: [
                    CommonModule,
                    FileSizeModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngDropzoneModule, { declarations: function () { return [CngDropzoneComponent]; }, imports: function () { return [CommonModule,
        FileSizeModule]; }, exports: function () { return [CngDropzoneComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngStepLabel, [{
        type: Directive,
        args: [{
                selector: '[cngStepLabel]'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngStep, [{
        type: Component,
        args: [{
                selector: 'cng-step',
                template: '<ng-template><ng-content></ng-content></ng-template>',
                providers: [
                    { provide: CdkStep, useExisting: CngStep_1 },
                ],
                encapsulation: ViewEncapsulation.None,
                exportAs: 'cngStep',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: CngStepper, decorators: [{
                type: Inject,
                args: [forwardRef(() => CngStepper)]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [STEPPER_GLOBAL_OPTIONS]
            }] }]; }, { stepLabel: [{
            type: ContentChild,
            args: [CngStepLabel]
        }], stepAfter: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngStepper, [{
        type: Directive,
        args: [{
                selector: '[cngStepper]',
                providers: [
                    {
                        provide: CdkStepper,
                        useExisting: CngStepper_1
                    },
                ]
            }]
    }], null, { size: [{
            type: Input
        }], color: [{
            type: Input
        }], _steps: [{
            type: ContentChildren,
            args: [CngStep, { descendants: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngStepHeaderComponent, [{
        type: Component,
        args: [{ selector: 'cng-step-header', template: "<div>\n\t<div *ngIf=\"completed && !active\" class=\"step__icon\" (click)=\"onClick($event)\">\n\t\t<ng-container *ngIf=\"showNumber\"><span class=\"icon-check\"></span></ng-container>\n\t</div>\n\t<div *ngIf=\"!(completed && !active)\" class=\"step__icon\" (click)=\"onClick($event)\">\n\t\t<ng-container *ngIf=\"showNumber\">{{ index + 1 }}</ng-container>\n\t</div>\n\t<div class=\"step__label\">\n\t\t<ng-container *ngIf=\"templateLabel\">\n\t\t\t<ng-container *ngTemplateOutlet=\"templateLabel.template\"></ng-container>\n\t\t</ng-container>\n\t\t<ng-container *ngIf=\"stringLabel\">\n\t\t\t<span>{{ label }}</span>\n\t\t</ng-container>\n\t</div>\n</div>", host: {
                    class: 'step cng-step-header',
                    '[class.active]': 'active',
                    '[class.visited]': 'completed && !active',
                    role: 'tab'
                }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, styles: [".cng-step-header{outline:0;position:relative;box-sizing:content-box;-webkit-tap-highlight-color:transparent}.step__icon{cursor:pointer}"] }]
    }], function () { return [{ type: ɵngcc8.FocusMonitor }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { showNumber: [{
            type: Input
        }], headerClicked: [{
            type: Output
        }], state: [{
            type: Input
        }], label: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], index: [{
            type: Input
        }], selected: [{
            type: Input
        }], active: [{
            type: Input
        }], completed: [{
            type: Input
        }], optional: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngHorizontalStepper, [{
        type: Component,
        args: [{ selector: 'cng-horizontal-stepper', exportAs: 'cngHorizontalStepper', template: "<div class=\"steps steps--{{ color }} steps--{{ size }}\">\n\t<ng-container *ngFor=\"let step of steps; let i = index; let isLast = last\">\n\t  <cng-step-header class=\"cng-horizontal-stepper-header\"\n\t\t\t\t\t   (keydown)=\"_onKeydown($event)\"\n\t\t\t\t\t   [tabIndex]=\"_getFocusIndex() === i ? 0 : -1\"\n\t\t\t\t\t   [id]=\"_getStepLabelId(i)\"\n\t\t\t\t\t   [attr.aria-posinset]=\"i + 1\"\n\t\t\t\t\t   [attr.aria-setsize]=\"steps.length\"\n\t\t\t\t\t   [attr.aria-controls]=\"_getStepContentId(i)\"\n\t\t\t\t\t   [attr.aria-selected]=\"selectedIndex === i\"\n\t\t\t\t\t   [attr.aria-label]=\"step.ariaLabel || null\"\n\t\t\t\t\t   [attr.aria-labelledby]=\"(!step.ariaLabel && step.ariaLabelledby) ? step.ariaLabelledby : null\"\n\t\t\t\t\t   [index]=\"i\"\n\t\t\t\t\t   [state]=\"_getIndicatorType(i, step.state)\"\n\t\t\t\t\t   [label]=\"step.stepLabel || step.label\"\n\t\t\t\t\t   [selected]=\"selectedIndex === i\"\n\t\t\t\t\t   [active]=\"selectedIndex === i\"\n\t\t\t\t\t   [completed]=\"step.completed\"\n\t\t\t\t\t   [optional]=\"step.optional\"\n\t\t\t\t\t   [errorMessage]=\"step.errorMessage\"\n\t\t\t\t\t   [showNumber]=\"size !== 'dot'\"\n\t\t\t\t\t   (headerClicked)=\"step.select()\">\n\t  </cng-step-header>\n\t</ng-container>\n  </div>\n  \n  <div class=\"cng-horizontal-content-container\">\n\t<div *ngFor=\"let step of steps; let i = index\"\n\t\t [attr.tabindex]=\"selectedIndex === i ? 0 : null\"\n\t\t class=\"cng-horizontal-stepper-content\" role=\"tabpanel\"\n\t\t [id]=\"_getStepContentId(i)\"\n\t\t [attr.aria-labelledby]=\"_getStepLabelId(i)\"\n\t\t [attr.aria-expanded]=\"selectedIndex === i\">\n\t  <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n\t</div>\n  </div>", inputs: ['selectedIndex'], host: {
                    class: 'cng-stepper-horizontal',
                    'aria-orientation': 'horizontal',
                    role: 'tablist'
                }, providers: [
                    { provide: CngStepper, useExisting: CngHorizontalStepper_1 },
                    { provide: CdkStepper, useExisting: CngHorizontalStepper_1 },
                ], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, styles: [".cng-horizontal-stepper-content{outline:0;transition:opacity .5s}.cng-horizontal-stepper-content[aria-expanded=false]{height:0;opacity:0;overflow:hidden}"] }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngStepperNext, [{
        type: Directive,
        args: [{
                selector: 'button[cngStepperNext]',
                host: {
                    '[type]': 'type'
                },
                inputs: ['type']
            }]
    }], null, { stepAfter: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngStepperPrevious, [{
        type: Directive,
        args: [{
                selector: 'button[cngStepperPrevious]',
                host: {
                    '[type]': 'type'
                },
                inputs: ['type']
            }]
    }], null, { stepAfter: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngStepperModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CngStepper,
                    CngStep,
                    CngHorizontalStepper,
                    CngStepHeaderComponent,
                    CngStepLabel,
                    CngStepperNext,
                    CngStepperPrevious,
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    CngStepper,
                    CngStep,
                    CngStepHeaderComponent,
                    CngHorizontalStepper,
                    CngStepLabel,
                    CngStepperNext,
                    CngStepperPrevious,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngStepperModule, { declarations: function () { return [CngStepper, CngStep, CngHorizontalStepper, CngStepHeaderComponent, CngStepLabel, CngStepperNext, CngStepperPrevious]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CngStepper, CngStep, CngStepHeaderComponent, CngHorizontalStepper, CngStepLabel, CngStepperNext, CngStepperPrevious]; } }); })();

/*
 * Public API Surface of cisco-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CNG_BREADCRUMB_LABEL, CNG_DATA, CNG_TOOLTIP_POSITION, CngAccordionComponent, CngAccordionDrawerComponent, CngAccordionModule, CngAlertColor, CngAlertComponent, CngAlertModule, CngAlertOutletComponent, CngAlertOutletModule, CngAlertService, CngApiDatasource, CngApiDatasourceEventType, CngAutoGroupComponent, CngAutoOptionComponent, CngAutocompleteComponent, CngAutocompleteModule, CngAutocompleteTriggerDirective, CngBreadcrumbsComponent, CngBreadcrumbsModule, CngCell, CngCellDef, CngClickedOutsideDirective, CngClickedOutsideModule, CngColumnDef, CngContentComponent, CngContentConfigType, CngContentModule, CngDclComponent, CngDclHostDirective, CngDclModule, CngDropdownComponent, CngDropdownDirection, CngDropdownGroupComponent, CngDropdownItemComponent, CngDropdownModule, CngDropdownTriggerForDirective, CngDropdownWrapperComponent, CngDropzoneComponent, CngDropzoneModule, CngFilterClearComponent, CngFilterComponent, CngFilterGroupComponent, CngFilterItemComponent, CngFilterItemDirective, CngFilterModule, CngFooterCell, CngFooterCellDef, CngFooterComponent, CngFooterDefaultConfig, CngFooterModule, CngFooterRow, CngFooterRowDef, CngFormFieldComponent, CngFormFieldModule, CngGridComponent, CngGridItemComponent, CngGridModule, CngGroupComponent, CngHeaderCell, CngHeaderCellDef, CngHeaderComponent, CngHeaderModule, CngHeaderRow, CngHeaderRowDef, CngHorizontalStepper, CngInputDirective, CngLabelComponent, CngLabelModule, CngLayoutComponent, CngLayoutHeader, CngLayoutModule, CngLayoutSidebar, CngLoaderColor, CngLoaderComponent, CngLoaderModule, CngModalComponent, CngModalModule, CngModalService, CngModalSize, CngOptionComponent, CngOptionType, CngPagerComponent, CngPagerModule, CngProgressbarColor, CngProgressbarComponent, CngProgressbarModule, CngRatingComponent, CngRatingModule, CngRow, CngRowDef, CngSearchDirective, CngSearchModule, CngSelectAllComponent, CngSelectColumnComponent, CngSelectComponent, CngSelectModule, CngSidebarColor, CngSidebarComponent, CngSidebarItemType, CngSidebarModule, CngSortDirective, CngSortHeaderComponent, CngSortModule, CngStep, CngStepHeaderComponent, CngStepLabel, CngStepper, CngStepperColor, CngStepperModule, CngStepperNext, CngStepperPrevious, CngStepperSize, CngTabComponent, CngTabContentDirective, CngTabLabelDirective, CngTabLinkComponent, CngTabPostDirective, CngTabPreDirective, CngTableColumn, CngTableComponent, CngTableModule, CngTabsComponent, CngTabsModule, CngTabsNavComponent, CngThemePickerDirective, CngThemePickerModule, CngTitleDirective, CngToastComponent, CngToastConfiguration, CngToastConfigurationDefaults, CngToastIconComponent, CngToastModule, CngToastOptions, CngToastPadding, CngToastPosition, CngToastService, CngToastSeverity, CngToasterComponent, CngToasterWrapperComponent, CngTooltipComponent, CngTooltipModule, CngTooltipTriggerDirective, ThemeType, _getOptionScrollPosition, CngLayoutContentWidthPipe as ɵa, CngTabAnchorDirective as ɵb, GetStarTitlePipe as ɵc, IsHalfPipe as ɵd, IsActivePipe as ɵe, CngShiftclickModule as ɵf, CngShiftclickDirective as ɵg, CngClickItemDirective as ɵh };

